{
  "level": "ho02",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:ho02",
    "objects": "AREAS.E3:ho02.e3",
    "mesh": "TREES.E3:ho02.e3"
  },
  "spawn_point": {
    "position": [
      -129.29119614821215,
      1616.6726122157295,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -129.29119614821215,
      1716.6726122157295,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -6656.287109375,
      -2323.521484375,
      -300.0
    ],
    "bbox_max": [
      6145.4921875,
      7450.0,
      1843.7513427734375
    ],
    "vertex_count": 1235,
    "vertices": [
      [
        4547.47998046875,
        5909.91845703125,
        1135.4051513671875
      ],
      [
        3163.701416015625,
        6834.52880859375,
        610.11962890625
      ],
      [
        5764.48095703125,
        5096.74462890625,
        1469.6295166015625
      ],
      [
        4547.47998046875,
        5909.91845703125,
        1135.405029296875
      ],
      [
        5957.56005859375,
        4967.7333984375,
        1590.8251953125
      ],
      [
        5764.48095703125,
        5096.74462890625,
        1469.62939453125
      ],
      [
        6145.4921875,
        4991.36962890625,
        1843.7513427734375
      ],
      [
        6000.2373046875,
        4939.21728515625,
        1686.8751220703125
      ],
      [
        5957.56005859375,
        4967.7333984375,
        1590.8251953125
      ],
      [
        2637.3291015625,
        7186.23974609375,
        703.6844482421875
      ],
      [
        3017.69189453125,
        6932.08935546875,
        638.5988159179688
      ],
      [
        3017.69189453125,
        6932.08935546875,
        638.5988159179688
      ],
      [
        3163.701416015625,
        6834.52880859375,
        610.11962890625
      ],
      [
        6051.90966796875,
        4904.69091796875,
        1803.1688232421875
      ],
      [
        4117.16162109375,
        2301.5830078125,
        1016.0430908203125
      ],
      [
        4089.31982421875,
        3098.861083984375,
        938.4326782226562
      ],
      [
        4081.29052734375,
        4137.17724609375,
        -256.76629638671875
      ],
      [
        4120.587890625,
        4226.46826171875,
        -300.0
      ],
      [
        4081.29052734375,
        4137.17724609375,
        -256.76629638671875
      ],
      [
        4118.24951171875,
        2270.430419921875,
        1019.3637084960938
      ],
      [
        4117.16162109375,
        2301.583251953125,
        1016.0430908203125
      ],
      [
        4031.279296875,
        4760.92822265625,
        0.0
      ],
      [
        4024.458251953125,
        4956.259765625,
        44.4617919921875
      ],
      [
        4023.4130859375,
        4986.189453125,
        -69.49503326416016
      ],
      [
        4043.345947265625,
        4415.38427734375,
        -169.08460998535156
      ],
      [
        4031.279296875,
        4760.92822265625,
        0.0
      ],
      [
        4043.345947265625,
        4415.38427734375,
        -169.08460998535156
      ],
      [
        4024.458251953125,
        4956.259765625,
        44.461708068847656
      ],
      [
        4021.62939453125,
        5037.267578125,
        101.1990966796875
      ],
      [
        4021.62939453125,
        5037.267578125,
        101.1990737915039
      ],
      [
        3977.8642578125,
        6290.52294921875,
        919.177734375
      ],
      [
        4059.62060546875,
        3949.339111328125,
        65.54586791992188
      ],
      [
        4087.392822265625,
        3154.04345703125,
        933.06103515625
      ],
      [
        4059.008056640625,
        3966.878662109375,
        0.0
      ],
      [
        4059.62060546875,
        3949.339111328125,
        65.54586791992188
      ],
      [
        4087.392822265625,
        3154.043701171875,
        933.0609741210938
      ],
      [
        -3400.0,
        3834.140625,
        150.0
      ],
      [
        -3400.0,
        6377.31689453125,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        150.0
      ],
      [
        -6430.5634765625,
        3343.44873046875,
        -22.699951171875
      ],
      [
        -6430.5634765625,
        3343.44873046875,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        150.0
      ],
      [
        -3400.0,
        6409.3681640625,
        150.0
      ],
      [
        -3400.0,
        6409.3681640625,
        -22.699951171875
      ],
      [
        -6430.5634765625,
        3343.44873046875,
        976.300048828125
      ],
      [
        -6656.287109375,
        3323.70068359375,
        1359.083251953125
      ],
      [
        -5342.236328125,
        4972.2451171875,
        157.04067993164062
      ],
      [
        -6430.5634765625,
        3343.448974609375,
        1249.6044921875
      ],
      [
        -5332.01806640625,
        4987.5380859375,
        150.0
      ],
      [
        -5342.236328125,
        4972.2451171875,
        157.04066467285156
      ],
      [
        -3400.0,
        3834.140625,
        150.0
      ],
      [
        -3400.0,
        3608.589111328125,
        224.2318115234375
      ],
      [
        -5111.27001953125,
        3458.872314453125,
        609.7310791015625
      ],
      [
        -3400.0,
        6409.3681640625,
        976.300048828125
      ],
      [
        -5111.27001953125,
        3458.8720703125,
        609.7310791015625
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        3108.39404296875,
        6871.484375,
        547.1160278320312
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.83790969848633
      ],
      [
        228.268310546875,
        5028.201171875,
        -58.072784423828125
      ],
      [
        427.0267333984375,
        7267.0830078125,
        -58.072776794433594
      ],
      [
        427.0267333984375,
        7267.0830078125,
        -58.07276916503906
      ],
      [
        231.02944946289062,
        7173.888671875,
        -300.0
      ],
      [
        259.23272705078125,
        5158.08642578125,
        0.0
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        100.0,
        7430.10888671875,
        -22.699951171875
      ],
      [
        100.0,
        7430.10888671875,
        673.5613403320312
      ],
      [
        100.0,
        7265.8046875,
        0.0
      ],
      [
        100.0,
        7165.60498046875,
        -300.0
      ],
      [
        3966.75,
        4947.60009765625,
        -13.693603515625
      ],
      [
        3978.369140625,
        4957.15869140625,
        -10.697733879089355
      ],
      [
        3979.6884765625,
        4946.3798828125,
        -13.885726928710938
      ],
      [
        4025.732177734375,
        4919.77783203125,
        -81.08197021484375
      ],
      [
        4042.8125,
        4430.66259765625,
        -166.41896057128906
      ],
      [
        1489.9713134765625,
        7193.40869140625,
        643.8284912109375
      ],
      [
        3018.309814453125,
        6889.40283203125,
        624.2333374023438
      ],
      [
        3018.309814453125,
        6889.40283203125,
        624.2333374023438
      ],
      [
        3108.3935546875,
        6871.484375,
        620.907470703125
      ],
      [
        3979.6884765625,
        4946.3798828125,
        -13.885726928710938
      ],
      [
        4019.882080078125,
        4618.00146484375,
        -111.00995635986328
      ],
      [
        3986.6806640625,
        4979.27001953125,
        32.464378356933594
      ],
      [
        3170.046875,
        6830.2890625,
        612.5284423828125
      ],
      [
        4000.44775390625,
        4954.3212890625,
        24.79591178894043
      ],
      [
        3986.6806640625,
        4979.27001953125,
        32.464378356933594
      ],
      [
        4000.44775390625,
        4954.3212890625,
        24.79587745666504
      ],
      [
        3999.89697265625,
        4949.31298828125,
        23.076534271240234
      ],
      [
        3992.506103515625,
        4882.0908203125,
        0.0
      ],
      [
        4040.075439453125,
        4509.04052734375,
        -123.255859375
      ],
      [
        3992.506103515625,
        4882.0908203125,
        0.0
      ],
      [
        3956.206787109375,
        5048.34375,
        54.11029052734375
      ],
      [
        4020.44775390625,
        5071.1044921875,
        123.28400421142578
      ],
      [
        100.0,
        7430.10888671875,
        976.300048828125
      ],
      [
        3977.4443359375,
        5000.20556640625,
        39.024993896484375
      ],
      [
        3986.291015625,
        5059.00244140625,
        86.50453186035156
      ],
      [
        -619.7982788085938,
        3851.8251953125,
        150.0
      ],
      [
        -3070.4775390625,
        3637.418701171875,
        150.0
      ],
      [
        -2708.39404296875,
        6871.484375,
        150.0
      ],
      [
        100.0,
        7430.10888671875,
        150.0
      ],
      [
        -302.08367919921875,
        3879.621826171875,
        -300.0
      ],
      [
        -366.4575500488281,
        3873.98974609375,
        -113.45060729980469
      ],
      [
        -2708.39404296875,
        6871.484375,
        150.0
      ],
      [
        -3400.0,
        6409.3681640625,
        150.0
      ],
      [
        -475.55438232421875,
        3864.445068359375,
        0.0
      ],
      [
        -619.7982788085938,
        3851.8251953125,
        150.0
      ],
      [
        -475.5544128417969,
        3864.445068359375,
        0.0
      ],
      [
        -366.4575500488281,
        3873.98974609375,
        -113.45060729980469
      ],
      [
        -1165.5225830078125,
        7178.380859375,
        976.300048828125
      ],
      [
        -2525.29052734375,
        6907.90576171875,
        150.0
      ],
      [
        -3070.4775390625,
        3637.418701171875,
        150.0
      ],
      [
        3317.77783203125,
        3319.888916015625,
        100.00000762939453
      ],
      [
        3966.056884765625,
        3861.65869140625,
        100.0
      ],
      [
        3966.056884765625,
        3861.65869140625,
        100.0
      ],
      [
        4060.7236328125,
        3917.75341796875,
        100.0
      ],
      [
        4087.113037109375,
        3162.05224609375,
        924.3250122070312
      ],
      [
        2878.090087890625,
        3120.435546875,
        137.21926879882812
      ],
      [
        2889.345947265625,
        2798.10986328125,
        170.32931518554688
      ],
      [
        2814.28564453125,
        3107.142822265625,
        100.0
      ],
      [
        2804.21044921875,
        3033.157958984375,
        100.0
      ],
      [
        -3714.042724609375,
        -2323.521484375,
        1179.1292724609375
      ],
      [
        -5228.9921875,
        3448.57275390625,
        666.8276977539062
      ],
      [
        -4658.73828125,
        3498.463623046875,
        507.7889099121094
      ],
      [
        -3861.632568359375,
        2261.4169921875,
        -300.0
      ],
      [
        -3400.0,
        3608.589111328125,
        224.2318115234375
      ],
      [
        -3400.0,
        3505.9931640625,
        257.99737548828125
      ],
      [
        -3400.0,
        2940.080810546875,
        336.2261657714844
      ],
      [
        -3400.0,
        2786.4052734375,
        73.41243743896484
      ],
      [
        -3400.0,
        2627.53955078125,
        -300.0
      ],
      [
        -3400.0,
        2786.4052734375,
        73.41243743896484
      ],
      [
        -3400.0,
        2993.050048828125,
        426.8134765625
      ],
      [
        -3400.0,
        2993.050048828125,
        426.8134765625
      ],
      [
        -3400.0,
        2755.17236328125,
        0.0
      ],
      [
        -2650.0,
        3350.0,
        0.0
      ],
      [
        -2652.671142578125,
        3400.0,
        150.0
      ],
      [
        -2672.78515625,
        3400.0,
        150.0
      ],
      [
        -2183.333251953125,
        3400.0,
        0.0
      ],
      [
        -2652.67138671875,
        3400.0,
        150.0
      ],
      [
        -2672.78515625,
        3400.0,
        150.0
      ],
      [
        -3400.0,
        3400.0,
        292.881103515625
      ],
      [
        -2700.0,
        3381.37744140625,
        161.4759979248047
      ],
      [
        -2700.0,
        3372.810546875,
        146.8248748779297
      ],
      [
        -2700.0,
        3372.810546875,
        146.8248748779297
      ],
      [
        -2700.0,
        3310.3447265625,
        0.0
      ],
      [
        -2700.0,
        3381.37744140625,
        161.47598266601562
      ],
      [
        -2700.0,
        3400.0,
        155.3470916748047
      ],
      [
        1645.0,
        1469.9998779296875,
        500.0
      ],
      [
        1645.0,
        1469.9998779296875,
        1180.0
      ],
      [
        1645.0,
        1830.0,
        370.0
      ],
      [
        1645.0,
        1830.0,
        500.0
      ],
      [
        1645.0,
        1830.0,
        500.0
      ],
      [
        1645.0,
        1830.0,
        1180.0
      ],
      [
        1975.4892578125,
        1830.0,
        1060.0
      ],
      [
        1975.800048828125,
        1830.0,
        1059.6484375
      ],
      [
        1968.064697265625,
        1837.4246826171875,
        1060.0
      ],
      [
        1975.489501953125,
        1830.0,
        1060.0
      ],
      [
        1917.3709716796875,
        1888.11865234375,
        1060.0
      ],
      [
        1865.3895263671875,
        1940.0999755859375,
        1060.0
      ],
      [
        1968.064697265625,
        1837.4246826171875,
        1060.0
      ],
      [
        1917.3709716796875,
        1888.11865234375,
        1060.0
      ],
      [
        1913.6177978515625,
        1830.0,
        1130.0
      ],
      [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      [
        1892.56787109375,
        1851.050048828125,
        1130.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      [
        1913.2427978515625,
        1830.375,
        1130.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1892.9427490234375,
        1830.0,
        1106.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1880.41455078125,
        1830.0,
        1130.0
      ],
      [
        1704.19970703125,
        1830.0,
        1060.0
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1926.6507568359375,
        1772.5001220703125,
        1110.0
      ],
      [
        1921.2918701171875,
        1792.5001220703125,
        1110.0
      ],
      [
        -2700.0,
        3397.04736328125,
        156.31884765625
      ],
      [
        -320.5,
        1140.0,
        60.0
      ],
      [
        -329.5,
        1140.0,
        60.0
      ],
      [
        -327.8995056152344,
        1140.0,
        28.0
      ],
      [
        -314.3934020996094,
        1128.6065673828125,
        40.0
      ],
      [
        -314.3934020996094,
        1128.6065673828125,
        41.0
      ],
      [
        -310.0,
        1118.0,
        41.0
      ],
      [
        -310.0,
        1118.0,
        40.0
      ],
      [
        -310.0,
        1118.0,
        40.0
      ],
      [
        -310.0,
        1118.0,
        41.0
      ],
      [
        -314.3934020996094,
        1107.3934326171875,
        41.0
      ],
      [
        -314.3934020996094,
        1107.3934326171875,
        40.0
      ],
      [
        -317.63677978515625,
        1129.9500732421875,
        41.0
      ],
      [
        -318.44732666015625,
        1130.2857666015625,
        40.0
      ],
      [
        -325.0,
        1133.0,
        40.0
      ],
      [
        -325.0,
        1133.0,
        41.0
      ],
      [
        -318.44732666015625,
        1130.2857666015625,
        40.0
      ],
      [
        -317.63677978515625,
        1129.9500732421875,
        41.0
      ],
      [
        -314.3934020996094,
        1128.6065673828125,
        41.0
      ],
      [
        -314.3934020996094,
        1128.6065673828125,
        40.0
      ],
      [
        -327.8995056152344,
        1140.0,
        35.0
      ],
      [
        -329.5,
        1147.0,
        60.0
      ],
      [
        -320.5,
        1147.0,
        60.0
      ],
      [
        -329.5,
        1140.0,
        60.0
      ],
      [
        -329.5,
        1147.0,
        60.0
      ],
      [
        -320.5,
        1147.0,
        60.0
      ],
      [
        -320.5,
        1140.0,
        60.0
      ],
      [
        1050.0,
        1390.0,
        390.0852355957031
      ],
      [
        1010.0,
        1330.0,
        350.0852355957031
      ],
      [
        1010.0,
        1390.0,
        350.0852355957031
      ],
      [
        1549.9998779296875,
        1550.0,
        370.0
      ],
      [
        1549.9998779296875,
        1550.0,
        500.0
      ],
      [
        1549.9998779296875,
        1550.0,
        500.0
      ],
      [
        1549.9998779296875,
        1550.0,
        1180.0
      ],
      [
        1010.0,
        1520.0,
        350.0852355957031
      ],
      [
        1010.0,
        1540.0,
        350.0852355957031
      ],
      [
        1010.0,
        1520.0,
        350.0852355957031
      ],
      [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      [
        1030.0,
        1550.0,
        370.085205078125
      ],
      [
        1550.0,
        1910.0,
        370.0
      ],
      [
        1550.0,
        1910.0,
        500.0
      ],
      [
        1550.0,
        1910.0,
        500.0
      ],
      [
        1550.0,
        1910.0,
        1180.0
      ],
      [
        0.0,
        1490.0,
        60.0
      ],
      [
        0.0,
        1490.0,
        214.0
      ],
      [
        -592.6333618164062,
        1490.0,
        214.0
      ],
      [
        0.0,
        1490.0,
        214.0
      ],
      [
        0.0,
        1500.0,
        214.0
      ],
      [
        -595.0115356445312,
        1430.0,
        60.0
      ],
      [
        -595.0115356445312,
        1430.0,
        214.0
      ],
      [
        -595.0115356445312,
        1430.0,
        214.0
      ],
      [
        -608.4334106445312,
        1430.0,
        214.0
      ],
      [
        -50.843994140625,
        1250.0,
        60.0
      ],
      [
        -50.843994140625,
        1250.0,
        120.0
      ],
      [
        -50.0,
        1250.4873046875,
        120.0
      ],
      [
        -50.843994140625,
        1250.0,
        120.0
      ],
      [
        -339.5,
        1083.344482421875,
        75.0
      ],
      [
        -309.5,
        1100.6649169921875,
        75.0
      ],
      [
        -309.5,
        1100.6649169921875,
        120.0
      ],
      [
        -339.5,
        1083.344482421875,
        120.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        85.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        76.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        76.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        85.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        85.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        76.0
      ],
      [
        -313.5,
        1098.3555908203125,
        75.0
      ],
      [
        -313.5,
        1098.3555908203125,
        78.33777618408203
      ],
      [
        -314.5,
        1097.7783203125,
        78.04911804199219
      ],
      [
        -314.5,
        1097.7783203125,
        75.0
      ],
      [
        -313.5,
        1098.3555908203125,
        78.33777618408203
      ],
      [
        -314.5,
        1097.7783203125,
        78.04911804199219
      ],
      [
        -309.5,
        1100.646484375,
        78.0
      ],
      [
        -309.53204345703125,
        1100.646484375,
        78.0
      ],
      [
        -309.5,
        1100.6650390625,
        78.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        95.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        75.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        95.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        120.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        120.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        75.0
      ],
      [
        -214.8716278076172,
        1155.2987060546875,
        120.0
      ],
      [
        -136.8021240234375,
        1148.3199462890625,
        120.0
      ],
      [
        -159.20640563964844,
        1157.6002197265625,
        131.0
      ],
      [
        -214.8716278076172,
        1155.2987060546875,
        120.0
      ],
      [
        -197.52635192871094,
        1165.31298828125,
        131.0
      ],
      [
        -189.29701232910156,
        1170.064208984375,
        131.0
      ],
      [
        -197.52635192871094,
        1165.31298828125,
        131.0
      ],
      [
        -159.20643615722656,
        1157.6002197265625,
        131.0
      ],
      [
        -136.8021240234375,
        1148.3199462890625,
        95.0
      ],
      [
        -197.011962890625,
        1130.9688720703125,
        95.0
      ],
      [
        -154.3612060546875,
        1155.59326171875,
        95.0
      ],
      [
        -136.8021240234375,
        1148.3199462890625,
        95.0
      ],
      [
        -136.8021240234375,
        1148.3199462890625,
        120.0
      ],
      [
        -197.011962890625,
        1130.9688720703125,
        120.0
      ],
      [
        -197.011962890625,
        1130.9688720703125,
        95.0
      ],
      [
        -240.8894805908203,
        1140.2772216796875,
        78.0
      ],
      [
        -240.61631774902344,
        1139.8575439453125,
        78.0
      ],
      [
        -240.61631774902344,
        1139.8575439453125,
        75.0
      ],
      [
        -214.8716278076172,
        1155.2987060546875,
        95.0
      ],
      [
        -214.59840393066406,
        1154.8790283203125,
        95.0
      ],
      [
        -240.61631774902344,
        1139.8575439453125,
        95.0
      ],
      [
        -214.59840393066406,
        1154.87890625,
        95.0
      ],
      [
        -214.8716278076172,
        1155.2987060546875,
        95.0
      ],
      [
        -189.29701232910156,
        1170.064208984375,
        95.0
      ],
      [
        -188.71461486816406,
        1169.822998046875,
        95.0
      ],
      [
        -240.61631774902344,
        1139.8575439453125,
        95.0
      ],
      [
        -177.07107543945312,
        1165.0,
        95.0
      ],
      [
        -170.4713134765625,
        1180.9332275390625,
        95.0
      ],
      [
        -179.36158752441406,
        1175.8004150390625,
        131.0
      ],
      [
        -184.49166870117188,
        1172.8385009765625,
        131.0
      ],
      [
        -184.49166870117188,
        1172.8385009765625,
        131.0
      ],
      [
        -177.071044921875,
        1165.0,
        131.0
      ],
      [
        -170.47137451171875,
        1180.93310546875,
        131.0
      ],
      [
        -179.36158752441406,
        1175.8004150390625,
        131.0
      ],
      [
        -172.0710906982422,
        1162.928955078125,
        95.0
      ],
      [
        -175.00001525878906,
        1170.0,
        95.0
      ],
      [
        -136.8179473876953,
        1200.363037109375,
        95.0
      ],
      [
        -132.36288452148438,
        1193.5189208984375,
        95.0
      ],
      [
        -172.07106018066406,
        1177.0711669921875,
        95.0
      ],
      [
        -132.36288452148438,
        1193.5189208984375,
        95.0
      ],
      [
        -136.8179473876953,
        1200.363037109375,
        95.0
      ],
      [
        -136.8179473876953,
        1200.363037109375,
        120.0
      ],
      [
        -132.36288452148438,
        1193.5189208984375,
        120.0
      ],
      [
        -132.36288452148438,
        1193.5189208984375,
        120.0
      ],
      [
        -136.8179473876953,
        1200.363037109375,
        120.0
      ],
      [
        -154.16317749023438,
        1190.3486328125,
        131.0
      ],
      [
        -151.15890502929688,
        1185.7332763671875,
        131.0
      ],
      [
        -157.64349365234375,
        1183.04736328125,
        131.0
      ],
      [
        -157.3835906982422,
        1188.4893798828125,
        131.0
      ],
      [
        -161.8411102294922,
        1185.915771484375,
        131.0
      ],
      [
        -151.15890502929688,
        1185.7332763671875,
        131.0
      ],
      [
        -154.16317749023438,
        1190.3486328125,
        131.0
      ],
      [
        -157.3835906982422,
        1188.4893798828125,
        131.0
      ],
      [
        -157.64349365234375,
        1183.04736328125,
        131.0
      ],
      [
        -161.8411102294922,
        1185.915771484375,
        131.0
      ],
      [
        -124.75238037109375,
        1176.671142578125,
        95.0
      ],
      [
        -165.0000457763672,
        1160.0,
        95.0
      ],
      [
        -124.75238037109375,
        1176.671142578125,
        95.0
      ],
      [
        -124.75238037109375,
        1176.671142578125,
        120.0
      ],
      [
        -124.75238037109375,
        1176.671142578125,
        120.0
      ],
      [
        -138.9307403564453,
        1170.7982177734375,
        129.8446502685547
      ],
      [
        -141.64157104492188,
        1169.67529296875,
        131.0
      ],
      [
        -140.9049072265625,
        1169.98046875,
        131.0
      ],
      [
        -141.64157104492188,
        1169.67529296875,
        131.0
      ],
      [
        -140.9049072265625,
        1169.98046875,
        131.0
      ],
      [
        -138.9307403564453,
        1170.7982177734375,
        129.8446502685547
      ],
      [
        -156.62240600585938,
        1176.5299072265625,
        95.0
      ],
      [
        -140.85792541503906,
        1170.0,
        95.0
      ],
      [
        -165.00003051757812,
        1180.0001220703125,
        95.0
      ],
      [
        -140.9396514892578,
        1170.0338134765625,
        131.0
      ],
      [
        -140.8578643798828,
        1170.0,
        130.9724578857422
      ],
      [
        -140.9396514892578,
        1170.0338134765625,
        131.0
      ],
      [
        -156.62240600585938,
        1176.5299072265625,
        105.0
      ],
      [
        -156.6223907470703,
        1176.5299072265625,
        106.0
      ],
      [
        -157.00506591796875,
        1177.4537353515625,
        106.0
      ],
      [
        -156.6223907470703,
        1176.5299072265625,
        106.0
      ],
      [
        -156.62240600585938,
        1176.5299072265625,
        105.0
      ],
      [
        -152.92892456054688,
        1165.0,
        95.0
      ],
      [
        -157.92893981933594,
        1177.0711669921875,
        95.0
      ],
      [
        -152.92892456054688,
        1165.0,
        131.0
      ],
      [
        -154.61732482910156,
        1169.076171875,
        95.0
      ],
      [
        -154.61732482910156,
        1169.076171875,
        106.0
      ],
      [
        -154.61732482910156,
        1169.076171875,
        106.0
      ],
      [
        -157.92893981933594,
        1162.928955078125,
        95.0
      ],
      [
        -155.0,
        1170.0,
        95.0
      ],
      [
        -155.54119873046875,
        1168.693359375,
        131.0
      ],
      [
        -154.6173095703125,
        1169.076171875,
        131.0
      ],
      [
        -187.0,
        1171.390380859375,
        320.0
      ],
      [
        -134.50001525878906,
        1201.7012939453125,
        320.0
      ],
      [
        -161.91433715820312,
        1185.87353515625,
        270.0
      ],
      [
        -134.50001525878906,
        1201.701171875,
        270.0
      ],
      [
        -173.94740295410156,
        1178.92626953125,
        270.0
      ],
      [
        -154.45880126953125,
        1171.3065185546875,
        260.0
      ],
      [
        -156.62240600585938,
        1176.5299072265625,
        260.0
      ],
      [
        0.0,
        839.9456176757812,
        144.0
      ],
      [
        0.0,
        1000.0,
        82.0
      ],
      [
        -615.3160400390625,
        1210.361328125,
        60.0
      ],
      [
        -615.3160400390625,
        1210.361328125,
        214.0
      ],
      [
        -482.9289245605469,
        1162.928955078125,
        250.0
      ],
      [
        -490.0,
        1160.0,
        250.00001525878906
      ],
      [
        -339.4679260253906,
        1100.646484375,
        78.0
      ],
      [
        -334.49993896484375,
        1097.7781982421875,
        75.0
      ],
      [
        -335.49993896484375,
        1097.7781982421875,
        75.0
      ],
      [
        -340.46795654296875,
        1100.646484375,
        75.0
      ],
      [
        -409.6885070800781,
        1140.611083984375,
        75.0
      ],
      [
        -340.46795654296875,
        1100.646484375,
        75.0
      ],
      [
        -409.6874694824219,
        1140.6104736328125,
        60.0
      ],
      [
        -409.6875,
        1140.6104736328125,
        70.0
      ],
      [
        -336.5,
        1098.6800537109375,
        78.0
      ],
      [
        -336.5,
        1098.3555908203125,
        78.0
      ],
      [
        -336.5,
        1098.3555908203125,
        75.0
      ],
      [
        -336.5,
        1098.6800537109375,
        78.0
      ],
      [
        -336.5,
        1098.9329833984375,
        75.0
      ],
      [
        -336.5,
        1098.9329833984375,
        78.0
      ],
      [
        -335.5,
        1098.3555908203125,
        75.0
      ],
      [
        -335.5,
        1097.7781982421875,
        75.0
      ],
      [
        -335.5,
        1097.7781982421875,
        78.0
      ],
      [
        -335.5,
        1098.3555908203125,
        78.0
      ],
      [
        -409.4375,
        1141.04345703125,
        78.0
      ],
      [
        -409.6885070800781,
        1140.611083984375,
        75.0
      ],
      [
        -409.6885070800781,
        1140.611083984375,
        78.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        75.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        75.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        75.0
      ],
      [
        -424.5,
        1115.0986328125,
        78.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        75.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        78.0
      ],
      [
        -417.09478759765625,
        1136.816650390625,
        78.0
      ],
      [
        -424.6260986328125,
        1123.84423828125,
        78.0
      ],
      [
        -424.5,
        1115.0986328125,
        78.0
      ],
      [
        -420.7344055175781,
        1121.5848388671875,
        78.0
      ],
      [
        -413.2030944824219,
        1134.5572509765625,
        78.0
      ],
      [
        -424.6260986328125,
        1123.84423828125,
        78.0
      ],
      [
        -420.7344055175781,
        1121.5848388671875,
        78.0
      ],
      [
        -413.2030944824219,
        1134.5572509765625,
        78.0
      ],
      [
        -417.09478759765625,
        1136.816650390625,
        78.0
      ],
      [
        -336.5,
        1097.7781982421875,
        78.0
      ],
      [
        -336.5,
        1097.7781982421875,
        75.0
      ],
      [
        -435.4183654785156,
        1156.04345703125,
        120.0
      ],
      [
        -409.91668701171875,
        1141.320068359375,
        120.0
      ],
      [
        -417.6866149902344,
        1145.8060302734375,
        120.0
      ],
      [
        -334.49993896484375,
        1097.7781982421875,
        120.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        120.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        120.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        120.0
      ],
      [
        -445.0,
        1100.0,
        120.0
      ],
      [
        -500.0,
        1100.0,
        120.0
      ],
      [
        -500.0,
        1120.0,
        120.0
      ],
      [
        -490.0,
        1120.0,
        120.0
      ],
      [
        -490.0,
        1120.0,
        120.0
      ],
      [
        -445.0,
        1120.0,
        120.0
      ],
      [
        -520.1583862304688,
        1147.5079345703125,
        120.0
      ],
      [
        -496.91070556640625,
        1157.1373291015625,
        131.0
      ],
      [
        -432.1231384277344,
        1120.118896484375,
        131.28280639648438
      ],
      [
        -432.18994140625,
        1120.0,
        131.28785705566406
      ],
      [
        -431.9201965332031,
        1120.0,
        131.2823028564453
      ],
      [
        -432.18994140625,
        1120.0,
        131.28785705566406
      ],
      [
        -432.1231384277344,
        1120.118896484375,
        131.28280639648438
      ],
      [
        -432.18994140625,
        1120.0,
        131.20782470703125
      ],
      [
        -435.4183654785156,
        1156.04345703125,
        120.0
      ],
      [
        -452.7389221191406,
        1166.04345703125,
        131.0
      ],
      [
        -417.6866149902344,
        1145.8060302734375,
        130.1929473876953
      ],
      [
        -417.6866149902344,
        1145.8060302734375,
        120.0
      ],
      [
        -432.18994140625,
        1120.0,
        120.0
      ],
      [
        -430.4916076660156,
        1120.0,
        131.25291442871094
      ],
      [
        -410.8052062988281,
        1141.8331298828125,
        130.17398071289062
      ],
      [
        -417.6866149902344,
        1145.8060302734375,
        130.1929473876953
      ],
      [
        -421.99920654296875,
        1120.0,
        130.9424285888672
      ],
      [
        -409.91668701171875,
        1141.320068359375,
        130.14993286132812
      ],
      [
        -410.8052062988281,
        1141.8331298828125,
        130.17398071289062
      ],
      [
        -430.4916076660156,
        1120.0,
        131.25291442871094
      ],
      [
        -421.99920654296875,
        1120.0,
        120.0
      ],
      [
        -409.91668701171875,
        1141.320068359375,
        120.0
      ],
      [
        -409.91668701171875,
        1141.320068359375,
        130.14993286132812
      ],
      [
        -421.99920654296875,
        1120.0,
        130.9424285888672
      ],
      [
        -496.9107666015625,
        1157.137451171875,
        131.0
      ],
      [
        -452.7389221191406,
        1166.04345703125,
        131.0
      ],
      [
        -462.2093505859375,
        1171.51123046875,
        131.0
      ],
      [
        -500.0,
        1100.0,
        120.0
      ],
      [
        -500.0,
        1120.0,
        120.0
      ],
      [
        -435.4183654785156,
        1156.04345703125,
        95.0
      ],
      [
        -435.4183654785156,
        1156.04345703125,
        95.0
      ],
      [
        -520.1583862304688,
        1147.5079345703125,
        95.0
      ],
      [
        -462.20941162109375,
        1171.51123046875,
        95.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        95.0
      ],
      [
        -487.30767822265625,
        1110.0,
        95.0
      ],
      [
        -487.30767822265625,
        1100.0,
        95.0
      ],
      [
        -487.30767822265625,
        1110.0,
        95.0
      ],
      [
        -336.5,
        1097.7781982421875,
        78.049072265625
      ],
      [
        -336.5,
        1098.9329833984375,
        78.5
      ],
      [
        -336.0618896484375,
        1098.6800537109375,
        78.5
      ],
      [
        -335.5,
        1098.3555908203125,
        78.33779907226562
      ],
      [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      [
        -336.5,
        1097.7781982421875,
        78.049072265625
      ],
      [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      [
        -335.5,
        1098.3555908203125,
        78.33779907226562
      ],
      [
        -336.0618896484375,
        1098.6800537109375,
        78.5
      ],
      [
        -336.5,
        1098.9329833984375,
        78.5
      ],
      [
        -398.348388671875,
        1100.0,
        95.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        95.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        120.0
      ],
      [
        -398.348388671875,
        1100.0,
        120.0
      ],
      [
        -520.1583862304688,
        1147.5079345703125,
        105.0
      ],
      [
        -520.1583862304688,
        1147.5078125,
        95.0
      ],
      [
        -520.1583862304688,
        1147.5079345703125,
        120.0
      ],
      [
        -520.1583862304688,
        1147.5078125,
        105.0
      ],
      [
        -432.9425048828125,
        1120.0,
        105.0
      ],
      [
        -432.9425048828125,
        1120.0,
        106.0
      ],
      [
        -432.9425048828125,
        1120.0,
        120.0
      ],
      [
        -432.9425048828125,
        1120.0,
        105.0
      ],
      [
        -435.0,
        1120.0,
        105.0
      ],
      [
        -435.0,
        1120.0,
        95.0
      ],
      [
        -432.9366149902344,
        1120.0,
        105.0
      ],
      [
        -435.0,
        1120.0,
        105.0
      ],
      [
        -415.9012756347656,
        1139.3277587890625,
        95.0
      ],
      [
        -415.9012756347656,
        1139.3277587890625,
        120.0
      ],
      [
        -456.4000244140625,
        1110.0,
        107.48001098632812
      ],
      [
        -452.3076477050781,
        1110.0,
        108.0
      ],
      [
        -452.3076477050781,
        1100.0,
        108.0
      ],
      [
        -445.0,
        1110.0,
        110.71429443359375
      ],
      [
        -445.0,
        1110.0,
        111.71430969238281
      ],
      [
        -445.0,
        1100.0,
        111.71430969238281
      ],
      [
        -445.0,
        1100.0,
        110.71429443359375
      ],
      [
        -445.0,
        1110.0,
        107.0
      ],
      [
        -445.0,
        1100.0,
        107.0
      ],
      [
        -445.0,
        1105.0,
        105.0
      ],
      [
        -445.0,
        1105.0,
        107.0
      ],
      [
        -435.0,
        1110.0,
        105.0
      ],
      [
        -445.0,
        1110.0,
        105.0
      ],
      [
        -435.0,
        1110.0,
        105.0
      ],
      [
        -445.0,
        1110.0,
        105.0
      ],
      [
        -456.4000244140625,
        1120.0,
        107.48001098632812
      ],
      [
        -456.4000244140625,
        1110.0,
        107.48001098632812
      ],
      [
        -445.0,
        1120.0,
        107.0
      ],
      [
        -445.0,
        1120.0,
        108.0
      ],
      [
        -445.0,
        1110.0,
        108.0
      ],
      [
        -445.0,
        1110.0,
        107.0
      ],
      [
        -445.0,
        1120.0,
        111.71430969238281
      ],
      [
        -445.0,
        1115.0,
        105.0
      ],
      [
        -445.0,
        1115.0,
        107.0
      ],
      [
        -430.0,
        1118.2740478515625,
        95.0
      ],
      [
        -430.0,
        1118.2740478515625,
        105.0
      ],
      [
        -430.0,
        1118.2740478515625,
        105.0
      ],
      [
        -432.9894714355469,
        1120.0,
        105.0
      ],
      [
        -487.0833435058594,
        1110.0,
        119.0
      ],
      [
        -487.0833435058594,
        1100.0,
        119.0
      ],
      [
        -487.0833435058594,
        1110.0,
        119.0
      ],
      [
        -445.0,
        1110.0,
        120.0
      ],
      [
        -445.0,
        1100.0,
        119.0
      ],
      [
        -445.0,
        1110.0,
        119.0
      ],
      [
        -445.0,
        1110.0,
        111.71430969238281
      ],
      [
        -445.0,
        1120.0,
        119.0
      ],
      [
        -445.0,
        1110.0,
        119.0
      ],
      [
        -430.0,
        1118.291748046875,
        95.0
      ],
      [
        -430.0,
        1118.291748046875,
        105.0
      ],
      [
        -430.0,
        1118.291748046875,
        105.0
      ],
      [
        -480.0,
        1170.0,
        250.0
      ],
      [
        -482.9289245605469,
        1162.928955078125,
        250.00001525878906
      ],
      [
        -476.06134033203125,
        1179.5086669921875,
        95.0
      ],
      [
        -482.9288635253906,
        1162.928955078125,
        95.0
      ],
      [
        -468.59075927734375,
        1175.195556640625,
        131.0
      ],
      [
        -468.8244934082031,
        1175.33056640625,
        131.0
      ],
      [
        -477.35589599609375,
        1176.38330078125,
        131.0
      ],
      [
        -477.35589599609375,
        1176.38330078125,
        131.0
      ],
      [
        -468.8244934082031,
        1175.33056640625,
        131.0
      ],
      [
        -476.0613098144531,
        1179.5086669921875,
        131.0
      ],
      [
        -468.59075927734375,
        1175.195556640625,
        131.0
      ],
      [
        -482.9289245605469,
        1177.071044921875,
        250.0
      ],
      [
        -480.0,
        1170.0,
        250.00001525878906
      ],
      [
        -486.4145812988281,
        1185.486083984375,
        95.0
      ],
      [
        -479.9999694824219,
        1170.0,
        95.0
      ],
      [
        -486.41455078125,
        1185.486083984375,
        131.0
      ],
      [
        -490.0,
        1160.0,
        250.0
      ],
      [
        -497.0710754394531,
        1162.928955078125,
        250.00001525878906
      ],
      [
        -528.0411376953125,
        1175.7572021484375,
        95.0
      ],
      [
        -489.9999694824219,
        1160.0,
        95.0
      ],
      [
        -528.0411376953125,
        1175.7572021484375,
        95.0
      ],
      [
        -528.0411376953125,
        1175.7572021484375,
        120.0
      ],
      [
        -528.0411376953125,
        1175.7572021484375,
        120.0
      ],
      [
        -509.39813232421875,
        1168.0350341796875,
        131.0
      ],
      [
        -506.9605407714844,
        1167.0252685546875,
        131.0
      ],
      [
        -509.39813232421875,
        1168.0350341796875,
        131.0
      ],
      [
        -506.9605407714844,
        1167.0252685546875,
        131.0
      ],
      [
        -490.0,
        1180.0,
        250.0
      ],
      [
        -482.9289245605469,
        1177.071044921875,
        250.00001525878906
      ],
      [
        -518.680908203125,
        1191.8800048828125,
        95.0
      ],
      [
        -513.3609008789062,
        1201.0435791015625,
        95.0
      ],
      [
        -482.9289245605469,
        1177.071044921875,
        95.0
      ],
      [
        -513.3609008789062,
        1201.0435791015625,
        95.0
      ],
      [
        -518.680908203125,
        1191.8800048828125,
        95.0
      ],
      [
        -518.680908203125,
        1191.8800048828125,
        120.0
      ],
      [
        -513.3609008789062,
        1201.0435791015625,
        120.0
      ],
      [
        -513.3609008789062,
        1201.0435791015625,
        120.0
      ],
      [
        -518.680908203125,
        1191.8800048828125,
        120.0
      ],
      [
        -500.037841796875,
        1184.157958984375,
        131.0
      ],
      [
        -496.0403137207031,
        1191.0435791015625,
        131.0
      ],
      [
        -495.941162109375,
        1190.986328125,
        131.0
      ],
      [
        -496.61090087890625,
        1182.7384033203125,
        131.0
      ],
      [
        -495.7098388671875,
        1190.852783203125,
        131.0
      ],
      [
        -496.0403137207031,
        1191.0435791015625,
        131.0
      ],
      [
        -500.037841796875,
        1184.157958984375,
        131.0
      ],
      [
        -496.61090087890625,
        1182.7384033203125,
        131.0
      ],
      [
        -495.941162109375,
        1190.986328125,
        131.0
      ],
      [
        -495.7098388671875,
        1190.852783203125,
        131.0
      ],
      [
        -497.0710754394531,
        1177.071044921875,
        250.0
      ],
      [
        -490.0,
        1180.0,
        250.00001525878906
      ],
      [
        -498.377685546875,
        1176.52978515625,
        95.0
      ],
      [
        -490.0001525878906,
        1180.0,
        95.0
      ],
      [
        -514.1420288085938,
        1170.0,
        95.0
      ],
      [
        -514.1420288085938,
        1170.0,
        128.200927734375
      ],
      [
        -506.3941345214844,
        1173.2093505859375,
        131.0
      ],
      [
        -506.3941345214844,
        1173.2093505859375,
        131.0
      ],
      [
        -498.377685546875,
        1176.52978515625,
        105.0
      ],
      [
        -498.37762451171875,
        1176.5299072265625,
        106.0
      ],
      [
        -497.9949645996094,
        1177.4537353515625,
        106.0
      ],
      [
        -498.377685546875,
        1176.52978515625,
        105.0
      ],
      [
        -498.37762451171875,
        1176.5299072265625,
        106.0
      ],
      [
        -500.0,
        1170.0,
        250.0
      ],
      [
        -497.0710754394531,
        1177.071044921875,
        250.00001525878906
      ],
      [
        -502.071044921875,
        1165.0,
        95.0
      ],
      [
        -497.071044921875,
        1177.0711669921875,
        95.0
      ],
      [
        -502.0710754394531,
        1165.0,
        131.0
      ],
      [
        -500.3826599121094,
        1169.076171875,
        106.0
      ],
      [
        -500.3826599121094,
        1169.076171875,
        95.0
      ],
      [
        -500.3826599121094,
        1169.076171875,
        106.0
      ],
      [
        -497.0710754394531,
        1162.928955078125,
        250.0
      ],
      [
        -500.0,
        1170.0,
        250.00001525878906
      ],
      [
        -500.3826599121094,
        1169.076171875,
        95.0
      ],
      [
        -500.0,
        1170.0,
        95.0
      ],
      [
        -499.4588317871094,
        1168.6934814453125,
        95.0
      ],
      [
        -497.0710754394531,
        1162.928955078125,
        95.0
      ],
      [
        -514.4999389648438,
        1201.7012939453125,
        320.0
      ],
      [
        -461.9999694824219,
        1171.390380859375,
        320.0
      ],
      [
        -324.5,
        1092.0047607421875,
        120.0
      ],
      [
        -324.5,
        1092.0047607421875,
        75.0
      ],
      [
        -340.21795654296875,
        1101.0794677734375,
        250.0
      ],
      [
        -308.78204345703125,
        1101.0794677734375,
        250.00003051757812
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        120.0
      ],
      [
        -391.0191650390625,
        1130.4095458984375,
        120.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        120.0
      ],
      [
        -257.9808349609375,
        1130.4095458984375,
        120.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        118.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        118.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        118.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        118.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        110.0
      ],
      [
        -364.5608215332031,
        1130.4095458984375,
        110.0
      ],
      [
        -285.4391784667969,
        1130.4095458984375,
        110.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        110.0
      ],
      [
        -370.1299133300781,
        1130.4095458984375,
        110.0
      ],
      [
        -364.5608215332031,
        1130.4095458984375,
        110.0
      ],
      [
        -279.8700866699219,
        1130.4095458984375,
        110.0
      ],
      [
        -285.4391784667969,
        1130.4095458984375,
        110.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        110.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        118.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        110.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        118.0
      ],
      [
        -302.4201354980469,
        1130.4095458984375,
        95.0
      ],
      [
        -285.4391784667969,
        1130.4095458984375,
        95.0
      ],
      [
        -347.5798645019531,
        1130.4095458984375,
        95.0
      ],
      [
        -364.5608215332031,
        1130.4095458984375,
        95.0
      ],
      [
        -364.5608215332031,
        1130.4095458984375,
        95.0
      ],
      [
        -370.1299133300781,
        1130.4095458984375,
        95.0
      ],
      [
        -279.8700866699219,
        1130.4095458984375,
        95.0
      ],
      [
        -285.4391784667969,
        1130.4095458984375,
        95.0
      ],
      [
        -313.5,
        1125.5,
        60.99046325683594
      ],
      [
        -314.5,
        1125.5,
        60.99046325683594
      ],
      [
        -296.577392578125,
        1130.4095458984375,
        64.0
      ],
      [
        -293.315185546875,
        1130.4095458984375,
        64.0
      ],
      [
        -296.577392578125,
        1130.4095458984375,
        64.0
      ],
      [
        -296.577392578125,
        1130.4095458984375,
        60.0
      ],
      [
        -293.315185546875,
        1130.4095458984375,
        64.0
      ],
      [
        -293.315185546875,
        1130.4095458984375,
        60.0
      ],
      [
        -321.5,
        1125.5,
        60.99046325683594
      ],
      [
        -322.5,
        1125.5,
        60.99046325683594
      ],
      [
        -335.5,
        1125.5,
        60.99046325683594
      ],
      [
        -336.5,
        1125.5,
        60.99046325683594
      ],
      [
        -356.684814453125,
        1130.4095458984375,
        64.0
      ],
      [
        -353.422607421875,
        1130.4095458984375,
        64.0
      ],
      [
        -353.422607421875,
        1130.4095458984375,
        60.0
      ],
      [
        -353.422607421875,
        1130.4095458984375,
        64.0
      ],
      [
        -356.684814453125,
        1130.4095458984375,
        60.0
      ],
      [
        -356.684814453125,
        1130.4095458984375,
        64.0
      ],
      [
        -327.5,
        1125.5,
        60.99046325683594
      ],
      [
        -328.5,
        1125.5,
        60.99046325683594
      ],
      [
        -347.5798645019531,
        1130.4095458984375,
        100.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        100.0
      ],
      [
        -302.4201354980469,
        1130.4095458984375,
        100.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        100.0
      ],
      [
        -337.2240295410156,
        1130.4095458984375,
        100.0
      ],
      [
        -312.7759704589844,
        1130.4095458984375,
        100.0
      ],
      [
        -337.2240295410156,
        1130.4095458984375,
        100.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        100.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        100.0
      ],
      [
        -312.7759704589844,
        1130.4095458984375,
        100.0
      ],
      [
        -347.5798645019531,
        1130.4095458984375,
        100.0
      ],
      [
        -347.5798645019531,
        1130.4095458984375,
        95.0
      ],
      [
        -302.4201354980469,
        1130.4095458984375,
        100.0
      ],
      [
        -302.4201354980469,
        1130.4095458984375,
        95.0
      ],
      [
        -279.8700866699219,
        1130.4095458984375,
        95.0
      ],
      [
        -279.8700866699219,
        1130.4095458984375,
        100.0
      ],
      [
        -280.6162109375,
        1127.625,
        100.0
      ],
      [
        -370.1299133300781,
        1130.4095458984375,
        100.0
      ],
      [
        -370.1299133300781,
        1130.4095458984375,
        95.0
      ],
      [
        -369.3837890625,
        1127.625,
        100.0
      ],
      [
        -370.1299133300781,
        1130.4095458984375,
        110.0
      ],
      [
        -279.8700866699219,
        1130.4095458984375,
        110.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        100.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        110.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        110.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        100.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        110.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        100.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        100.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        110.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        120.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        118.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        120.0
      ],
      [
        -344.8478088378906,
        1130.4095458984375,
        118.0
      ],
      [
        -329.5,
        1130.4095458984375,
        400.0
      ],
      [
        -320.5,
        1130.4095458984375,
        400.0
      ],
      [
        -391.0191650390625,
        1130.4095458984375,
        400.0
      ],
      [
        -329.5,
        1130.4095458984375,
        400.0
      ],
      [
        -320.5,
        1130.4095458984375,
        400.0
      ],
      [
        -257.9808349609375,
        1130.4095458984375,
        400.0
      ],
      [
        -320.5,
        1130.4095458984375,
        432.0
      ],
      [
        -320.5,
        1190.0,
        432.0
      ],
      [
        -375.0001220703125,
        1147.0,
        419.20001220703125
      ],
      [
        -372.0001220703125,
        1147.0,
        419.20001220703125
      ],
      [
        -375.0001220703125,
        1147.0,
        416.1000061035156
      ],
      [
        -372.0001220703125,
        1147.0,
        416.1000061035156
      ],
      [
        -375.0001220703125,
        1147.0,
        412.5
      ],
      [
        -372.0001220703125,
        1147.0,
        412.5
      ],
      [
        -375.0001220703125,
        1147.0,
        409.0
      ],
      [
        -372.0001220703125,
        1147.0,
        409.0
      ],
      [
        -320.5,
        1158.0,
        402.0
      ],
      [
        -320.5,
        1158.0,
        432.0
      ],
      [
        -320.5,
        1154.0,
        405.5
      ],
      [
        -320.5,
        1158.0,
        405.5
      ],
      [
        -320.5,
        1154.0,
        405.0
      ],
      [
        -320.5,
        1154.0,
        405.5
      ],
      [
        -387.80487060546875,
        1178.65625,
        120.0
      ],
      [
        -387.6523132324219,
        1178.5682373046875,
        120.0
      ],
      [
        -374.2751159667969,
        1201.610107421875,
        120.0
      ],
      [
        -374.483154296875,
        1201.7301025390625,
        120.0
      ],
      [
        -377.7227478027344,
        1195.6715087890625,
        120.0
      ],
      [
        -377.9443664550781,
        1195.7349853515625,
        120.0
      ],
      [
        -369.4998779296875,
        1210.361328125,
        120.0
      ],
      [
        -369.1944274902344,
        1210.361328125,
        120.0
      ],
      [
        -409.4998474121094,
        1141.07958984375,
        120.0
      ],
      [
        -409.49993896484375,
        1141.0794677734375,
        120.0
      ],
      [
        -409.3359680175781,
        1141.2183837890625,
        120.0
      ],
      [
        -409.4039001464844,
        1141.1014404296875,
        120.0
      ],
      [
        -409.4039001464844,
        1141.1014404296875,
        120.0
      ],
      [
        -409.4194641113281,
        1141.0745849609375,
        120.0
      ],
      [
        -377.9443664550781,
        1195.7349853515625,
        120.0
      ],
      [
        -377.7227478027344,
        1195.6715087890625,
        120.0
      ],
      [
        -409.3359680175781,
        1141.2183837890625,
        120.0
      ],
      [
        -409.4194641113281,
        1141.0745849609375,
        120.0
      ],
      [
        -409.43756103515625,
        1141.04345703125,
        120.0
      ],
      [
        -409.4998474121094,
        1141.07958984375,
        95.0
      ],
      [
        -409.49993896484375,
        1141.0794677734375,
        95.0
      ],
      [
        -409.4998474121094,
        1141.07958984375,
        95.0
      ],
      [
        -409.4998474121094,
        1141.07958984375,
        120.0
      ],
      [
        -374.483154296875,
        1201.7301025390625,
        125.006103515625
      ],
      [
        -374.2751159667969,
        1201.610107421875,
        125.006103515625
      ],
      [
        -387.6523132324219,
        1178.5682373046875,
        125.006103515625
      ],
      [
        -387.80487060546875,
        1178.65625,
        125.006103515625
      ],
      [
        -374.483154296875,
        1201.7301025390625,
        120.0
      ],
      [
        -374.2751159667969,
        1201.610107421875,
        120.0
      ],
      [
        -374.2751159667969,
        1201.610107421875,
        125.006103515625
      ],
      [
        -374.483154296875,
        1201.7301025390625,
        125.006103515625
      ],
      [
        -387.6523132324219,
        1178.5682373046875,
        120.0
      ],
      [
        -387.80487060546875,
        1178.65625,
        120.0
      ],
      [
        -387.80487060546875,
        1178.65625,
        125.006103515625
      ],
      [
        -387.6523132324219,
        1178.5682373046875,
        125.006103515625
      ],
      [
        -340.0255432128906,
        1210.361328125,
        120.0
      ],
      [
        -340.0,
        1210.361328125,
        120.0
      ],
      [
        -340.0255432128906,
        1210.361328125,
        120.0
      ],
      [
        -320.5,
        1200.361328125,
        75.0
      ],
      [
        -320.5,
        1200.361328125,
        95.0
      ],
      [
        -340.0,
        1200.361328125,
        108.34407043457031
      ],
      [
        -340.0,
        1210.361328125,
        109.99969482421875
      ],
      [
        -320.5,
        1210.361328125,
        109.99969482421875
      ],
      [
        -320.5,
        1200.361328125,
        108.34407043457031
      ],
      [
        -340.0,
        1200.361328125,
        118.0
      ],
      [
        -340.0,
        1210.361328125,
        118.0
      ],
      [
        -320.5,
        1210.361328125,
        118.0
      ],
      [
        -320.5,
        1200.361328125,
        118.0
      ],
      [
        -340.0,
        1210.361328125,
        118.0
      ],
      [
        -340.0,
        1200.361328125,
        118.0
      ],
      [
        -320.5,
        1200.361328125,
        118.0
      ],
      [
        -320.5,
        1210.361328125,
        118.0
      ],
      [
        -340.0,
        1200.361328125,
        118.0
      ],
      [
        -340.0,
        1210.361328125,
        118.0
      ],
      [
        -340.0,
        1210.361328125,
        109.99969482421875
      ],
      [
        -340.0,
        1200.361328125,
        108.34407043457031
      ],
      [
        -340.0,
        1200.361328125,
        120.0
      ],
      [
        -340.0,
        1210.361328125,
        120.0
      ],
      [
        -340.0,
        1210.361328125,
        118.0
      ],
      [
        -340.0,
        1200.361328125,
        118.0
      ],
      [
        -320.5,
        1130.4095458984375,
        118.0
      ],
      [
        -320.5,
        1180.199951171875,
        118.0
      ],
      [
        -320.5,
        1130.4095458984375,
        118.0
      ],
      [
        -320.5,
        1180.199951171875,
        118.0
      ],
      [
        -320.5,
        1180.199951171875,
        118.0
      ],
      [
        -320.5,
        1180.199951171875,
        118.0
      ],
      [
        -320.5,
        1130.4095458984375,
        100.0
      ],
      [
        -320.5,
        1153.25,
        100.0
      ],
      [
        -320.5,
        1147.0,
        60.0
      ],
      [
        -320.5,
        1147.0,
        65.0
      ],
      [
        -320.5,
        1181.5,
        62.0
      ],
      [
        -320.5,
        1177.5,
        62.0
      ],
      [
        -320.5,
        1149.0,
        62.0
      ],
      [
        -320.5,
        1175.5,
        62.0
      ],
      [
        -320.5,
        1147.0,
        65.0
      ],
      [
        -320.5,
        1149.0,
        65.0
      ],
      [
        -320.5,
        1177.5,
        65.0
      ],
      [
        -320.5,
        1175.5,
        65.0
      ],
      [
        -320.5,
        1175.5,
        65.0
      ],
      [
        -320.5,
        1175.5,
        62.0
      ],
      [
        -364.75,
        1175.0,
        65.0
      ],
      [
        -364.75,
        1175.0,
        90.75
      ],
      [
        -364.75,
        1187.7750244140625,
        82.40657806396484
      ],
      [
        -364.75,
        1175.0,
        77.33158111572266
      ],
      [
        -364.75,
        1182.794189453125,
        65.0
      ],
      [
        -364.75,
        1175.0,
        65.0
      ],
      [
        -364.75,
        1185.219970703125,
        87.54440307617188
      ],
      [
        -364.75,
        1175.0,
        83.4843978881836
      ],
      [
        -374.5753173828125,
        1147.0,
        95.0
      ],
      [
        -356.5753173828125,
        1147.0,
        95.0
      ],
      [
        -364.75,
        1175.0,
        77.33158111572266
      ],
      [
        -364.75,
        1162.2249755859375,
        82.40657806396484
      ],
      [
        -364.75,
        1175.0,
        65.0
      ],
      [
        -364.75,
        1167.205810546875,
        65.0
      ],
      [
        -364.75,
        1167.205810546875,
        62.5
      ],
      [
        -364.75,
        1164.205810546875,
        62.5
      ],
      [
        -364.75,
        1164.205810546875,
        62.5
      ],
      [
        -364.75,
        1164.205810546875,
        62.0
      ],
      [
        -360.5,
        1167.205810546875,
        62.5
      ],
      [
        -364.75,
        1167.205810546875,
        60.0
      ],
      [
        -364.75,
        1167.205810546875,
        62.5
      ],
      [
        -364.75,
        1167.205810546875,
        65.0
      ],
      [
        -364.75,
        1175.0,
        83.4843978881836
      ],
      [
        -364.75,
        1164.780029296875,
        87.54440307617188
      ],
      [
        -367.7679138183594,
        1164.205810546875,
        62.5
      ],
      [
        -373.6908264160156,
        1147.0,
        64.0
      ],
      [
        -375.739990234375,
        1147.0,
        64.0
      ],
      [
        -373.6908264160156,
        1147.0,
        64.0
      ],
      [
        -372.9237976074219,
        1147.0,
        64.0
      ],
      [
        -376.25,
        1163.9166259765625,
        100.0
      ],
      [
        -365.0,
        1163.9166259765625,
        100.0
      ],
      [
        -365.0,
        1153.25,
        100.0
      ],
      [
        -365.0,
        1163.9166259765625,
        100.0
      ],
      [
        -365.0,
        1153.25,
        100.0
      ],
      [
        -356.5753173828125,
        1147.0,
        100.0
      ],
      [
        -356.5753173828125,
        1147.0,
        95.0
      ],
      [
        -376.25,
        1153.25,
        100.0
      ],
      [
        -376.25,
        1163.9166259765625,
        100.0
      ],
      [
        -376.25,
        1153.25,
        100.0
      ],
      [
        -374.5753173828125,
        1147.0,
        95.0
      ],
      [
        -374.5753173828125,
        1147.0,
        100.0
      ],
      [
        -370.1299133300781,
        1130.4095458984375,
        100.0
      ],
      [
        -320.5,
        1153.25,
        100.0
      ],
      [
        -320.5,
        1168.875,
        103.006103515625
      ],
      [
        -320.5,
        1180.199951171875,
        105.006103515625
      ],
      [
        -320.5,
        1168.875,
        103.006103515625
      ],
      [
        -320.5,
        1180.199951171875,
        105.006103515625
      ],
      [
        -376.25,
        1168.874755859375,
        103.00605773925781
      ],
      [
        -376.25,
        1171.208984375,
        103.41828155517578
      ],
      [
        -365.0,
        1171.2088623046875,
        103.41828155517578
      ],
      [
        -365.0,
        1168.874755859375,
        103.00605773925781
      ],
      [
        -376.25,
        1171.2088623046875,
        103.41828155517578
      ],
      [
        -365.0,
        1171.208984375,
        103.41828155517578
      ],
      [
        -347.09954833984375,
        1173.534912109375,
        103.90263366699219
      ],
      [
        -376.25,
        1171.34228515625,
        103.48079681396484
      ],
      [
        -365.0,
        1171.34228515625,
        103.48079681396484
      ],
      [
        -376.25,
        1171.34228515625,
        103.48079681396484
      ],
      [
        -365.0,
        1171.34228515625,
        103.48079681396484
      ],
      [
        -340.0,
        1180.199951171875,
        105.18492126464844
      ],
      [
        -340.0,
        1200.361328125,
        109.06378173828125
      ],
      [
        -340.0,
        1180.199951171875,
        105.18492126464844
      ],
      [
        -376.25,
        1185.25,
        118.0
      ],
      [
        -376.25,
        1195.25,
        118.0
      ],
      [
        -376.25,
        1166.050048828125,
        118.0
      ],
      [
        -376.25,
        1185.25,
        118.0
      ],
      [
        -365.0,
        1185.25,
        118.0
      ],
      [
        -365.0,
        1166.050048828125,
        118.0
      ],
      [
        -353.0,
        1195.25,
        118.0
      ],
      [
        -353.0,
        1185.25,
        118.0
      ],
      [
        -365.0,
        1195.25,
        118.0
      ],
      [
        -353.0,
        1195.25,
        118.0
      ],
      [
        -353.0,
        1185.25,
        118.0
      ],
      [
        -365.0,
        1185.25,
        118.0
      ],
      [
        -365.0,
        1130.4095458984375,
        110.0
      ],
      [
        -365.0,
        1153.25,
        110.0
      ],
      [
        -356.25,
        1153.25,
        110.0
      ],
      [
        -352.06329345703125,
        1168.875,
        110.0
      ],
      [
        -365.0,
        1166.050048828125,
        118.0
      ],
      [
        -376.25,
        1166.050048828125,
        118.0
      ],
      [
        -376.25,
        1195.25,
        118.0
      ],
      [
        -365.0,
        1195.25,
        118.0
      ],
      [
        -340.0,
        1210.361328125,
        125.0
      ],
      [
        -355.0,
        1210.361328125,
        125.0
      ],
      [
        -355.0,
        1210.361328125,
        125.0
      ],
      [
        -355.0,
        1210.361328125,
        120.0
      ],
      [
        -340.0,
        1210.361328125,
        120.0
      ],
      [
        -340.0,
        1210.361328125,
        125.0
      ],
      [
        -429.4999084472656,
        1210.361328125,
        120.0008773803711
      ],
      [
        -429.4999084472656,
        1210.361328125,
        100.00611877441406
      ],
      [
        -429.4999084472656,
        1210.361328125,
        100.00611877441406
      ],
      [
        -429.4999084472656,
        1210.361328125,
        80.00611877441406
      ],
      [
        -429.4999084472656,
        1210.361328125,
        120.0008773803711
      ],
      [
        -429.4999084472656,
        1210.361328125,
        500.0
      ],
      [
        -509.5000915527344,
        1210.361328125,
        320.0
      ],
      [
        -439.5000915527344,
        1210.361328125,
        320.0
      ],
      [
        -415.13079833984375,
        1150.3536376953125,
        128.143798828125
      ],
      [
        -410.1838073730469,
        1158.6741943359375,
        122.82001495361328
      ],
      [
        -402.6838073730469,
        1153.6741943359375,
        123.12716674804688
      ],
      [
        -410.1838073730469,
        1158.6741943359375,
        122.82001495361328
      ],
      [
        -402.3447570800781,
        1153.47265625,
        123.12943267822266
      ],
      [
        -402.6838073730469,
        1153.6741943359375,
        123.12716674804688
      ],
      [
        -402.35498046875,
        1153.4549560546875,
        130.0
      ],
      [
        -409.6993408203125,
        1143.0595703125,
        130.11337280273438
      ],
      [
        -416.9037170410156,
        1147.1990966796875,
        130.13385009765625
      ],
      [
        -416.9037170410156,
        1147.1990966796875,
        130.13385009765625
      ],
      [
        -415.13079833984375,
        1150.3536376953125,
        128.143798828125
      ],
      [
        -407.63079833984375,
        1145.3536376953125,
        128.45095825195312
      ],
      [
        -409.1062316894531,
        1142.7501220703125,
        130.09677124023438
      ],
      [
        -407.63079833984375,
        1145.3536376953125,
        128.45095825195312
      ],
      [
        -407.18524169921875,
        1145.0887451171875,
        128.45394897460938
      ],
      [
        -409.1062316894531,
        1142.7501220703125,
        130.09677124023438
      ],
      [
        -409.6993408203125,
        1143.0595703125,
        130.11337280273438
      ],
      [
        -417.67535400390625,
        1145.8260498046875,
        120.0
      ],
      [
        -399.4999694824219,
        1158.39990234375,
        120.0
      ],
      [
        -399.5028076171875,
        1158.4046630859375,
        120.0
      ],
      [
        -417.67535400390625,
        1145.8260498046875,
        130.1920928955078
      ],
      [
        -417.67535400390625,
        1145.8260498046875,
        120.0
      ],
      [
        -417.67535400390625,
        1145.8260498046875,
        130.1920928955078
      ],
      [
        -435.3560485839844,
        1156.0074462890625,
        120.0
      ],
      [
        -369.5223388671875,
        1210.361328125,
        80.00000762939453
      ],
      [
        -369.5223388671875,
        1210.361328125,
        60.0
      ],
      [
        -369.522216796875,
        1210.361328125,
        120.00000762939453
      ],
      [
        -369.5223388671875,
        1210.361328125,
        80.00000762939453
      ],
      [
        -369.522216796875,
        1210.361328125,
        120.0
      ],
      [
        -387.95721435546875,
        1178.4073486328125,
        60.00611877441406
      ],
      [
        -429.4999084472656,
        1210.361328125,
        80.00611877441406
      ],
      [
        -406.4058837890625,
        1210.361328125,
        60.00611877441406
      ],
      [
        -280.0,
        1158.0,
        402.0
      ],
      [
        -320.5,
        1158.0,
        402.0
      ],
      [
        -305.0,
        1154.0,
        402.0
      ],
      [
        -305.0,
        1154.0,
        405.5
      ],
      [
        -239.49996948242188,
        1141.0794677734375,
        120.0
      ],
      [
        -239.54287719726562,
        1141.15380859375,
        120.0
      ],
      [
        -262.0843811035156,
        1180.196533203125,
        120.0
      ],
      [
        -266.0574645996094,
        1178.94189453125,
        120.0
      ],
      [
        -286.50933837890625,
        1210.361328125,
        120.0
      ],
      [
        -279.5001220703125,
        1210.361328125,
        120.0
      ],
      [
        -241.7386016845703,
        1141.5816650390625,
        120.0
      ],
      [
        -241.3408660888672,
        1140.970703125,
        120.0
      ],
      [
        -266.0574645996094,
        1178.94189453125,
        120.0
      ],
      [
        -262.0843811035156,
        1180.196533203125,
        120.0
      ],
      [
        -241.73861694335938,
        1141.5816650390625,
        120.0
      ],
      [
        -241.3408660888672,
        1140.970703125,
        120.0
      ],
      [
        -240.88951110839844,
        1140.2772216796875,
        120.0
      ],
      [
        -239.54287719726562,
        1141.15380859375,
        120.0
      ],
      [
        -239.54287719726562,
        1141.15380859375,
        95.0
      ],
      [
        -249.50714111328125,
        1158.412353515625,
        95.0
      ],
      [
        -251.74757385253906,
        1156.9580078125,
        95.0
      ],
      [
        -251.74757385253906,
        1156.9580078125,
        110.0
      ],
      [
        -249.50714111328125,
        1158.412353515625,
        110.0
      ],
      [
        -244.0028076171875,
        1148.8785400390625,
        110.0
      ],
      [
        -245.75125122070312,
        1147.74609375,
        110.0
      ],
      [
        -245.75125122070312,
        1147.74609375,
        95.0
      ],
      [
        -244.0028076171875,
        1148.8785400390625,
        95.0
      ],
      [
        -249.50714111328125,
        1158.412353515625,
        110.0
      ],
      [
        -251.74757385253906,
        1156.9580078125,
        110.0
      ],
      [
        -245.75125122070312,
        1147.74609375,
        110.0
      ],
      [
        -244.0028076171875,
        1148.8785400390625,
        110.0
      ],
      [
        -244.0028076171875,
        1148.8785400390625,
        95.0
      ],
      [
        -245.75125122070312,
        1147.74609375,
        95.0
      ],
      [
        -251.74757385253906,
        1156.9580078125,
        95.0
      ],
      [
        -249.50714111328125,
        1158.412353515625,
        95.0
      ],
      [
        -239.54287719726562,
        1141.15380859375,
        95.0
      ],
      [
        -239.49996948242188,
        1141.0794677734375,
        95.0
      ],
      [
        -261.195068359375,
        1178.65625,
        125.006103515625
      ],
      [
        -264.5946350097656,
        1176.694580078125,
        125.006103515625
      ],
      [
        -279.1505432128906,
        1199.0562744140625,
        125.006103515625
      ],
      [
        -274.516845703125,
        1201.7301025390625,
        125.006103515625
      ],
      [
        -279.1505432128906,
        1199.0562744140625,
        120.0
      ],
      [
        -274.516845703125,
        1201.7301025390625,
        120.0
      ],
      [
        -274.516845703125,
        1201.7301025390625,
        125.006103515625
      ],
      [
        -279.1505432128906,
        1199.0562744140625,
        125.006103515625
      ],
      [
        -261.195068359375,
        1178.65625,
        120.0
      ],
      [
        -264.5946350097656,
        1176.694580078125,
        120.0
      ],
      [
        -264.5946350097656,
        1176.694580078125,
        125.006103515625
      ],
      [
        -261.195068359375,
        1178.65625,
        125.006103515625
      ],
      [
        -310.0,
        1210.361328125,
        120.0
      ],
      [
        -310.0,
        1210.361328125,
        118.0
      ],
      [
        -310.0,
        1210.361328125,
        118.0
      ],
      [
        -310.0,
        1210.361328125,
        75.0
      ],
      [
        -310.0,
        1210.361328125,
        60.0
      ],
      [
        -310.0,
        1200.361328125,
        108.34407043457031
      ],
      [
        -310.0,
        1210.361328125,
        109.99969482421875
      ],
      [
        -310.0,
        1210.361328125,
        118.0
      ],
      [
        -310.0,
        1200.361328125,
        118.0
      ],
      [
        -310.0,
        1210.361328125,
        109.99969482421875
      ],
      [
        -310.0,
        1200.361328125,
        108.34407043457031
      ],
      [
        -320.5,
        1200.361328125,
        108.34407043457031
      ],
      [
        -277.035888671875,
        1167.205810546875,
        62.5
      ],
      [
        -295.7320556640625,
        1178.0,
        62.5
      ],
      [
        -294.0,
        1175.0,
        62.5
      ],
      [
        -289.5,
        1182.794189453125,
        62.5
      ],
      [
        -292.964111328125,
        1167.205810546875,
        62.5
      ],
      [
        -287.10845947265625,
        1140.142333984375,
        65.0
      ],
      [
        -286.71484375,
        1139.689453125,
        65.0
      ],
      [
        -287.10845947265625,
        1140.142333984375,
        65.0
      ],
      [
        -306.0,
        1140.0,
        65.0
      ],
      [
        -306.0,
        1147.0,
        65.0
      ],
      [
        -312.0,
        1140.0,
        60.0
      ],
      [
        -312.0,
        1140.0,
        65.0
      ],
      [
        -306.0,
        1140.0,
        65.0
      ],
      [
        -312.0,
        1147.0,
        60.0
      ],
      [
        -312.0,
        1147.0,
        65.0
      ],
      [
        -312.0,
        1181.5,
        62.0
      ],
      [
        -312.0,
        1177.5,
        62.0
      ],
      [
        -320.5,
        1140.0,
        62.0
      ],
      [
        -312.0,
        1140.0,
        62.0
      ],
      [
        -320.5,
        1147.0,
        62.0
      ],
      [
        -312.0,
        1147.0,
        62.0
      ],
      [
        -320.5,
        1140.0,
        65.0
      ],
      [
        -285.25,
        1175.0,
        65.0
      ],
      [
        -285.25,
        1175.0,
        88.75
      ],
      [
        -286.9847412109375,
        1140.0,
        66.5999984741211
      ],
      [
        -286.9847412109375,
        1140.0,
        65.0
      ],
      [
        -293.75,
        1153.25,
        110.0
      ],
      [
        -297.93670654296875,
        1168.875,
        110.0
      ],
      [
        -310.0,
        1180.199951171875,
        110.0
      ],
      [
        -310.0,
        1200.361328125,
        110.0
      ],
      [
        -297.93670654296875,
        1168.875,
        110.0
      ],
      [
        -310.0,
        1180.199951171875,
        110.0
      ],
      [
        -310.0,
        1173.341796875,
        115.0
      ],
      [
        -310.0,
        1173.341796875,
        116.0
      ],
      [
        -310.0,
        1173.341796875,
        115.0
      ],
      [
        -310.0,
        1173.341796875,
        116.0
      ],
      [
        -297.93670654296875,
        1137.625,
        115.0
      ],
      [
        -297.93670654296875,
        1137.625,
        116.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        116.0
      ],
      [
        -305.1521911621094,
        1130.4095458984375,
        115.0
      ],
      [
        -294.2479553222656,
        1143.927490234375,
        100.0
      ],
      [
        -296.2500915527344,
        1143.9195556640625,
        100.0
      ],
      [
        -296.2500915527344,
        1143.9195556640625,
        100.0
      ],
      [
        -320.5,
        1143.8218994140625,
        100.0
      ],
      [
        -276.2285461425781,
        1144.0,
        100.0
      ],
      [
        -279.8700866699219,
        1130.4095458984375,
        100.0
      ],
      [
        -294.2479553222656,
        1143.927490234375,
        100.0
      ],
      [
        -294.2479553222656,
        1143.927490234375,
        95.0
      ],
      [
        -296.2500915527344,
        1143.9195556640625,
        110.0
      ],
      [
        -296.2500915527344,
        1143.9195556640625,
        100.0
      ],
      [
        -296.2500915527344,
        1143.9195556640625,
        100.0
      ],
      [
        -296.2500915527344,
        1143.9195556640625,
        110.0
      ],
      [
        -257.3829040527344,
        1153.300048828125,
        100.0
      ],
      [
        -257.3829040527344,
        1153.300048828125,
        100.0
      ],
      [
        -251.74757385253906,
        1156.9580078125,
        100.0
      ],
      [
        -251.3809814453125,
        1144.0999755859375,
        100.0
      ],
      [
        -245.75125122070312,
        1147.74609375,
        100.0
      ],
      [
        -257.3829040527344,
        1153.300048828125,
        100.00962829589844
      ],
      [
        -257.3829040527344,
        1153.300048828125,
        100.00962829589844
      ],
      [
        -251.74757385253906,
        1156.9580078125,
        100.71338653564453
      ],
      [
        -302.90045166015625,
        1173.534912109375,
        103.90263366699219
      ],
      [
        -310.0,
        1180.199951171875,
        105.18492126464844
      ],
      [
        -310.0,
        1200.361328125,
        109.06378173828125
      ],
      [
        -310.0,
        1180.199951171875,
        105.18492126464844
      ],
      [
        -310.0,
        1210.361328125,
        120.0
      ],
      [
        -310.0,
        1210.361328125,
        118.0
      ],
      [
        -295.0,
        1210.361328125,
        125.0
      ],
      [
        -310.0,
        1210.361328125,
        125.0
      ],
      [
        -310.0,
        1210.361328125,
        125.0
      ],
      [
        -310.0,
        1210.361328125,
        120.0
      ],
      [
        -295.0,
        1210.361328125,
        120.0
      ],
      [
        -295.0,
        1210.361328125,
        125.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        120.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        110.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        80.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        95.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        110.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        95.0
      ],
      [
        -279.477783203125,
        1210.361328125,
        60.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        80.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        120.0
      ],
      [
        -249.42201232910156,
        1158.2647705078125,
        120.0
      ],
      [
        -261.042724609375,
        1178.4073486328125,
        60.00611877441406
      ],
      [
        -219.50009155273438,
        1210.361328125,
        120.00524139404297
      ],
      [
        -219.5000762939453,
        1210.361328125,
        100.00611877441406
      ],
      [
        -219.5000762939453,
        1210.361328125,
        100.00611877441406
      ],
      [
        -219.50009155273438,
        1210.361328125,
        80.0
      ],
      [
        -219.50009155273438,
        1210.361328125,
        120.00524139404297
      ],
      [
        -219.5000762939453,
        1210.361328125,
        500.0
      ],
      [
        -249.50003051757812,
        1158.4000244140625,
        95.0
      ],
      [
        -249.484375,
        1158.4271240234375,
        95.0
      ],
      [
        -169.8828887939453,
        1210.361328125,
        95.0
      ],
      [
        -162.16839599609375,
        1210.361328125,
        95.0
      ],
      [
        -209.49990844726562,
        1210.361328125,
        320.0
      ],
      [
        -139.49990844726562,
        1210.361328125,
        320.0
      ],
      [
        -169.88290405273438,
        1210.361328125,
        120.0
      ],
      [
        -167.1900177001953,
        1210.361328125,
        120.8079833984375
      ],
      [
        -149.0497283935547,
        1210.361328125,
        270.0
      ],
      [
        -139.49993896484375,
        1210.361328125,
        270.0
      ],
      [
        -205.74085998535156,
        1210.361328125,
        270.0
      ],
      [
        -209.49990844726562,
        1210.361328125,
        270.0
      ],
      [
        -169.8828887939453,
        1210.361328125,
        120.0
      ],
      [
        -169.88290405273438,
        1210.361328125,
        95.0
      ],
      [
        -162.16839599609375,
        1210.361328125,
        120.0
      ],
      [
        -162.16839599609375,
        1210.361328125,
        95.0
      ],
      [
        -249.484375,
        1158.4271240234375,
        95.0
      ],
      [
        -249.484375,
        1158.4271240234375,
        110.0
      ],
      [
        -209.94268798828125,
        1184.0941162109375,
        110.0
      ],
      [
        -209.94268798828125,
        1184.0941162109375,
        95.0
      ],
      [
        -209.94268798828125,
        1184.0941162109375,
        120.0
      ],
      [
        -209.94268798828125,
        1184.0941162109375,
        110.0
      ],
      [
        -209.94268798828125,
        1184.0941162109375,
        120.0
      ],
      [
        -209.80831909179688,
        1184.181396484375,
        120.08821868896484
      ],
      [
        -249.484375,
        1158.4271240234375,
        110.0
      ],
      [
        -249.50003051757812,
        1158.4000244140625,
        110.0
      ],
      [
        -249.49725341796875,
        1158.40478515625,
        120.0
      ],
      [
        -239.5428924560547,
        1141.15380859375,
        120.0
      ],
      [
        -239.54290771484375,
        1141.15380859375,
        120.0
      ],
      [
        -249.50003051757812,
        1158.4000244140625,
        120.0
      ],
      [
        -167.1900177001953,
        1210.361328125,
        120.8079833984375
      ],
      [
        -162.16839599609375,
        1210.361328125,
        120.0
      ],
      [
        -214.50567626953125,
        1162.5135498046875,
        110.0
      ],
      [
        -211.1370086669922,
        1178.445556640625,
        110.0
      ],
      [
        -242.59410095214844,
        1210.361328125,
        60.00611877441406
      ],
      [
        -219.50009155273438,
        1210.361328125,
        80.0
      ],
      [
        -261.1859130859375,
        1178.661376953125,
        120.0
      ],
      [
        -261.18621826171875,
        1178.6611328125,
        120.0
      ],
      [
        -540.0,
        1430.0,
        120.0
      ],
      [
        -625.0554809570312,
        1309.916748046875,
        120.0
      ],
      [
        -618.1177368164062,
        1239.0,
        60.0
      ],
      [
        -618.1177368164062,
        1239.0,
        119.99999237060547
      ],
      [
        -618.1177368164062,
        1239.0,
        214.0
      ],
      [
        -394.65386962890625,
        1410.0,
        60.0
      ],
      [
        -400.42303466796875,
        1420.0,
        120.0
      ],
      [
        -406.1922912597656,
        1430.0,
        120.0
      ],
      [
        -400.42303466796875,
        1420.0,
        120.0
      ],
      [
        -516.034423828125,
        1239.0,
        60.02784729003906
      ],
      [
        -422.9655456542969,
        1239.0,
        60.02784729003906
      ],
      [
        -340.0,
        1239.0,
        60.0
      ],
      [
        -340.0,
        1239.02783203125,
        60.0
      ],
      [
        -340.0,
        1239.0,
        60.02788162231445
      ],
      [
        -299.5139465332031,
        1239.02783203125,
        60.0
      ],
      [
        -299.5,
        1239.0,
        60.0
      ],
      [
        -299.5,
        1239.0,
        60.02788162231445
      ],
      [
        -310.0,
        1239.02783203125,
        60.0
      ],
      [
        -310.0,
        1239.0,
        60.0
      ],
      [
        -310.0,
        1239.0,
        60.02788162231445
      ],
      [
        -350.5,
        1239.0,
        60.02788162231445
      ],
      [
        -350.5,
        1239.0,
        60.0
      ],
      [
        -350.4860534667969,
        1239.02783203125,
        60.0
      ],
      [
        -422.9655456542969,
        1239.0,
        60.02784729003906
      ],
      [
        -422.9404602050781,
        1239.0,
        60.00611877441406
      ],
      [
        -340.0,
        1239.0,
        65.0
      ],
      [
        -340.0,
        1239.0,
        80.0
      ],
      [
        -340.0,
        1239.0,
        125.0
      ],
      [
        -350.5,
        1239.0,
        80.0
      ],
      [
        -350.5,
        1239.0,
        80.0
      ],
      [
        -350.5,
        1239.0,
        125.0
      ],
      [
        -350.5,
        1239.0,
        125.0
      ],
      [
        -340.0,
        1239.0,
        125.0
      ],
      [
        -310.0,
        1239.0,
        65.0
      ],
      [
        -310.0,
        1263.2667236328125,
        65.0
      ],
      [
        -310.0,
        1263.2667236328125,
        60.0
      ],
      [
        -310.0,
        1239.0,
        125.0
      ],
      [
        -310.0,
        1239.0,
        80.0
      ],
      [
        -299.5,
        1239.0,
        80.0
      ],
      [
        -299.5,
        1239.0,
        125.0
      ],
      [
        -299.5,
        1239.0,
        80.0
      ],
      [
        -310.0,
        1239.0,
        125.0
      ],
      [
        -299.5,
        1239.0,
        125.0
      ],
      [
        -313.88458251953125,
        1270.0,
        65.0
      ],
      [
        -312.4634094238281,
        1267.53662109375,
        65.0
      ],
      [
        -310.0,
        1263.2667236328125,
        65.0
      ],
      [
        -310.0,
        1239.0,
        65.0
      ],
      [
        -314.0,
        1239.0,
        65.0
      ],
      [
        -312.4634094238281,
        1267.53662109375,
        65.0
      ],
      [
        -340.0,
        1239.0,
        65.0
      ],
      [
        -336.0,
        1239.0,
        65.0
      ],
      [
        -335.0,
        1239.0,
        85.0
      ],
      [
        -315.0,
        1239.0,
        85.0
      ],
      [
        -310.0,
        1239.0,
        85.0
      ],
      [
        -311.0,
        1239.0,
        85.0
      ],
      [
        -340.0,
        1239.0,
        85.0
      ],
      [
        -339.0,
        1239.0,
        85.0
      ],
      [
        -311.0,
        1239.0,
        85.0
      ],
      [
        -339.0,
        1239.0,
        85.0
      ],
      [
        -446.0344543457031,
        1239.0,
        60.02784729003906
      ],
      [
        -355.0,
        1210.4000244140625,
        60.0
      ],
      [
        -355.0,
        1210.4000244140625,
        120.0
      ],
      [
        -355.0,
        1210.361328125,
        120.0
      ],
      [
        -429.5222473144531,
        1210.4000244140625,
        80.00611877441406
      ],
      [
        -406.42822265625,
        1210.4000244140625,
        60.00611877441406
      ],
      [
        -295.0,
        1210.4000244140625,
        60.0
      ],
      [
        -295.0,
        1210.4000244140625,
        120.0
      ],
      [
        -295.0,
        1210.361328125,
        120.0
      ],
      [
        -226.0344696044922,
        1239.0,
        60.02783966064453
      ],
      [
        -132.9655303955078,
        1239.0,
        60.02783966064453
      ],
      [
        -226.05955505371094,
        1239.0,
        60.00611877441406
      ],
      [
        -226.0344696044922,
        1239.0,
        60.02783966064453
      ],
      [
        -200.0,
        1320.0,
        62.0
      ],
      [
        -217.67767333984375,
        1327.3223876953125,
        62.0
      ],
      [
        -182.32232666015625,
        1327.3223876953125,
        62.0
      ],
      [
        -200.0,
        1320.0,
        62.0
      ],
      [
        -225.0,
        1345.0,
        62.0
      ],
      [
        -217.67767333984375,
        1362.6776123046875,
        62.0
      ],
      [
        -217.67767333984375,
        1327.3223876953125,
        62.0
      ],
      [
        -225.0,
        1345.0,
        62.0
      ],
      [
        -175.0,
        1345.0,
        62.0
      ],
      [
        -182.32232666015625,
        1327.3223876953125,
        62.0
      ],
      [
        -200.0,
        1367.835205078125,
        62.0
      ],
      [
        -216.14694213867188,
        1361.1468505859375,
        62.0
      ],
      [
        -183.85305786132812,
        1361.1468505859375,
        62.0
      ],
      [
        -200.0,
        1367.835205078125,
        62.0
      ],
      [
        -216.14694213867188,
        1361.1468505859375,
        62.0
      ],
      [
        -222.835205078125,
        1345.0,
        62.0
      ],
      [
        -177.164794921875,
        1345.0,
        62.0
      ],
      [
        -183.85305786132812,
        1361.1468505859375,
        62.0
      ],
      [
        -183.85305786132812,
        1328.8531494140625,
        62.0
      ],
      [
        -177.164794921875,
        1345.0,
        62.0
      ],
      [
        -310.0,
        1270.0,
        62.0
      ],
      [
        -310.0,
        1263.2667236328125,
        62.0
      ],
      [
        -202.96554565429688,
        1239.0,
        60.02783966064453
      ],
      [
        180.0,
        1678.487548828125,
        120.0
      ],
      [
        190.0,
        1693.45361328125,
        120.0
      ],
      [
        190.0,
        1693.45361328125,
        140.0
      ],
      [
        180.0,
        1678.487548828125,
        140.0
      ],
      [
        180.0,
        1678.487548828125,
        60.0
      ],
      [
        190.0,
        1693.45361328125,
        60.0
      ],
      [
        190.0,
        1693.45361328125,
        120.0
      ],
      [
        180.0,
        1678.487548828125,
        120.0
      ],
      [
        120.0,
        1490.0,
        60.0
      ],
      [
        120.0,
        1490.0,
        214.0
      ],
      [
        120.0,
        1490.0,
        214.0
      ],
      [
        120.0,
        1500.0,
        214.0
      ],
      [
        165.93487548828125,
        1311.201416015625,
        60.0
      ],
      [
        294.4364929199219,
        1655.5635986328125,
        120.0
      ],
      [
        338.8263244628906,
        1721.997802734375,
        120.0
      ],
      [
        397.2405700683594,
        1809.4210205078125,
        120.0
      ],
      [
        357.9654846191406,
        1750.6416015625,
        120.0
      ],
      [
        350.6906433105469,
        1739.7540283203125,
        130.0
      ],
      [
        344.3594055175781,
        1730.2786865234375,
        130.0
      ],
      [
        357.9654846191406,
        1750.6416015625,
        130.0
      ],
      [
        350.6906433105469,
        1739.7540283203125,
        130.0
      ],
      [
        397.2405700683594,
        1809.4210205078125,
        120.0
      ],
      [
        397.2405700683594,
        1809.4210205078125,
        130.0
      ],
      [
        450.0,
        1820.0,
        130.0
      ],
      [
        397.2405700683594,
        1809.4210205078125,
        140.0
      ],
      [
        405.0116271972656,
        1821.05126953125,
        140.0
      ],
      [
        397.2405700683594,
        1809.4210205078125,
        140.0
      ],
      [
        330.16748046875,
        1656.07763671875,
        140.0
      ],
      [
        252.0435028076172,
        1460.0,
        240.0
      ],
      [
        338.8262939453125,
        1721.997802734375,
        120.0
      ],
      [
        338.8263244628906,
        1721.997802734375,
        130.0
      ],
      [
        338.8262939453125,
        1721.997802734375,
        130.0
      ],
      [
        202.13682556152344,
        1711.61767578125,
        120.0
      ],
      [
        202.13682556152344,
        1711.61767578125,
        140.0
      ],
      [
        327.61627197265625,
        1795.46044921875,
        130.0
      ],
      [
        397.2405700683594,
        1809.4210205078125,
        130.0
      ],
      [
        202.13682556152344,
        1711.61767578125,
        130.0
      ],
      [
        190.0,
        1693.45361328125,
        130.0
      ],
      [
        37.0,
        1509.403564453125,
        214.0
      ],
      [
        35.0,
        1509.403564453125,
        214.0
      ],
      [
        35.0,
        1509.403564453125,
        214.0
      ],
      [
        35.0,
        1511.5380859375,
        214.0
      ],
      [
        0.0,
        1050.0,
        82.0
      ],
      [
        10.0,
        1050.0,
        82.0
      ],
      [
        0.0,
        1050.0,
        126.0
      ],
      [
        10.0,
        1050.0,
        126.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.5555701851844788,
        -0.8314697742462158,
        -0.0
      ],
      "plane_d": 7440.36279296875,
      "bbox_min": [
        -6971.595703125,
        -5240.431640625,
        -500.0
      ],
      "bbox_max": [
        6306.5068359375,
        7700.0,
        2700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        2637.3291015625,
        4904.69091796875,
        610.11962890625
      ],
      "bbox_max": [
        6306.5068359375,
        7186.23974609375,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        4547.47998046875,
        4939.21728515625,
        1135.405029296875
      ],
      "bbox_max": [
        6306.5068359375,
        6601.240234375,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        5764.48095703125,
        4939.21728515625,
        1469.62939453125
      ],
      "bbox_max": [
        6306.5068359375,
        5140.50634765625,
        1913.5762939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2275390625,
      "bbox_min": [
        5957.56005859375,
        4939.21728515625,
        1590.8251953125
      ],
      "bbox_max": [
        6306.5068359375,
        5140.50634765625,
        1913.5762939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        2637.3291015625,
        4904.69091796875,
        610.11962890625
      ],
      "bbox_max": [
        6145.4921875,
        7186.23974609375,
        1843.7513427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        3014.04736328125,
        6834.52880859375,
        610.11962890625
      ],
      "bbox_max": [
        3163.701416015625,
        7183.8857421875,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2275390625,
      "bbox_min": [
        6000.2373046875,
        4904.69091796875,
        1686.8751220703125
      ],
      "bbox_max": [
        6145.4921875,
        4991.36962890625,
        1843.7513427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -6971.595703125,
        -5240.431640625,
        -500.0
      ],
      "bbox_max": [
        6051.90966796875,
        7700.0,
        2700.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2275390625,
      "bbox_min": [
        3977.8642578125,
        2270.430419921875,
        -300.0
      ],
      "bbox_max": [
        6051.90966796875,
        6290.52294921875,
        1803.1688232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        4081.29052734375,
        2270.430419921875,
        -300.0
      ],
      "bbox_max": [
        4237.6171875,
        4226.46826171875,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8327998518943787,
        -0.2665044367313385,
        0.4852007031440735
      ],
      "plane_d": 4626.05712890625,
      "bbox_min": [
        4081.29052734375,
        4000.0,
        -300.0
      ],
      "bbox_max": [
        4237.6171875,
        4226.46826171875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8088762164115906,
        0.07353420555591583,
        -0.5833626985549927
      ],
      "plane_d": 2847.2470703125,
      "bbox_min": [
        4081.29052734375,
        4000.0,
        -300.0
      ],
      "bbox_max": [
        4120.587890625,
        4226.46826171875,
        -256.76629638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5601329803466797,
        0.06843777745962143,
        0.8255710005760193
      ],
      "plane_d": 1309.8272705078125,
      "bbox_min": [
        4117.16162109375,
        2270.430419921875,
        1016.0430908203125
      ],
      "bbox_max": [
        4137.6171875,
        2301.583251953125,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3977.8642578125,
        3098.861083984375,
        -300.0
      ],
      "bbox_max": [
        5957.56005859375,
        6290.52294921875,
        1590.8251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8088762164115906,
        0.07353420555591583,
        -0.5833626985549927
      ],
      "plane_d": 2847.2470703125,
      "bbox_min": [
        4023.4130859375,
        4116.14306640625,
        -300.0
      ],
      "bbox_max": [
        4237.6171875,
        5100.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8327998518943787,
        -0.2665044367313385,
        0.4852007031440735
      ],
      "plane_d": 4626.05712890625,
      "bbox_min": [
        4031.279296875,
        4116.14306640625,
        -256.76629638671875
      ],
      "bbox_max": [
        4237.6171875,
        4760.92822265625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3977.8642578125,
        5037.267578125,
        101.1990737915039
      ],
      "bbox_max": [
        4547.47998046875,
        6290.52294921875,
        1135.4051513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        4087.392822265625,
        3098.861083984375,
        933.0609741210938
      ],
      "bbox_max": [
        4157.6171875,
        3154.043701171875,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -6656.287109375,
        3323.70068359375,
        -22.699951171875
      ],
      "bbox_max": [
        -3400.0,
        6409.3681640625,
        1359.083251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6656.287109375,
        3323.70068359375,
        150.0
      ],
      "bbox_max": [
        -3400.0,
        6409.3681640625,
        1359.083251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.213623046875,
      "bbox_min": [
        -6656.287109375,
        3323.70068359375,
        150.0
      ],
      "bbox_max": [
        -5332.01806640625,
        4995.78271484375,
        1359.083251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18346190452575684,
        0.3073110282421112,
        0.9337567090988159
      ],
      "plane_d": -694.5667724609375,
      "bbox_min": [
        -5345.82861328125,
        4972.2451171875,
        150.0
      ],
      "bbox_max": [
        -5332.01806640625,
        4995.78271484375,
        157.04066467285156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.213623046875,
      "bbox_min": [
        -6430.5634765625,
        3343.448974609375,
        157.04067993164062
      ],
      "bbox_max": [
        -5111.27001953125,
        4972.2451171875,
        1249.6044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        100.0,
        4430.66259765625,
        -300.0
      ],
      "bbox_max": [
        4042.8125,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9449668526649475,
        0.08389011770486832,
        0.3162277042865753
      ],
      "plane_d": -187.74609375,
      "bbox_min": [
        140.185791015625,
        4947.96533203125,
        -300.0
      ],
      "bbox_max": [
        427.0267333984375,
        7267.0830078125,
        -58.07276916503906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        231.02944946289062,
        7173.888671875,
        -300.0
      ],
      "bbox_max": [
        427.0267333984375,
        7267.0830078125,
        -58.07276916503906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9449668526649475,
        0.08389011770486832,
        0.3162277042865753
      ],
      "plane_d": -187.74609375,
      "bbox_min": [
        100.0,
        5028.201171875,
        -300.0
      ],
      "bbox_max": [
        448.3017578125,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        100.0,
        7165.60498046875,
        -300.0
      ],
      "bbox_max": [
        448.3017578125,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        100.0,
        7165.60498046875,
        -300.0
      ],
      "bbox_max": [
        448.3017578125,
        7287.82421875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3040.46826171875,
        4430.66259765625,
        -300.0
      ],
      "bbox_max": [
        4042.8125,
        5034.5224609375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8088762164115906,
        0.07353420555591583,
        -0.5833626985549927
      ],
      "plane_d": 2847.2470703125,
      "bbox_min": [
        3978.369140625,
        4919.77783203125,
        -81.08197021484375
      ],
      "bbox_max": [
        4025.732177734375,
        4986.189453125,
        -10.697733879089355
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8088762164115906,
        0.07353420555591583,
        -0.5833626985549927
      ],
      "plane_d": 2847.2470703125,
      "bbox_min": [
        3979.6884765625,
        4430.66259765625,
        -166.41896057128906
      ],
      "bbox_max": [
        4042.8125,
        4946.3798828125,
        -13.885726928710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        1489.9713134765625,
        6871.484375,
        620.907470703125
      ],
      "bbox_max": [
        3108.3935546875,
        7193.40869140625,
        703.6844482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        3017.69189453125,
        6871.484375,
        620.907470703125
      ],
      "bbox_max": [
        3108.3935546875,
        6932.08935546875,
        638.5988159179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        3018.309814453125,
        4415.38427734375,
        -169.08460998535156
      ],
      "bbox_max": [
        4043.345947265625,
        6889.40283203125,
        624.2333374023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3045.157470703125,
        4618.00146484375,
        -111.00995635986328
      ],
      "bbox_max": [
        4019.882080078125,
        5034.5224609375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8088762164115906,
        0.07353420555591583,
        -0.5833626985549927
      ],
      "plane_d": 2847.2470703125,
      "bbox_min": [
        3970.173828125,
        4946.3798828125,
        -13.885726928710938
      ],
      "bbox_max": [
        3979.6884765625,
        4957.15869140625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8088762164115906,
        0.07353420555591583,
        -0.5833626985549927
      ],
      "plane_d": 2847.2470703125,
      "bbox_min": [
        3970.173828125,
        4618.00146484375,
        -111.00995635986328
      ],
      "bbox_max": [
        4019.882080078125,
        4951.876953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3163.701416015625,
        4415.38427734375,
        -169.08460998535156
      ],
      "bbox_max": [
        4043.345947265625,
        6834.52880859375,
        612.5284423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3970.173828125,
        4949.31298828125,
        0.0
      ],
      "bbox_max": [
        4000.44775390625,
        4954.3212890625,
        24.79587745666504
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8327998518943787,
        -0.2665044367313385,
        0.4852007031440735
      ],
      "plane_d": 4626.05712890625,
      "bbox_min": [
        3970.173828125,
        4415.38427734375,
        -169.08460998535156
      ],
      "bbox_max": [
        4043.345947265625,
        4951.876953125,
        23.076534271240234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8088762164115906,
        0.07353420555591583,
        -0.5833626985549927
      ],
      "plane_d": 2847.2470703125,
      "bbox_min": [
        3970.173828125,
        4415.38427734375,
        -169.08460998535156
      ],
      "bbox_max": [
        4043.345947265625,
        4951.876953125,
        23.076534271240234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3970.173828125,
        4882.0908203125,
        0.0
      ],
      "bbox_max": [
        3999.89697265625,
        4951.876953125,
        23.076534271240234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        100.0,
        4509.04052734375,
        -123.255859375
      ],
      "bbox_max": [
        4040.075439453125,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        100.0,
        5035.24365234375,
        -36.837890625
      ],
      "bbox_max": [
        259.23272705078125,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9449668526649475,
        0.08389011770486832,
        0.3162277042865753
      ],
      "plane_d": -187.74609375,
      "bbox_min": [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      "bbox_max": [
        259.23272705078125,
        5158.08642578125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8327998518943787,
        -0.2665044367313385,
        0.4852007031440735
      ],
      "plane_d": 4626.05712890625,
      "bbox_min": [
        3956.206787109375,
        4509.04052734375,
        -123.255859375
      ],
      "bbox_max": [
        4040.075439453125,
        5071.1044921875,
        123.28400421142578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        3977.4443359375,
        4954.3212890625,
        24.79591178894043
      ],
      "bbox_max": [
        4024.458251953125,
        5071.1044921875,
        123.28400421142578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3977.4443359375,
        4979.27001953125,
        32.464378356933594
      ],
      "bbox_max": [
        4021.62939453125,
        5071.1044921875,
        123.28400421142578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3956.206787109375,
        5000.20556640625,
        39.024993896484375
      ],
      "bbox_max": [
        3986.291015625,
        5059.00244140625,
        86.50453186035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -3400.0,
        3851.8251953125,
        -300.0
      ],
      "bbox_max": [
        100.0,
        7430.10888671875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9484592080116272,
        -0.020618677139282227,
        0.3162277638912201
      ],
      "plane_d": 291.7543029785156,
      "bbox_min": [
        -3400.0,
        3851.8251953125,
        -300.0
      ],
      "bbox_max": [
        100.0,
        7265.8046875,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9319282174110413,
        -0.1775101274251938,
        0.31622785329818726
      ],
      "plane_d": 1065.060791015625,
      "bbox_min": [
        -3400.0,
        3851.8251953125,
        -300.0
      ],
      "bbox_max": [
        -100.20496368408203,
        6871.484375,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5555701851844788,
        -0.8314697742462158,
        0.0
      ],
      "plane_d": 7218.134765625,
      "bbox_min": [
        -3400.0,
        3851.8251953125,
        -113.45060729980469
      ],
      "bbox_max": [
        -366.4575500488281,
        6871.484375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40394648909568787,
        -0.8583862781524658,
        0.31622806191444397
      ],
      "plane_d": 3509.28515625,
      "bbox_min": [
        -619.7982788085938,
        3851.8251953125,
        -113.45060729980469
      ],
      "bbox_max": [
        -366.4575500488281,
        3934.389892578125,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        -150.0,
        7155.99462890625,
        -300.0
      ],
      "bbox_max": [
        100.0,
        7265.8046875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3932375907897949,
        -0.4582340121269226,
        0.797110915184021
      ],
      "plane_d": 2052.83154296875,
      "bbox_min": [
        -3400.0,
        3608.589111328125,
        150.0
      ],
      "bbox_max": [
        100.0,
        7430.10888671875,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2525.29052734375,
        4955.25732421875,
        150.0
      ],
      "bbox_max": [
        100.0,
        7430.10888671875,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8558866381645203,
        -0.018606234341859818,
        0.5168285369873047
      ],
      "plane_d": 228.558349609375,
      "bbox_min": [
        -750.0,
        4955.25732421875,
        150.0
      ],
      "bbox_max": [
        -202.00167846679688,
        7158.4658203125,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6274019479751587,
        0.7507457733154297,
        0.20675456523895264
      ],
      "plane_d": -431.48779296875,
      "bbox_min": [
        3317.77783203125,
        3319.888916015625,
        0.0
      ],
      "bbox_max": [
        4060.7236328125,
        3966.878662109375,
        100.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3970937132835388,
        0.6701478362083435,
        0.6270713210105896
      ],
      "plane_d": -1075.6932373046875,
      "bbox_min": [
        3966.056884765625,
        3861.65869140625,
        65.54586791992188
      ],
      "bbox_max": [
        4060.7236328125,
        3949.339111328125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3970937132835388,
        0.6701478362083435,
        0.6270713210105896
      ],
      "plane_d": -1075.6932373046875,
      "bbox_min": [
        3260.0,
        3162.05224609375,
        100.0
      ],
      "bbox_max": [
        4087.113037109375,
        3917.75341796875,
        924.3250122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6274019479751587,
        0.7507457733154297,
        0.20675456523895264
      ],
      "plane_d": -431.48779296875,
      "bbox_min": [
        3260.0,
        3200.0,
        100.0
      ],
      "bbox_max": [
        3966.056884765625,
        3861.65869140625,
        360.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        2878.090087890625,
        1830.0,
        137.21926879882812
      ],
      "bbox_max": [
        4117.16162109375,
        3200.0,
        1016.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3970937132835388,
        0.6701478362083435,
        0.6270713210105896
      ],
      "plane_d": -1075.6932373046875,
      "bbox_min": [
        3260.0,
        3154.04345703125,
        360.0
      ],
      "bbox_max": [
        4087.392822265625,
        3200.0,
        933.06103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        2878.090087890625,
        1830.0,
        137.21926879882812
      ],
      "bbox_max": [
        3260.0,
        3200.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        2780.0,
        3033.157958984375,
        80.0
      ],
      "bbox_max": [
        2814.28564453125,
        3107.142822265625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        2804.21044921875,
        2798.10986328125,
        100.0
      ],
      "bbox_max": [
        2889.345947265625,
        3120.435546875,
        170.32931518554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -2619.10009765625,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        3608.589111328125,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -6971.595703125,
        -2323.521484375,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        3608.589111328125,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6821.484375,
        2758.39404296875,
        -22.699951171875
      ],
      "bbox_max": [
        -6430.5634765625,
        3343.44873046875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7714905142784119,
        0.08541621267795563,
        0.6304812431335449
      ],
      "plane_d": 2975.195556640625,
      "bbox_min": [
        -5228.9921875,
        -2269.10009765625,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        3608.589111328125,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -5228.9921875,
        -2269.10009765625,
        -300.0
      ],
      "bbox_max": [
        -3509.2900390625,
        3498.463623046875,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18346190452575684,
        0.3073110282421112,
        0.9337567090988159
      ],
      "plane_d": -694.5667724609375,
      "bbox_min": [
        -5228.9921875,
        2154.178466796875,
        507.7889099121094
      ],
      "bbox_max": [
        -4658.73828125,
        3498.463623046875,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.213623046875,
      "bbox_min": [
        -5228.9921875,
        2154.178466796875,
        609.7310791015625
      ],
      "bbox_max": [
        -4912.15185546875,
        3458.8720703125,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5895068049430847,
        -0.7432911396026611,
        0.31622788310050964
      ],
      "plane_d": 4052.218505859375,
      "bbox_min": [
        -4100.0,
        2156.023681640625,
        -300.0
      ],
      "bbox_max": [
        -3861.632568359375,
        2261.4169921875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5895068049430847,
        -0.7432911396026611,
        0.31622788310050964
      ],
      "plane_d": 4052.218505859375,
      "bbox_min": [
        -4100.0,
        2200.0,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        2786.4052734375,
        73.41243743896484
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18346190452575684,
        0.3073110282421112,
        0.9337567090988159
      ],
      "plane_d": -694.5667724609375,
      "bbox_min": [
        -4912.15185546875,
        2154.178466796875,
        257.99737548828125
      ],
      "bbox_max": [
        -3400.0,
        3505.9931640625,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -4912.15185546875,
        2154.178466796875,
        336.2261657714844
      ],
      "bbox_max": [
        -3400.0,
        2993.050048828125,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -3400.0,
      "bbox_min": [
        -150.0,
        -300.0,
        2200.0
      ],
      "bbox_max": [
        3879.621826171875,
        1180.0,
        0.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.10106618702411652,
        -0.9432844519615173,
        0.3162279725074768
      ],
      "plane_d": 3427.828369140625,
      "bbox_min": [
        -2652.67138671875,
        3400.0,
        0.0
      ],
      "bbox_max": [
        -475.55438232421875,
        3864.445068359375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40394648909568787,
        -0.8583862781524658,
        0.31622806191444397
      ],
      "plane_d": 3509.28515625,
      "bbox_min": [
        -1263.684326171875,
        3500.0,
        0.0
      ],
      "bbox_max": [
        -475.55438232421875,
        3864.445068359375,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.18346190452575684,
        0.3073110282421112,
        0.9337567090988159
      ],
      "plane_d": -694.5667724609375,
      "bbox_min": [
        -3400.0,
        3400.0,
        150.0
      ],
      "bbox_max": [
        -2672.78515625,
        3637.418701171875,
        292.881103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -3400.0,
        2755.17236328125,
        0.0
      ],
      "bbox_max": [
        -2700.0,
        3400.0,
        426.8134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5895068049430847,
        -0.7432911396026611,
        0.31622788310050964
      ],
      "plane_d": 4052.218505859375,
      "bbox_min": [
        -3400.0,
        2755.17236328125,
        0.0
      ],
      "bbox_max": [
        -2700.0,
        3400.0,
        426.8134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18346190452575684,
        0.3073110282421112,
        0.9337567090988159
      ],
      "plane_d": -694.5667724609375,
      "bbox_min": [
        -3400.0,
        2993.050048828125,
        155.3470916748047
      ],
      "bbox_max": [
        -2700.0,
        3400.0,
        426.8134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1645.0,
        1469.9998779296875,
        370.0
      ],
      "bbox_max": [
        2130.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        1645.0,
        1654.800048828125,
        370.0
      ],
      "bbox_max": [
        2130.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9688333868980408,
        -0.24771343171596527,
        -0.0
      ],
      "plane_d": 2410.359130859375,
      "bbox_min": [
        1660.0,
        1830.0,
        500.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2740.887451171875,
      "bbox_min": [
        1660.0,
        1830.0,
        500.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1660.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1865.3895263671875,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1892.56787109375,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1971.7369384765625,
        1891.7369384765625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1660.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1975.489501953125,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1885.0001220703125,
        1830.375,
        1130.0
      ],
      "bbox_max": [
        1913.2427978515625,
        1851.050048828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1880.41455078125,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1913.6177978515625,
        1837.9425048828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1880.41455078125,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1892.9425048828125,
        1837.9423828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1668.9998779296875,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1704.19970703125,
        1865.1998291015625,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        8.719300694792764e-07,
        0.0
      ],
      "plane_d": 1659.9984130859375,
      "bbox_min": [
        1659.9998779296875,
        1654.800048828125,
        1059.6480712890625
      ],
      "bbox_max": [
        2020.0,
        1830.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1659.9998779296875,
        1654.800048828125,
        1059.6480712890625
      ],
      "bbox_max": [
        2020.0,
        1830.0,
        1130.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        3.2501047826372087e-06
      ],
      "plane_d": 2319.75244140625,
      "bbox_min": [
        1800.0,
        1720.0,
        1060.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1921.2918701171875,
        1772.5001220703125,
        1110.0
      ],
      "bbox_max": [
        1928.516845703125,
        1793.0001220703125,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1800.0,
        1720.0,
        1060.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1830.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1800.0,
        1720.0,
        1110.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1800.0,
        1110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1704.355224609375,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10106618702411652,
        -0.9432844519615173,
        0.3162279725074768
      ],
      "plane_d": 3427.828369140625,
      "bbox_min": [
        -2700.0,
        3310.3447265625,
        0.0
      ],
      "bbox_max": [
        -2183.333251953125,
        3400.0,
        161.4759979248047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18346190452575684,
        0.3073110282421112,
        0.9337567090988159
      ],
      "plane_d": -694.5667724609375,
      "bbox_min": [
        -2700.0,
        3397.04736328125,
        150.0
      ],
      "bbox_max": [
        -2652.671142578125,
        3400.0,
        156.31884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -2672.78515625,
        3398.1728515625,
        150.0
      ],
      "bbox_max": [
        -2652.671142578125,
        3400.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5895068049430847,
        -0.7432911396026611,
        0.31622788310050964
      ],
      "plane_d": 4052.218505859375,
      "bbox_min": [
        -2700.0,
        3310.3447265625,
        0.0
      ],
      "bbox_max": [
        -2650.0,
        3398.1728515625,
        161.4759979248047
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18346190452575684,
        0.3073110282421112,
        0.9337567090988159
      ],
      "plane_d": -694.5667724609375,
      "bbox_min": [
        -2700.0,
        3381.37744140625,
        150.0
      ],
      "bbox_max": [
        -2669.724609375,
        3398.1728515625,
        161.47598266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        -340.0,
        1103.0,
        28.0
      ],
      "bbox_max": [
        -310.0,
        1147.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238793849945068,
        -0.38268375396728516,
        -0.0
      ],
      "plane_d": 133.3199005126953,
      "bbox_min": [
        -340.0,
        1103.0,
        28.0
      ],
      "bbox_max": [
        -310.0,
        1140.0,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -28.0,
      "bbox_min": [
        -327.8995056152344,
        1107.3934326171875,
        28.0
      ],
      "bbox_max": [
        -310.0,
        1140.0,
        43.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 40.0,
      "bbox_min": [
        -327.8995056152344,
        1107.3934326171875,
        28.0
      ],
      "bbox_max": [
        -310.0,
        1140.0,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -41.0,
      "bbox_min": [
        -325.0,
        1107.3934326171875,
        40.0
      ],
      "bbox_max": [
        -310.0,
        1133.0,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238789677619934,
        -0.38268476724624634,
        -0.0
      ],
      "plane_d": 141.4390869140625,
      "bbox_min": [
        -325.0,
        1107.3934326171875,
        40.0
      ],
      "bbox_max": [
        -310.0,
        1133.0,
        41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238789677619934,
        0.38268476724624634,
        0.0
      ],
      "plane_d": -714.2440795898438,
      "bbox_min": [
        -325.0,
        1107.3934326171875,
        40.0
      ],
      "bbox_max": [
        -310.0,
        1133.0,
        41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268551230430603,
        -0.9238786697387695,
        -2.1012406250520144e-06
      ],
      "plane_d": 922.3818359375,
      "bbox_min": [
        -325.0,
        1128.6065673828125,
        40.0
      ],
      "bbox_max": [
        -314.3934020996094,
        1133.0,
        41.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238789677619934,
        -0.38268476724624634,
        -0.0
      ],
      "plane_d": 141.4390869140625,
      "bbox_min": [
        -325.0,
        1107.3934326171875,
        41.0
      ],
      "bbox_max": [
        -310.0,
        1133.0,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238789677619934,
        0.38268476724624634,
        0.0
      ],
      "plane_d": -714.2440795898438,
      "bbox_min": [
        -325.0,
        1107.3934326171875,
        41.0
      ],
      "bbox_max": [
        -310.0,
        1133.0,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268551230430603,
        -0.9238786697387695,
        -2.1012406250520144e-06
      ],
      "plane_d": 922.3818359375,
      "bbox_min": [
        -325.0,
        1128.6065673828125,
        41.0
      ],
      "bbox_max": [
        -314.3934020996094,
        1133.0,
        43.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238789677619934,
        -0.38268476724624634,
        -0.0
      ],
      "plane_d": 141.4390869140625,
      "bbox_min": [
        -327.8995056152344,
        1107.3934326171875,
        28.0
      ],
      "bbox_max": [
        -310.0,
        1140.0,
        40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238789677619934,
        0.38268476724624634,
        0.0
      ],
      "plane_d": -714.2440795898438,
      "bbox_min": [
        -327.8995056152344,
        1107.3934326171875,
        28.0
      ],
      "bbox_max": [
        -310.0,
        1140.0,
        40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.382688045501709,
        -0.9238775968551636,
        0.0
      ],
      "plane_d": 922.3796997070312,
      "bbox_min": [
        -327.8995056152344,
        1128.6065673828125,
        28.0
      ],
      "bbox_max": [
        -314.3934020996094,
        1140.0,
        40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9703943133354187,
        0.24152612686157227,
        0.0
      ],
      "plane_d": -586.3511352539062,
      "bbox_min": [
        -327.8995056152344,
        1131.9644775390625,
        28.0
      ],
      "bbox_max": [
        -320.5,
        1140.0,
        35.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 35.0,
      "bbox_min": [
        -327.8995056152344,
        1131.9644775390625,
        35.0
      ],
      "bbox_max": [
        -320.5,
        1140.0,
        35.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 43.0,
      "bbox_min": [
        -340.0,
        1103.0,
        28.0
      ],
      "bbox_max": [
        -314.3934020996094,
        1140.0,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826861083507538,
        0.9238784313201904,
        0.0
      ],
      "plane_d": -894.6649169921875,
      "bbox_min": [
        -340.0,
        1103.0,
        28.0
      ],
      "bbox_max": [
        -314.3934020996094,
        1140.0,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826861083507538,
        0.9238784313201904,
        0.0
      ],
      "plane_d": -1143.410888671875,
      "bbox_min": [
        -340.0,
        1103.0,
        28.0
      ],
      "bbox_max": [
        -314.3934020996094,
        1140.0,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238789677619934,
        -0.38268476724624634,
        0.0
      ],
      "plane_d": 741.96044921875,
      "bbox_min": [
        -340.0,
        1107.3934326171875,
        28.0
      ],
      "bbox_max": [
        -325.0,
        1140.0,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238789677619934,
        0.38268476724624634,
        0.0
      ],
      "plane_d": -113.72271728515625,
      "bbox_min": [
        -340.0,
        1107.3934326171875,
        28.0
      ],
      "bbox_max": [
        -325.0,
        1140.0,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826894760131836,
        -0.9238770604133606,
        0.0
      ],
      "plane_d": 1171.1268310546875,
      "bbox_min": [
        -335.6065979003906,
        1128.6065673828125,
        28.0
      ],
      "bbox_max": [
        -325.0,
        1140.0,
        43.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9703943133354187,
        0.24152612686157227,
        -0.0
      ],
      "plane_d": 44.4051399230957,
      "bbox_min": [
        -329.5,
        1131.9644775390625,
        28.0
      ],
      "bbox_max": [
        -325.0,
        1140.0,
        35.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 35.0,
      "bbox_min": [
        -329.5,
        1131.9644775390625,
        35.0
      ],
      "bbox_max": [
        -325.0,
        1140.0,
        35.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -329.5,
        1140.0,
        28.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 329.5,
      "bbox_min": [
        -329.5,
        1140.0,
        28.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -320.5,
      "bbox_min": [
        -329.5,
        1140.0,
        28.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -28.0,
      "bbox_min": [
        -329.5,
        1140.0,
        28.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        28.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1830.0,
      "bbox_min": [
        1010.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        1645.0,
        2050.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1010.0,
        1330.0,
        350.0852355957031
      ],
      "bbox_max": [
        1050.0,
        1390.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        1010.0,
        1390.0,
        80.0
      ],
      "bbox_max": [
        1645.0,
        1550.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        500.0
      ],
      "bbox_max": [
        1645.0,
        1508.2841796875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2162.533447265625,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        500.0
      ],
      "bbox_max": [
        1588.2841796875,
        1508.2841796875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1010.0,
        1390.0,
        80.0
      ],
      "bbox_max": [
        1075.0,
        1550.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        370.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1030.0,
        1460.0,
        370.085205078125
      ],
      "bbox_max": [
        1075.0,
        1550.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1460.0,
        370.085205078125
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        1148.2298583984375,
        1550.0,
        370.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1690.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1148.2298583984375,
        1630.0,
        379.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 543.9276733398438,
      "bbox_min": [
        1148.2298583984375,
        1630.0,
        379.0
      ],
      "bbox_max": [
        1198.2298583984375,
        1690.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1550.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1550.0,
        1910.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1550.0,
        1910.0,
        370.0
      ],
      "bbox_max": [
        1588.2843017578125,
        2050.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -326.482421875,
      "bbox_min": [
        1550.0001220703125,
        2011.7158203125,
        500.0
      ],
      "bbox_max": [
        1588.2843017578125,
        2050.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        839.914794921875,
        1330.0,
        180.0
      ],
      "bbox_max": [
        1010.0,
        1540.0,
        350.0852355957031
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        0.3090174198150635,
        0.0
      ],
      "plane_d": 88.44082641601562,
      "bbox_min": [
        510.5146179199219,
        1223.5849609375,
        160.0
      ],
      "bbox_max": [
        582.7122802734375,
        1384.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        0.8090178370475769,
        0.0
      ],
      "plane_d": -777.47216796875,
      "bbox_min": [
        510.5146179199219,
        1223.5849609375,
        160.0
      ],
      "bbox_max": [
        582.7122802734375,
        1384.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        -0.3090174198150635,
        0.0
      ],
      "plane_d": 882.6156005859375,
      "bbox_min": [
        510.5146179199219,
        1223.5849609375,
        160.0
      ],
      "bbox_max": [
        530.4696044921875,
        1285.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -640.0554809570312,
        820.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        2540.0,
        640.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        -608.4334106445312,
        1430.0,
        60.0
      ],
      "bbox_max": [
        0.0,
        1500.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9700985550880432,
        -0.2427113950252533,
        0.0
      ],
      "plane_d": 924.297119140625,
      "bbox_min": [
        -608.4334106445312,
        1430.0,
        60.0
      ],
      "bbox_max": [
        -580.0,
        1490.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -214.0,
      "bbox_min": [
        -608.4334106445312,
        1430.0,
        214.0
      ],
      "bbox_max": [
        -580.0,
        1490.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999999403953552,
        0.866025447845459,
        0.0
      ],
      "plane_d": -1107.953857421875,
      "bbox_min": [
        -640.0554809570312,
        820.0,
        60.0
      ],
      "bbox_max": [
        0.0,
        1430.0,
        540.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -50.843994140625,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1250.4873046875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -50.843994140625,
        1250.0,
        120.0
      ],
      "bbox_max": [
        -50.0,
        1250.4873046875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -339.5,
        1040.0,
        75.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -339.5,
        1040.0,
        75.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1051.800048828125,
      "bbox_min": [
        -339.5,
        1040.0,
        75.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -335.0,
        1040.0,
        75.0
      ],
      "bbox_max": [
        -315.0,
        1051.800048828125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -335.0,
        1040.0,
        75.0
      ],
      "bbox_max": [
        -315.0,
        1051.800048828125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 335.0,
      "bbox_min": [
        -335.0,
        1040.0,
        75.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -330.0,
        1050.0,
        75.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -330.0,
        1050.0,
        75.0
      ],
      "bbox_max": [
        -330.0,
        1051.800048828125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -339.02734375,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -332.0,
      "bbox_min": [
        -339.02734375,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -318.0,
        1057.8154296875,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575021624565125,
        0.5144803524017334
      ],
      "plane_d": -946.6806030273438,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        85.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575021624565125,
        0.5144803524017334
      ],
      "plane_d": -946.6806030273438,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        85.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -76.0,
      "bbox_min": [
        -339.02734375,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7746033668518066,
        -0.4471936821937561,
        -0.44722193479537964
      ],
      "plane_d": 765.14208984375,
      "bbox_min": [
        -337.8636474609375,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -912.150634765625,
      "bbox_min": [
        -337.8636474609375,
        1055.800048828125,
        75.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745686173439026,
        0.44724565744400024,
        -0.44723013043403625
      ],
      "plane_d": -179.21800231933594,
      "bbox_min": [
        -335.824951171875,
        1055.800048828125,
        75.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        -0.7070940732955933,
        0.0
      ],
      "plane_d": 984.6046752929688,
      "bbox_min": [
        -338.37939453125,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -508.52301025390625,
      "bbox_min": [
        -338.37939453125,
        1055.80712890625,
        76.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.489622978416264e-09,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -594.5062866210938,
      "bbox_min": [
        -338.37939453125,
        1055.80712890625,
        76.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -508.52301025390625,
      "bbox_min": [
        -336.6470947265625,
        1054.1455078125,
        76.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5078026056289673,
        -0.01057465560734272,
        0.861408531665802
      ],
      "plane_d": 115.78661346435547,
      "bbox_min": [
        -336.6470947265625,
        1054.1455078125,
        76.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -912.150634765625,
      "bbox_min": [
        -315.62744140625,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -76.0,
      "bbox_min": [
        -315.62744140625,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745887041091919,
        -0.4471992552280426,
        -0.44724172353744507
      ],
      "plane_d": 261.66192626953125,
      "bbox_min": [
        -315.62744140625,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745679020881653,
        0.4472414255142212,
        -0.4472355842590332
      ],
      "plane_d": -682.6824951171875,
      "bbox_min": [
        -315.62744140625,
        1055.800048828125,
        75.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745699286460876,
        0.4472425878047943,
        -0.44723090529441833
      ],
      "plane_d": -197.33912658691406,
      "bbox_min": [
        -312.425048828125,
        1055.800048828125,
        75.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940732955933,
        -0.0
      ],
      "plane_d": -524.9769897460938,
      "bbox_min": [
        -315.0853271484375,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -968.1423950195312,
      "bbox_min": [
        -315.0853271484375,
        1054.1455078125,
        76.0
      ],
      "bbox_max": [
        -313.3529052734375,
        1057.53955078125,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.010574648156762123,
        0.861408531665802
      ],
      "plane_d": -214.28509521484375,
      "bbox_min": [
        -315.0853271484375,
        1054.1455078125,
        76.0
      ],
      "bbox_max": [
        -313.3529052734375,
        1057.53955078125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -968.1423950195312,
      "bbox_min": [
        -315.0853271484375,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": 103.94253540039062,
      "bbox_min": [
        -313.3529052734375,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -594.5062866210938,
      "bbox_min": [
        -315.0853271484375,
        1055.80712890625,
        76.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 313.5,
      "bbox_min": [
        -314.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        78.33777618408203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.5,
      "bbox_min": [
        -314.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -313.5,
        1098.3555908203125,
        78.33777618408203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -314.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -313.5,
        1098.3555908203125,
        78.33777618408203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -309.53204345703125,
        1100.646484375,
        78.0
      ],
      "bbox_max": [
        -309.5,
        1100.6650390625,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -354.81549072265625,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -339.5,
        1083.344482421875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -354.81549072265625,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -339.5,
        1083.344482421875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826856315135956,
        0.9238786101341248,
        -0.0
      ],
      "plane_d": -1008.5560302734375,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1200.363037109375,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -136.8021240234375,
        1170.064208984375,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.26290392875671387,
        0.40389078855514526,
        -0.8762155771255493
      ],
      "plane_d": -394.6158142089844,
      "bbox_min": [
        -214.8716278076172,
        1125.61376953125,
        120.0
      ],
      "bbox_max": [
        -136.8021240234375,
        1170.064208984375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4038896858692169,
        0.26290363073349,
        -0.8762161731719971
      ],
      "plane_d": -111.8018569946289,
      "bbox_min": [
        -214.8716278076172,
        1125.61376953125,
        120.0
      ],
      "bbox_max": [
        -159.20643615722656,
        1170.064208984375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12700527906417847,
        0.6006799340248108,
        -0.7893372178077698
      ],
      "plane_d": -559.6082763671875,
      "bbox_min": [
        -199.3573760986328,
        1125.61376953125,
        120.0
      ],
      "bbox_max": [
        -159.20643615722656,
        1170.064208984375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -197.52635192871094,
        1142.37548828125,
        131.0
      ],
      "bbox_max": [
        -159.20643615722656,
        1170.064208984375,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660280108451843,
        -0.49999552965164185,
        -0.0
      ],
      "plane_d": 361.51641845703125,
      "bbox_min": [
        -240.88949584960938,
        1118.62646484375,
        60.0
      ],
      "bbox_max": [
        -228.38961791992188,
        1140.2772216796875,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4999999403953552,
        0.866025447845459,
        0.0
      ],
      "plane_d": -1077.9537353515625,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -136.8021240234375,
        1170.064208984375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -136.8021240234375,
        1155.59326171875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8289903402328491,
        0.5592629313468933,
        0.0
      ],
      "plane_d": -844.8052978515625,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.545535147190094,
        0.8380879163742065,
        0.0
      ],
      "plane_d": -1037.0234375,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        95.0
      ],
      "bbox_max": [
        -136.8021240234375,
        1148.3199462890625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8289903402328491,
        0.5592629313468933,
        0.0
      ],
      "plane_d": -844.8052978515625,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        95.0
      ],
      "bbox_max": [
        -171.68490600585938,
        1130.9688720703125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20686249434947968,
        0.9783700108528137,
        0.0
      ],
      "plane_d": -1065.7515869140625,
      "bbox_min": [
        -197.011962890625,
        1125.61376953125,
        95.0
      ],
      "bbox_max": [
        -171.68490600585938,
        1130.9688720703125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999967217445374,
        -0.8660256266593933,
        0.0
      ],
      "plane_d": 1107.4539794921875,
      "bbox_min": [
        -309.5,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -154.3612060546875,
        1170.064208984375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -309.5,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -188.71461486816406,
        1170.064208984375,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8380868434906006,
        -0.5455368757247925,
        -0.0
      ],
      "plane_d": 420.1769714355469,
      "bbox_min": [
        -240.8894805908203,
        1139.8575439453125,
        75.0
      ],
      "bbox_max": [
        -240.61631774902344,
        1140.2772216796875,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -240.8894805908203,
        1139.8575439453125,
        78.0
      ],
      "bbox_max": [
        -188.71461486816406,
        1170.064208984375,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8380868434906006,
        -0.5455368757247925,
        -0.0
      ],
      "plane_d": 420.1769714355469,
      "bbox_min": [
        -240.8894805908203,
        1139.8575439453125,
        78.0
      ],
      "bbox_max": [
        -240.61631774902344,
        1140.2772216796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -240.61631774902344,
        1115.0986328125,
        75.0
      ],
      "bbox_max": [
        -154.3612060546875,
        1169.822998046875,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.46488767862319946,
        -0.30260810256004333,
        0.8320503234863281
      ],
      "plane_d": 170.66680908203125,
      "bbox_min": [
        -240.61631774902344,
        1115.0986328125,
        75.0
      ],
      "bbox_max": [
        -203.4488983154297,
        1150.357666015625,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5455361604690552,
        0.838087260723114,
        0.0
      ],
      "plane_d": -1064.5228271484375,
      "bbox_min": [
        -240.61631774902344,
        1115.0986328125,
        75.0
      ],
      "bbox_max": [
        -203.4488983154297,
        1150.357666015625,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380868434906006,
        -0.5455368757247925,
        0.0
      ],
      "plane_d": 420.17694091796875,
      "bbox_min": [
        -228.59152221679688,
        1115.0986328125,
        75.0
      ],
      "bbox_max": [
        -224.5,
        1121.38427734375,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5455361604690552,
        -0.838087260723114,
        0.0
      ],
      "plane_d": 1079.5657958984375,
      "bbox_min": [
        -240.61631774902344,
        1133.9915771484375,
        75.0
      ],
      "bbox_max": [
        -211.65533447265625,
        1150.357666015625,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380868434906006,
        -0.5455368757247925,
        -0.0
      ],
      "plane_d": 420.1769714355469,
      "bbox_min": [
        -240.61631774902344,
        1133.9915771484375,
        75.0
      ],
      "bbox_max": [
        -236.79795837402344,
        1139.8575439453125,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5455361604690552,
        0.838087260723114,
        0.0
      ],
      "plane_d": -1057.0228271484375,
      "bbox_min": [
        -237.14999389648438,
        1115.0986328125,
        95.0
      ],
      "bbox_max": [
        -197.011962890625,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20686249434947968,
        0.9783700108528137,
        0.0
      ],
      "plane_d": -1065.7515869140625,
      "bbox_min": [
        -199.3573760986328,
        1130.9688720703125,
        95.0
      ],
      "bbox_max": [
        -197.011962890625,
        1131.4647216796875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1121.7320556640625,
      "bbox_min": [
        -237.14999389648438,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -222.0,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551382422447205,
        0.5184000730514526,
        0.0
      ],
      "plane_d": -774.0403442382812,
      "bbox_min": [
        -226.1999969482422,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -222.0,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8551382422447205,
        0.5184000730514526,
        0.0
      ],
      "plane_d": -390.76739501953125,
      "bbox_min": [
        -223.0500030517578,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -222.0,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8551382422447205,
        -0.5184000730514526,
        0.0
      ],
      "plane_d": 770.4487915039062,
      "bbox_min": [
        -223.0500030517578,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -222.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1139.7320556640625,
      "bbox_min": [
        -237.14999389648438,
        1136.2679443359375,
        95.0
      ],
      "bbox_max": [
        -234.0,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1136.2679443359375,
      "bbox_min": [
        -237.14999389648438,
        1136.2679443359375,
        95.0
      ],
      "bbox_max": [
        -234.0,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8551382422447205,
        0.5184000730514526,
        0.0
      ],
      "plane_d": -389.8369445800781,
      "bbox_min": [
        -235.0500030517578,
        1136.2679443359375,
        95.0
      ],
      "bbox_max": [
        -234.0,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8551382422447205,
        -0.5184000730514526,
        0.0
      ],
      "plane_d": 790.0416259765625,
      "bbox_min": [
        -235.0500030517578,
        1136.2679443359375,
        95.0
      ],
      "bbox_max": [
        -234.0,
        1138.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 609.4187622070312,
      "bbox_min": [
        -189.29701232910156,
        1148.3199462890625,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1200.363037109375,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -189.29701232910156,
        1165.0,
        95.0
      ],
      "bbox_max": [
        -170.4713134765625,
        1180.9332275390625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -189.29701232910156,
        1165.0,
        131.0
      ],
      "bbox_max": [
        -170.47137451171875,
        1180.93310546875,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -0.0
      ],
      "plane_d": -286.0609436035156,
      "bbox_min": [
        -177.07107543945312,
        1148.3199462890625,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1200.363037109375,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -177.07107543945312,
        1162.928955078125,
        95.0
      ],
      "bbox_max": [
        -172.07107543945312,
        1170.0,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -177.071044921875,
        1162.928955078125,
        131.0
      ],
      "bbox_max": [
        -172.07107543945312,
        1170.0,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1153.3199462890625,
      "bbox_min": [
        -175.00001525878906,
        1148.3199462890625,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1200.363037109375,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -172.07107543945312,
        1177.071044921875,
        95.0
      ],
      "bbox_max": [
        -132.36288452148438,
        1200.363037109375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380875587463379,
        -0.5455357432365417,
        0.0
      ],
      "plane_d": 540.175537109375,
      "bbox_min": [
        -172.07107543945312,
        1177.071044921875,
        95.0
      ],
      "bbox_max": [
        -132.36288452148438,
        1200.363037109375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4038896858692169,
        -0.26290363073349,
        -0.8762161731719971
      ],
      "plane_d": 365.4664001464844,
      "bbox_min": [
        -172.07107543945312,
        1177.071044921875,
        120.0
      ],
      "bbox_max": [
        -132.36288452148438,
        1200.363037109375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -172.07107543945312,
        1177.071044921875,
        131.0
      ],
      "bbox_max": [
        -151.15890502929688,
        1190.3486328125,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1134.84228515625,
      "bbox_min": [
        -175.00001525878906,
        1148.3199462890625,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1193.5189208984375,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -165.0000457763672,
        1148.3199462890625,
        95.0
      ],
      "bbox_max": [
        -124.75238037109375,
        1176.671142578125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26290392875671387,
        0.40389078855514526,
        -0.8762155771255493
      ],
      "plane_d": -394.6158142089844,
      "bbox_min": [
        -165.0,
        1148.3199462890625,
        95.0
      ],
      "bbox_max": [
        -124.75238037109375,
        1176.671142578125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6006801724433899,
        0.12700723111629486,
        -0.7893367409706116
      ],
      "plane_d": -129.66162109375,
      "bbox_min": [
        -165.0,
        1148.3199462890625,
        95.0
      ],
      "bbox_max": [
        -124.75238037109375,
        1176.671142578125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.545535147190094,
        0.8380879163742065,
        0.0
      ],
      "plane_d": -1037.0234375,
      "bbox_min": [
        -165.0,
        1148.3199462890625,
        95.0
      ],
      "bbox_max": [
        -129.78054809570312,
        1170.7982177734375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -165.0,
        1157.6002197265625,
        129.8446502685547
      ],
      "bbox_max": [
        -138.9307403564453,
        1170.7982177734375,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.4038896858692169,
        -0.26290363073349,
        -0.8762161731719971
      ],
      "plane_d": 365.4664001464844,
      "bbox_min": [
        -140.9049072265625,
        1169.6522216796875,
        129.8446502685547
      ],
      "bbox_max": [
        -138.9307403564453,
        1170.7982177734375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1027.03369140625,
      "bbox_min": [
        -175.00001525878906,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1193.5189208984375,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -165.00003051757812,
        1170.0,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1193.5189208984375,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4038896858692169,
        -0.26290363073349,
        -0.8762161731719971
      ],
      "plane_d": 365.4664001464844,
      "bbox_min": [
        -165.0,
        1170.0,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1193.5189208984375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -165.0,
        1170.0338134765625,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1185.7332763671875,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238695502281189,
        0.3827075660228729,
        0.0
      ],
      "plane_d": -305.5682678222656,
      "bbox_min": [
        -159.23541259765625,
        1176.5299072265625,
        95.0
      ],
      "bbox_max": [
        -156.6223907470703,
        1178.3775634765625,
        106.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826913833618164,
        -0.9238762259483337,
        0.0
      ],
      "plane_d": 1147.906005859375,
      "bbox_min": [
        -159.23541259765625,
        1176.5299072265625,
        95.0
      ],
      "bbox_max": [
        -156.6223907470703,
        1178.3775634765625,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -106.0,
      "bbox_min": [
        -157.92892456054688,
        1176.5299072265625,
        105.0
      ],
      "bbox_max": [
        -156.6223907470703,
        1177.4537353515625,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -157.92892456054688,
        1176.5299072265625,
        105.0
      ],
      "bbox_max": [
        -156.62240600585938,
        1177.4537353515625,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 304.5385437011719,
      "bbox_min": [
        -175.00001525878906,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -140.8578643798828,
        1180.0001220703125,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -157.92893981933594,
        1165.0,
        95.0
      ],
      "bbox_max": [
        -140.8578643798828,
        1177.0711669921875,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238695502281189,
        0.3827075958251953,
        -0.0
      ],
      "plane_d": -305.568115234375,
      "bbox_min": [
        -157.92892456054688,
        1169.076171875,
        95.0
      ],
      "bbox_max": [
        -153.6934356689453,
        1177.071044921875,
        106.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826913833618164,
        0.9238762259483337,
        0.0
      ],
      "plane_d": -1140.2523193359375,
      "bbox_min": [
        -157.92892456054688,
        1170.0,
        95.0
      ],
      "bbox_max": [
        -154.0761260986328,
        1177.071044921875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -157.92892456054688,
        1170.0,
        105.0
      ],
      "bbox_max": [
        -154.0761260986328,
        1177.071044921875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4038896858692169,
        -0.26290363073349,
        -0.8762161731719971
      ],
      "plane_d": 365.4664001464844,
      "bbox_min": [
        -140.9396514892578,
        1169.98046875,
        130.9724578857422
      ],
      "bbox_max": [
        -140.8578643798828,
        1170.0338134765625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -590.941162109375,
      "bbox_min": [
        -175.00001525878906,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -152.92892456054688,
        1180.0001220703125,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -157.92893981933594,
        1162.928955078125,
        95.0
      ],
      "bbox_max": [
        -152.92892456054688,
        1170.0,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -155.54119873046875,
        1168.693359375,
        106.0
      ],
      "bbox_max": [
        -154.6173095703125,
        1170.0,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -175.00001525878906,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -155.0,
        1180.0001220703125,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -222.17942810058594,
        1097.7781982421875,
        250.0
      ],
      "bbox_max": [
        -109.5,
        1201.7012939453125,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 383.1253662109375,
      "bbox_min": [
        -222.17942810058594,
        1125.0986328125,
        402.0
      ],
      "bbox_max": [
        -207.17942810058594,
        1151.0794677734375,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -186.9999542236328,
        1097.7781982421875,
        250.0
      ],
      "bbox_max": [
        -109.5,
        1201.701171875,
        320.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 304.5385437011719,
      "bbox_min": [
        -175.0,
        1160.0,
        270.0
      ],
      "bbox_max": [
        -154.0761260986328,
        1180.0,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -157.92892456054688,
        1170.0,
        310.0
      ],
      "bbox_max": [
        -154.0761260986328,
        1177.4537353515625,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1027.03369140625,
      "bbox_min": [
        -175.0,
        1160.0,
        270.0
      ],
      "bbox_max": [
        -155.0,
        1180.0,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1153.3199462890625,
      "bbox_min": [
        -175.0,
        1160.0,
        270.0
      ],
      "bbox_max": [
        -155.0,
        1180.0,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826856315135956,
        0.9238786101341248,
        -0.0
      ],
      "plane_d": -1008.5560302734375,
      "bbox_min": [
        -175.0,
        1160.0,
        270.0
      ],
      "bbox_max": [
        -155.0,
        1177.071044921875,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1134.84228515625,
      "bbox_min": [
        -175.0,
        1160.0,
        270.0
      ],
      "bbox_max": [
        -155.0,
        1177.071044921875,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 609.4187622070312,
      "bbox_min": [
        -175.0,
        1162.928955078125,
        270.0
      ],
      "bbox_max": [
        -155.0,
        1177.071044921875,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -0.0
      ],
      "plane_d": -286.0609436035156,
      "bbox_min": [
        -175.0,
        1162.928955078125,
        270.0
      ],
      "bbox_max": [
        -155.0,
        1170.0,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -590.941162109375,
      "bbox_min": [
        -157.92892456054688,
        1162.928955078125,
        270.0
      ],
      "bbox_max": [
        -155.0,
        1170.0,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1153.3199462890625,
      "bbox_min": [
        -175.0,
        1160.0,
        250.0
      ],
      "bbox_max": [
        -154.0761260986328,
        1180.0,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826856315135956,
        0.9238786101341248,
        -0.0
      ],
      "plane_d": -1008.5560302734375,
      "bbox_min": [
        -175.0,
        1160.0,
        250.0
      ],
      "bbox_max": [
        -154.0761260986328,
        1180.0,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1134.84228515625,
      "bbox_min": [
        -175.0,
        1160.0,
        250.0
      ],
      "bbox_max": [
        -154.0761260986328,
        1180.0,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 609.4187622070312,
      "bbox_min": [
        -175.0,
        1162.928955078125,
        250.0
      ],
      "bbox_max": [
        -154.0761260986328,
        1180.0,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -0.0
      ],
      "plane_d": -286.0609436035156,
      "bbox_min": [
        -175.0,
        1162.928955078125,
        250.0
      ],
      "bbox_max": [
        -154.0761260986328,
        1180.0,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -590.941162109375,
      "bbox_min": [
        -165.0,
        1162.928955078125,
        250.0
      ],
      "bbox_max": [
        -154.0761260986328,
        1180.0,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826913833618164,
        0.9238762259483337,
        0.0
      ],
      "plane_d": -1140.2523193359375,
      "bbox_min": [
        -155.0,
        1170.0,
        250.0
      ],
      "bbox_max": [
        -154.0761260986328,
        1171.3065185546875,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        -155.0,
        1170.0,
        260.0
      ],
      "bbox_max": [
        -154.0761260986328,
        1171.3065185546875,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        -157.92892456054688,
        1176.5299072265625,
        260.0
      ],
      "bbox_max": [
        -156.62240600585938,
        1177.4537353515625,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        -0.0
      ],
      "plane_d": 304.5385437011719,
      "bbox_min": [
        -157.92892456054688,
        1170.0,
        260.0
      ],
      "bbox_max": [
        -154.45880126953125,
        1177.071044921875,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        -157.92892456054688,
        1170.0,
        260.0
      ],
      "bbox_max": [
        -154.45880126953125,
        1177.071044921875,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660242557525635,
        0.5000020861625671,
        0.0
      ],
      "plane_d": -363.1293029785156,
      "bbox_min": [
        -615.3160400390625,
        1074.5020751953125,
        60.0
      ],
      "bbox_max": [
        -134.50001525878906,
        1210.361328125,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999701976776,
        0.8660255074501038,
        0.0
      ],
      "plane_d": -783.4539794921875,
      "bbox_min": [
        -615.3160400390625,
        1074.5020751953125,
        60.0
      ],
      "bbox_max": [
        -239.49996948242188,
        1210.361328125,
        500.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.9952487945556641,
        0.09736471623182297,
        -0.0
      ],
      "plane_d": 494.5460205078125,
      "bbox_min": [
        -615.3160400390625,
        1097.7781982421875,
        60.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1210.361328125,
        250.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1259.215087890625,
      "bbox_min": [
        -528.278564453125,
        1097.7781982421875,
        60.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1201.0435791015625,
        250.00001525878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -520.1583862304688,
        1097.7781982421875,
        60.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1171.51123046875,
        151.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -409.6885070800781,
        1097.7781982421875,
        60.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1141.04345703125,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660203218460083,
        -0.5000088214874268,
        2.6428842829773203e-06
      ],
      "plane_d": 925.1128540039062,
      "bbox_min": [
        -409.6875,
        1140.6104736328125,
        60.0
      ],
      "bbox_max": [
        -409.4375,
        1141.04345703125,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -409.6885070800781,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1141.04345703125,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 335.5,
      "bbox_min": [
        -335.5,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1098.3555908203125,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648231029510498,
        -0.5020767450332642,
        0.0
      ],
      "plane_d": 926.982421875,
      "bbox_min": [
        -409.6885070800781,
        1140.611083984375,
        75.0
      ],
      "bbox_max": [
        -409.4375,
        1141.04345703125,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -424.6260986328125,
        1097.7781982421875,
        60.0
      ],
      "bbox_max": [
        -335.49993896484375,
        1140.611083984375,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660266995429993,
        -0.4999977946281433,
        0.0
      ],
      "plane_d": 925.1030883789062,
      "bbox_min": [
        -421.9375,
        1119.392822265625,
        60.0
      ],
      "bbox_max": [
        -409.6874694824219,
        1140.6104736328125,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999999403953552,
        0.866025447845459,
        0.0
      ],
      "plane_d": -753.4537963867188,
      "bbox_min": [
        -424.6260986328125,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -336.5,
        1140.611083984375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648231029510498,
        -0.5020767450332642,
        0.0
      ],
      "plane_d": 926.9824829101562,
      "bbox_min": [
        -424.6260986328125,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -336.5,
        1140.611083984375,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5020793676376343,
        -0.8648215532302856,
        -0.0
      ],
      "plane_d": 773.7288208007812,
      "bbox_min": [
        -417.09478759765625,
        1134.5572509765625,
        75.0
      ],
      "bbox_max": [
        -413.2030944824219,
        1136.816650390625,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -336.5,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -336.5,
        1098.3555908203125,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -520.1583862304688,
        1097.7781982421875,
        78.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1171.51123046875,
        151.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        -520.1583862304688,
        1100.0,
        120.0
      ],
      "bbox_max": [
        -409.91668701171875,
        1171.51123046875,
        151.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        -520.1583862304688,
        1100.0,
        120.0
      ],
      "bbox_max": [
        -409.91668701171875,
        1171.51123046875,
        151.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        -500.0,
        1100.0,
        140.0
      ],
      "bbox_max": [
        -480.0,
        1110.0,
        151.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -500.0,
        1100.0,
        140.0
      ],
      "bbox_max": [
        -480.0,
        1110.0,
        151.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -141.0,
      "bbox_min": [
        -500.0,
        1100.0,
        140.0
      ],
      "bbox_max": [
        -480.0,
        1110.0,
        151.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        -490.0,
        1100.0,
        140.0
      ],
      "bbox_max": [
        -490.0,
        1110.0,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 151.0,
      "bbox_min": [
        -500.0,
        1100.0,
        141.0
      ],
      "bbox_max": [
        -480.0,
        1110.0,
        151.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        -480.0,
        1100.0,
        141.0
      ],
      "bbox_max": [
        -480.0,
        1110.0,
        151.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        -520.1583862304688,
        1100.0,
        120.0
      ],
      "bbox_max": [
        -409.91668701171875,
        1171.51123046875,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2419619858264923,
        0.41677382588386536,
        -0.8762156963348389
      ],
      "plane_d": -247.24679565429688,
      "bbox_min": [
        -520.1583862304688,
        1120.0,
        120.0
      ],
      "bbox_max": [
        -409.91668701171875,
        1171.51123046875,
        131.28785705566406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020562084391713142,
        -0.030843129381537437,
        -0.999312698841095
      ],
      "plane_d": 156.85520935058594,
      "bbox_min": [
        -432.18994140625,
        1120.0,
        131.20782470703125
      ],
      "bbox_max": [
        -431.9201965332031,
        1120.118896484375,
        131.28785705566406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.871756911277771,
        -0.4899386465549469,
        0.0
      ],
      "plane_d": 925.495849609375,
      "bbox_min": [
        -432.18994140625,
        1120.0,
        120.0
      ],
      "bbox_max": [
        -409.91668701171875,
        1145.8060302734375,
        131.28280639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8700023889541626,
        0.4930475056171417,
        0.0
      ],
      "plane_d": -919.353515625,
      "bbox_min": [
        -421.99920654296875,
        1120.0,
        120.0
      ],
      "bbox_max": [
        -409.91668701171875,
        1141.320068359375,
        130.9424285888672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -496.9107666015625,
        1122.90625,
        120.0
      ],
      "bbox_max": [
        -450.44464111328125,
        1171.51123046875,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.1574774533510208,
        0.5934208035469055,
        -0.7893368005752563
      ],
      "plane_d": -646.87548828125,
      "bbox_min": [
        -477.7826843261719,
        1122.90625,
        120.0
      ],
      "bbox_max": [
        -450.44464111328125,
        1140.20263671875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        -500.0,
        1100.0,
        120.0
      ],
      "bbox_max": [
        -421.99920654296875,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8700023889541626,
        0.4930475056171417,
        0.0
      ],
      "plane_d": -919.353515625,
      "bbox_min": [
        -440.0,
        1100.0,
        120.0
      ],
      "bbox_max": [
        -421.99920654296875,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        -440.0,
        1100.0,
        120.0
      ],
      "bbox_max": [
        -421.99920654296875,
        1120.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0365307480096817,
        -0.016438838094472885,
        -0.9991973042488098
      ],
      "plane_d": 133.83287048339844,
      "bbox_min": [
        -440.0,
        1105.0,
        120.0
      ],
      "bbox_max": [
        -421.99920654296875,
        1120.0,
        131.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1105.0,
      "bbox_min": [
        -440.0,
        1105.0,
        120.0
      ],
      "bbox_max": [
        -430.4916076660156,
        1120.0,
        131.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.5,
      "bbox_min": [
        -440.0,
        1105.0,
        120.0
      ],
      "bbox_max": [
        -430.4916076660156,
        1120.0,
        131.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.871756911277771,
        -0.4899386465549469,
        0.0
      ],
      "plane_d": 925.495849609375,
      "bbox_min": [
        -440.0,
        1115.0,
        120.0
      ],
      "bbox_max": [
        -430.4916076660156,
        1120.0,
        131.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1115.0,
      "bbox_min": [
        -440.0,
        1115.0,
        120.0
      ],
      "bbox_max": [
        -435.0,
        1115.0,
        131.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020562084391713142,
        -0.030843129381537437,
        -0.999312698841095
      ],
      "plane_d": 156.85520935058594,
      "bbox_min": [
        -435.0,
        1115.0,
        131.25291442871094
      ],
      "bbox_max": [
        -430.4916076660156,
        1120.0,
        131.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -520.1583862304688,
        1097.7781982421875,
        78.0
      ],
      "bbox_max": [
        -335.5,
        1171.51123046875,
        120.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.5020793676376343,
        -0.8648215532302856,
        -0.0
      ],
      "plane_d": 773.7288208007812,
      "bbox_min": [
        -446.6790466308594,
        1097.7781982421875,
        78.0
      ],
      "bbox_max": [
        -335.5,
        1149.61962890625,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648231029510498,
        -0.5020767450332642,
        0.0
      ],
      "plane_d": 926.982421875,
      "bbox_min": [
        -413.2030944824219,
        1097.7781982421875,
        78.0
      ],
      "bbox_max": [
        -335.5,
        1141.04345703125,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -336.5,
        1097.7781982421875,
        78.0
      ],
      "bbox_max": [
        -335.5,
        1098.9329833984375,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -336.5,
        1098.6800537109375,
        78.5
      ],
      "bbox_max": [
        -336.0618896484375,
        1098.9329833984375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5020793676376343,
        0.8648215532302856,
        -0.0
      ],
      "plane_d": -758.7286987304688,
      "bbox_min": [
        -446.6790466308594,
        1115.0986328125,
        78.0
      ],
      "bbox_max": [
        -420.7344055175781,
        1136.647216796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648231029510498,
        -0.5020767450332642,
        0.0
      ],
      "plane_d": 926.9824829101562,
      "bbox_min": [
        -424.5,
        1115.0986328125,
        78.0
      ],
      "bbox_max": [
        -420.7344055175781,
        1121.5848388671875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        -520.1583862304688,
        1097.7781982421875,
        95.0
      ],
      "bbox_max": [
        -394.5001220703125,
        1147.5079345703125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999999403953552,
        0.866025447845459,
        -0.0
      ],
      "plane_d": -753.4537963867188,
      "bbox_min": [
        -398.348388671875,
        1097.7781982421875,
        95.0
      ],
      "bbox_max": [
        -394.5001220703125,
        1100.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        -520.1583862304688,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -398.348388671875,
        1147.5079345703125,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5020800828933716,
        0.8648211359977722,
        0.0
      ],
      "plane_d": -731.2279052734375,
      "bbox_min": [
        -520.1583862304688,
        1120.0,
        95.0
      ],
      "bbox_max": [
        -412.95001220703125,
        1147.5079345703125,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        -500.0,
        1120.0,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1135.8046875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -500.0,
        1120.0,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1135.8046875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        -490.0,
        1120.0,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1129.9991455078125,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2564944922924042,
        0.9665457010269165,
        0.0
      ],
      "plane_d": -1207.8887939453125,
      "bbox_min": [
        -477.7826843261719,
        1120.0,
        95.0
      ],
      "bbox_max": [
        -412.95001220703125,
        1140.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.855134904384613,
        0.518405556678772,
        -0.0
      ],
      "plane_d": -218.97767639160156,
      "bbox_min": [
        -450.44464111328125,
        1120.0,
        95.0
      ],
      "bbox_max": [
        -412.95001220703125,
        1139.3277587890625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551415801048279,
        0.5183945298194885,
        0.0
      ],
      "plane_d": -945.8328247070312,
      "bbox_min": [
        -450.44464111328125,
        1120.0,
        95.0
      ],
      "bbox_max": [
        -423.95001220703125,
        1130.1610107421875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1121.7320556640625,
      "bbox_min": [
        -426.0500183105469,
        1121.7320556640625,
        95.0
      ],
      "bbox_max": [
        -423.95001220703125,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5020793676376343,
        0.8648215532302856,
        0.0
      ],
      "plane_d": -751.2286376953125,
      "bbox_min": [
        -450.44464111328125,
        1120.0,
        95.0
      ],
      "bbox_max": [
        -432.9366149902344,
        1130.1610107421875,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 435.0,
      "bbox_min": [
        -435.0,
        1120.0,
        95.0
      ],
      "bbox_max": [
        -432.9366149902344,
        1121.1944580078125,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -435.0,
        1120.0,
        105.0
      ],
      "bbox_max": [
        -432.9366149902344,
        1121.1944580078125,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1137.2679443359375,
      "bbox_min": [
        -416.1000061035156,
        1137.2679443359375,
        95.0
      ],
      "bbox_max": [
        -412.95001220703125,
        1139.3277587890625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551415801048279,
        -0.5183945298194885,
        0.0
      ],
      "plane_d": 234.626953125,
      "bbox_min": [
        -416.1000061035156,
        1137.2679443359375,
        95.0
      ],
      "bbox_max": [
        -415.0500183105469,
        1139.3277587890625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551415801048279,
        0.5183945298194885,
        0.0
      ],
      "plane_d": -946.2757568359375,
      "bbox_min": [
        -416.1000061035156,
        1139.0,
        95.0
      ],
      "bbox_max": [
        -415.9012756347656,
        1139.3277587890625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.7320556640625,
      "bbox_min": [
        -415.9012756347656,
        1139.3277587890625,
        95.0
      ],
      "bbox_max": [
        -412.95001220703125,
        1140.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551415801048279,
        0.5183945298194885,
        0.0
      ],
      "plane_d": -946.2757568359375,
      "bbox_min": [
        -415.9012756347656,
        1139.3277587890625,
        95.0
      ],
      "bbox_max": [
        -415.0500183105469,
        1140.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999403953552,
        0.866025447845459,
        -0.0
      ],
      "plane_d": -753.4537963867188,
      "bbox_min": [
        -500.0,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -398.348388671875,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34818652272224426,
        0.0,
        0.9374252557754517
      ],
      "plane_d": -259.66680908203125,
      "bbox_min": [
        -500.0,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        -490.0,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1120.0,
        111.71430969238281
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -445.0,
      "bbox_min": [
        -445.0,
        1100.0,
        110.71429443359375
      ],
      "bbox_max": [
        -445.0,
        1110.0,
        111.71430969238281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 107.0,
      "bbox_min": [
        -455.0,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1110.0,
        110.71429443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -445.0,
      "bbox_min": [
        -452.3076477050781,
        1100.0,
        107.0
      ],
      "bbox_max": [
        -445.0,
        1110.0,
        110.71429443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -108.0,
      "bbox_min": [
        -452.3076477050781,
        1100.0,
        108.0
      ],
      "bbox_max": [
        -445.0,
        1110.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1105.0,
      "bbox_min": [
        -445.0,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1110.0,
        107.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -445.0,
      "bbox_min": [
        -445.0,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -445.0,
        1105.0,
        107.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -445.0,
      "bbox_min": [
        -445.0,
        1105.0,
        105.0
      ],
      "bbox_max": [
        -445.0,
        1110.0,
        107.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 107.0,
      "bbox_min": [
        -456.4000244140625,
        1110.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1120.0,
        111.71430969238281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -108.0,
      "bbox_min": [
        -456.4000244140625,
        1110.0,
        107.0
      ],
      "bbox_max": [
        -445.0,
        1120.0,
        111.71430969238281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3243243098258972,
        -0.0,
        -0.9459459185600281
      ],
      "plane_d": -46.351348876953125,
      "bbox_min": [
        -456.4000244140625,
        1110.0,
        107.0
      ],
      "bbox_max": [
        -445.0,
        1120.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -445.0,
      "bbox_min": [
        -445.0,
        1110.0,
        107.0
      ],
      "bbox_max": [
        -445.0,
        1120.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -445.0,
      "bbox_min": [
        -445.0,
        1110.0,
        108.0
      ],
      "bbox_max": [
        -445.0,
        1120.0,
        111.71430969238281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1115.0,
      "bbox_min": [
        -445.0,
        1110.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1120.0,
        107.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 435.0,
      "bbox_min": [
        -445.0,
        1115.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1120.0,
        107.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.0,
      "bbox_min": [
        -435.0,
        1115.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1120.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -435.0,
        1115.0,
        105.0
      ],
      "bbox_max": [
        -430.0,
        1120.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -445.0,
        1110.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1115.0,
        107.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -445.0,
      "bbox_min": [
        -445.0,
        1110.0,
        105.0
      ],
      "bbox_max": [
        -445.0,
        1115.0,
        107.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.0,
      "bbox_min": [
        -430.0,
        1110.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1115.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3243243098258972,
        -0.0,
        0.9459459185600281
      ],
      "plane_d": 45.40540313720703,
      "bbox_min": [
        -500.0,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -445.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3243243098258972,
        -0.0,
        -0.9459459185600281
      ],
      "plane_d": -46.351348876953125,
      "bbox_min": [
        -500.0,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -455.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -490.0,
        1100.0,
        107.48001098632812
      ],
      "bbox_max": [
        -455.0,
        1110.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 119.0,
      "bbox_min": [
        -490.0,
        1100.0,
        119.0
      ],
      "bbox_max": [
        -487.0833435058594,
        1110.0,
        119.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        -500.0,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1120.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 119.0,
      "bbox_min": [
        -500.0,
        1100.0,
        119.0
      ],
      "bbox_max": [
        -490.0,
        1120.0,
        119.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        -490.0,
        1100.0,
        111.71430969238281
      ],
      "bbox_max": [
        -445.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 119.0,
      "bbox_min": [
        -487.0833435058594,
        1100.0,
        111.71430969238281
      ],
      "bbox_max": [
        -445.0,
        1110.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -445.0,
      "bbox_min": [
        -445.0,
        1100.0,
        119.0
      ],
      "bbox_max": [
        -445.0,
        1110.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -455.0,
      "bbox_min": [
        -455.0,
        1110.0,
        119.0
      ],
      "bbox_max": [
        -445.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -445.0,
      "bbox_min": [
        -445.0,
        1110.0,
        119.0
      ],
      "bbox_max": [
        -445.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -445.0,
      "bbox_min": [
        -445.0,
        1110.0,
        111.71430969238281
      ],
      "bbox_max": [
        -445.0,
        1120.0,
        119.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551415801048279,
        -0.5183945298194885,
        0.0
      ],
      "plane_d": 215.3708953857422,
      "bbox_min": [
        -432.9894714355469,
        1115.0986328125,
        95.0
      ],
      "bbox_max": [
        -422.8999938964844,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1118.2679443359375,
      "bbox_min": [
        -426.0500183105469,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -422.8999938964844,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.855134904384613,
        -0.518405556678772,
        0.0
      ],
      "plane_d": 942.2507934570312,
      "bbox_min": [
        -423.95001220703125,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -422.8999938964844,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5020793676376343,
        0.8648215532302856,
        0.0
      ],
      "plane_d": -751.2286376953125,
      "bbox_min": [
        -432.9894714355469,
        1115.0986328125,
        95.0
      ],
      "bbox_max": [
        -424.5,
        1120.0,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.0,
      "bbox_min": [
        -432.9894714355469,
        1118.2740478515625,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1120.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -432.9894714355469,
        1118.2740478515625,
        105.0
      ],
      "bbox_max": [
        -430.0,
        1120.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.0,
      "bbox_min": [
        -432.9366149902344,
        1118.291748046875,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1120.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -432.9366149902344,
        1118.291748046875,
        105.0
      ],
      "bbox_max": [
        -430.0,
        1120.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -891.2019653320312,
      "bbox_min": [
        -528.278564453125,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -462.2093505859375,
        1201.0435791015625,
        250.00001525878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -482.9289245605469,
        1162.928955078125,
        95.0
      ],
      "bbox_max": [
        -462.2093505859375,
        1179.5086669921875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -482.9289245605469,
        1162.928955078125,
        131.0
      ],
      "bbox_max": [
        -462.2093505859375,
        1179.5086669921875,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 4.277719497680664,
      "bbox_min": [
        -528.278564453125,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -476.0613098144531,
        1201.0435791015625,
        250.00001525878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -486.4145812988281,
        1170.0,
        95.0
      ],
      "bbox_max": [
        -476.0613098144531,
        1185.486083984375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -486.41455078125,
        1170.0,
        131.0
      ],
      "bbox_max": [
        -476.0613098144531,
        1185.486083984375,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826856315135956,
        0.9238786101341248,
        -0.0
      ],
      "plane_d": -884.1832275390625,
      "bbox_min": [
        -528.278564453125,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -479.9999694824219,
        1201.0435791015625,
        250.00001525878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -528.278564453125,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -489.9999694824219,
        1175.7572021484375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5934197306632996,
        0.1574786901473999,
        -0.7893373966217041
      ],
      "plane_d": 223.11911010742188,
      "bbox_min": [
        -528.278564453125,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1175.7572021484375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2419619858264923,
        0.41677382588386536,
        -0.8762156963348389
      ],
      "plane_d": -247.24679565429688,
      "bbox_min": [
        -528.278564453125,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1175.7572021484375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648213148117065,
        -0.5020797848701477,
        0.0
      ],
      "plane_d": 1046.985107421875,
      "bbox_min": [
        -528.278564453125,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1175.7572021484375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41677308082580566,
        -0.24196134507656097,
        -0.8762162327766418
      ],
      "plane_d": 609.7070922851562,
      "bbox_min": [
        -528.278564453125,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1175.7572021484375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -521.0237426757812,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1168.0350341796875,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5020800828933716,
        0.8648211359977722,
        0.0
      ],
      "plane_d": -731.2279052734375,
      "bbox_min": [
        -521.0237426757812,
        1147.5078125,
        95.0
      ],
      "bbox_max": [
        -520.1583862304688,
        1148.01025390625,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 902.6608276367188,
      "bbox_min": [
        -528.0411376953125,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -479.9999694824219,
        1201.0435791015625,
        250.00001525878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -518.680908203125,
        1177.071044921875,
        95.0
      ],
      "bbox_max": [
        -482.9289245605469,
        1201.0435791015625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648213148117065,
        -0.5020797848701477,
        0.0
      ],
      "plane_d": 1046.985107421875,
      "bbox_min": [
        -518.680908203125,
        1177.071044921875,
        95.0
      ],
      "bbox_max": [
        -482.9289245605469,
        1201.0435791015625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41677308082580566,
        -0.24196134507656097,
        -0.8762162327766418
      ],
      "plane_d": 609.7070922851562,
      "bbox_min": [
        -518.680908203125,
        1177.071044921875,
        120.0
      ],
      "bbox_max": [
        -482.9289245605469,
        1201.0435791015625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -500.037841796875,
        1177.071044921875,
        131.0
      ],
      "bbox_max": [
        -482.9289245605469,
        1191.0435791015625,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1277.6927490234375,
      "bbox_min": [
        -528.0411376953125,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -479.9999694824219,
        1191.8800048828125,
        250.00001525878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -528.0411376953125,
        1170.0,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1191.8800048828125,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.41677308082580566,
        -0.24196134507656097,
        -0.8762162327766418
      ],
      "plane_d": 609.7070922851562,
      "bbox_min": [
        -528.0411376953125,
        1170.0,
        95.0
      ],
      "bbox_max": [
        -490.0,
        1191.8800048828125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238695502281189,
        0.3827075958251953,
        0.0
      ],
      "plane_d": -910.702880859375,
      "bbox_min": [
        -498.377685546875,
        1176.52978515625,
        95.0
      ],
      "bbox_max": [
        -495.76458740234375,
        1178.3775634765625,
        106.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38268598914146423,
        -0.9238784909248352,
        0.0
      ],
      "plane_d": 897.2484741210938,
      "bbox_min": [
        -498.377685546875,
        1176.52978515625,
        95.0
      ],
      "bbox_max": [
        -495.76458740234375,
        1178.3775634765625,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -106.0,
      "bbox_min": [
        -497.9949645996094,
        1177.071044921875,
        106.0
      ],
      "bbox_max": [
        -495.76458740234375,
        1178.3775634765625,
        106.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -106.0,
      "bbox_min": [
        -498.37762451171875,
        1176.5299072265625,
        106.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.4537353515625,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 909.6795654296875,
      "bbox_min": [
        -514.1420288085938,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -479.9999694824219,
        1180.0,
        250.00001525878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -514.1420288085938,
        1165.0,
        95.0
      ],
      "bbox_max": [
        -497.071044921875,
        1177.0711669921875,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -514.1420288085938,
        1165.0,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238695502281189,
        0.3827075660228729,
        0.0
      ],
      "plane_d": -910.70263671875,
      "bbox_min": [
        -514.1420288085938,
        1168.0350341796875,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826913833618164,
        -0.9238762259483337,
        -0.0
      ],
      "plane_d": 888.5895385742188,
      "bbox_min": [
        -501.30657958984375,
        1169.076171875,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268598914146423,
        0.9238784909248352,
        0.0
      ],
      "plane_d": -889.5948486328125,
      "bbox_min": [
        -500.92388916015625,
        1170.0,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -500.92388916015625,
        1170.0,
        105.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41677308082580566,
        -0.24196134507656097,
        -0.8762162327766418
      ],
      "plane_d": 609.7070922851562,
      "bbox_min": [
        -514.1420288085938,
        1168.0350341796875,
        128.200927734375
      ],
      "bbox_max": [
        -506.3941345214844,
        1173.2093505859375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -0.0
      ],
      "plane_d": 14.199869155883789,
      "bbox_min": [
        -502.0710754394531,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -479.9999694824219,
        1180.0,
        250.00001525878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -502.0710754394531,
        1162.928955078125,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1170.0,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -106.0,
      "bbox_min": [
        -500.3826599121094,
        1168.6934814453125,
        95.0
      ],
      "bbox_max": [
        -499.4588317871094,
        1170.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -500.3826599121094,
        1168.6934814453125,
        95.0
      ],
      "bbox_max": [
        -499.4588317871094,
        1170.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -502.071044921875,
        1162.928955078125,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1169.076171875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -500.0,
        1160.0,
        95.0
      ],
      "bbox_max": [
        -479.9999694824219,
        1180.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -539.5,
        1097.7781982421875,
        250.0
      ],
      "bbox_max": [
        -461.9999694824219,
        1201.7012939453125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 909.6795654296875,
      "bbox_min": [
        -500.92388916015625,
        1160.0,
        250.0
      ],
      "bbox_max": [
        -480.0,
        1180.0,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38268598914146423,
        0.9238784909248352,
        0.0
      ],
      "plane_d": -889.5948486328125,
      "bbox_min": [
        -500.92388916015625,
        1170.0,
        300.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.4537353515625,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -500.92388916015625,
        1170.0,
        310.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.4537353515625,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 902.6608276367188,
      "bbox_min": [
        -500.0,
        1160.0,
        250.0
      ],
      "bbox_max": [
        -480.0,
        1180.0,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1277.6927490234375,
      "bbox_min": [
        -500.0,
        1160.0,
        250.0
      ],
      "bbox_max": [
        -480.0,
        1180.0,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826856315135956,
        0.9238786101341248,
        -0.0
      ],
      "plane_d": -884.1832275390625,
      "bbox_min": [
        -500.0,
        1160.0,
        250.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1259.215087890625,
      "bbox_min": [
        -500.0,
        1160.0,
        250.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -0.0
      ],
      "plane_d": 14.199869155883789,
      "bbox_min": [
        -500.0,
        1162.928955078125,
        250.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -891.2019653320312,
      "bbox_min": [
        -482.9289245605469,
        1162.928955078125,
        250.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 4.277719497680664,
      "bbox_min": [
        -482.9289245605469,
        1170.0,
        250.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -394.5001220703125,
        1074.5020751953125,
        75.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -394.5001220703125,
        1074.5020751953125,
        75.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999999403953552,
        0.866025447845459,
        -0.0
      ],
      "plane_d": -753.4537963867188,
      "bbox_min": [
        -394.5001220703125,
        1074.5020751953125,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1097.7781982421875,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8289903402328491,
        0.5592629313468933,
        -0.0
      ],
      "plane_d": -306.7905578613281,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        75.0
      ],
      "bbox_max": [
        -354.81549072265625,
        1075.0986328125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 335.5,
      "bbox_min": [
        -336.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -336.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -336.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1130.4095458984375,
      "bbox_min": [
        -514.4999389648438,
        1092.0047607421875,
        60.0
      ],
      "bbox_max": [
        -239.49996948242188,
        1210.361328125,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1101.0794677734375,
      "bbox_min": [
        -391.0191650390625,
        1092.0047607421875,
        60.0
      ],
      "bbox_max": [
        -257.9808349609375,
        1130.4095458984375,
        250.00003051757812
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -340.21795654296875,
        1092.0047607421875,
        64.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.080078125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 322.0,
      "bbox_min": [
        -322.0,
        1096.7496337890625,
        64.0
      ],
      "bbox_max": [
        -318.0,
        1101.0794677734375,
        71.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -322.0,
        1096.7496337890625,
        64.0
      ],
      "bbox_max": [
        -318.0,
        1101.0794677734375,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 181.7264404296875,
      "bbox_min": [
        -322.0,
        1096.7496337890625,
        64.0
      ],
      "bbox_max": [
        -321.0,
        1101.0794677734375,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -331.0,
        1096.74951171875,
        64.0
      ],
      "bbox_max": [
        -326.0,
        1101.0794677734375,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -276.478759765625,
      "bbox_min": [
        -331.0,
        1096.74951171875,
        64.0
      ],
      "bbox_max": [
        -326.0,
        1101.0794677734375,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 188.09039306640625,
      "bbox_min": [
        -331.0,
        1096.74951171875,
        64.0
      ],
      "bbox_max": [
        -330.0,
        1101.0794677734375,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -340.21795654296875,
        1092.0047607421875,
        75.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.080078125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -322.5,
      "bbox_min": [
        -340.21795654296875,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.5,
      "bbox_min": [
        -322.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 313.5,
      "bbox_min": [
        -314.5,
        1097.7783203125,
        75.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -314.5,
        1097.7783203125,
        78.04911804199219
      ],
      "bbox_max": [
        -313.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -314.5,
        1097.7783203125,
        78.04911804199219
      ],
      "bbox_max": [
        -313.5,
        1098.6800537109375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -313.5,
        1100.646484375,
        78.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.0794677734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 321.5,
      "bbox_min": [
        -322.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -321.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -322.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -321.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -322.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -321.5,
        1098.6800537109375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -328.5,
      "bbox_min": [
        -340.21795654296875,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -322.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 327.5,
      "bbox_min": [
        -328.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -322.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -328.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -327.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -328.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -327.5,
        1098.6800537109375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -327.5,
        1100.646484375,
        78.0
      ],
      "bbox_max": [
        -322.5,
        1101.0794677734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 335.5,
      "bbox_min": [
        -340.21795654296875,
        1098.3555908203125,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -340.21795654296875,
        1098.3555908203125,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -336.5,
        1098.3555908203125,
        78.33779907226562
      ],
      "bbox_max": [
        -335.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -336.0618896484375,
        1098.3555908203125,
        78.33779907226562
      ],
      "bbox_max": [
        -335.5,
        1098.6800537109375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -340.21795654296875,
        1100.646484375,
        78.0
      ],
      "bbox_max": [
        -336.5,
        1101.0794677734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -391.0191650390625,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -257.9808349609375,
        1130.4095458984375,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -370.1299133300781,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -279.8700866699219,
        1130.4095458984375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -536.1575317382812,
      "bbox_min": [
        -370.1299133300781,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -279.8700866699219,
        1130.4095458984375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -995.7769165039062,
      "bbox_min": [
        -370.1299133300781,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -279.8700866699219,
        1130.4095458984375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        -370.1299133300781,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -279.8700866699219,
        1130.4095458984375,
        118.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.25882261991500854,
        0.9659249782562256,
        -0.0
      ],
      "plane_d": -999.6504516601562,
      "bbox_min": [
        -344.8478088378906,
        1122.0,
        110.0
      ],
      "bbox_max": [
        -305.1521911621094,
        1130.4095458984375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882259011268616,
        0.965924859046936,
        0.0
      ],
      "plane_d": -1167.885009765625,
      "bbox_min": [
        -344.8478088378906,
        1122.0,
        110.0
      ],
      "bbox_max": [
        -305.1521911621094,
        1130.4095458984375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071049213409424,
        0.7071086764335632,
        -0.0
      ],
      "plane_d": -555.4788208007812,
      "bbox_min": [
        -344.8478088378906,
        1126.186767578125,
        110.0
      ],
      "bbox_max": [
        -305.1521911621094,
        1130.4095458984375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071049213409424,
        0.7071086764335632,
        0.0
      ],
      "plane_d": -1015.0970458984375,
      "bbox_min": [
        -309.375,
        1126.186767578125,
        110.0
      ],
      "bbox_max": [
        -305.1521911621094,
        1130.4095458984375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -370.1299133300781,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -279.8700866699219,
        1130.4095458984375,
        110.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -322.5,
      "bbox_min": [
        -356.9383850097656,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -293.0616149902344,
        1130.4095458984375,
        78.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.5,
      "bbox_min": [
        -322.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -293.0616149902344,
        1130.4095458984375,
        78.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 313.5,
      "bbox_min": [
        -314.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -293.0616149902344,
        1130.4095458984375,
        78.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -314.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -313.5,
        1125.5,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -314.5,
        1125.5,
        60.0
      ],
      "bbox_max": [
        -313.5,
        1125.5,
        60.99046325683594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -63.5,
      "bbox_min": [
        -314.5,
        1122.0,
        60.99046325683594
      ],
      "bbox_max": [
        -313.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -314.5,
        1124.5,
        60.99046325683594
      ],
      "bbox_max": [
        -313.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -559.6878051757812,
      "bbox_min": [
        -314.5,
        1124.5,
        63.0
      ],
      "bbox_max": [
        -313.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9837599992752075,
        -0.17948898673057556,
        -0.0
      ],
      "plane_d": -89.80921936035156,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -293.0616149902344,
        1130.4095458984375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -293.0616149902344,
        1130.4095458984375,
        64.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9837608337402344,
        0.17948433756828308,
        0.0
      ],
      "plane_d": 86.814697265625,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -293.0616149902344,
        1130.4095458984375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000129342079163,
        -0.8660179376602173,
        0.0
      ],
      "plane_d": 1118.72021484375,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -293.0616149902344,
        1130.4095458984375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9196140766143799,
        0.3928230106830597,
        0.0
      ],
      "plane_d": -716.7876586914062,
      "bbox_min": [
        -297.25,
        1128.8349609375,
        60.0
      ],
      "bbox_max": [
        -296.577392578125,
        1130.4095458984375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9196160435676575,
        -0.3928183913230896,
        0.0
      ],
      "plane_d": 713.7830200195312,
      "bbox_min": [
        -294.1368103027344,
        1128.486083984375,
        60.0
      ],
      "bbox_max": [
        -293.315185546875,
        1130.4095458984375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -702.5599365234375,
      "bbox_min": [
        -322.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -314.5,
        1125.5,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 321.5,
      "bbox_min": [
        -322.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -321.5,
        1125.5,
        78.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -322.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -321.5,
        1125.5,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -322.5,
        1125.5,
        60.0
      ],
      "bbox_max": [
        -321.5,
        1125.5,
        60.99046325683594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -63.5,
      "bbox_min": [
        -322.5,
        1122.0,
        60.99046325683594
      ],
      "bbox_max": [
        -321.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -322.5,
        1124.5,
        60.99046325683594
      ],
      "bbox_max": [
        -321.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -559.6878051757812,
      "bbox_min": [
        -322.5,
        1124.5,
        63.0
      ],
      "bbox_max": [
        -321.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 335.5,
      "bbox_min": [
        -356.9383850097656,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -327.5,
        1130.4095458984375,
        78.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -356.9383850097656,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -335.5,
        1130.4095458984375,
        78.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -336.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -335.5,
        1125.5,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -336.5,
        1125.5,
        60.0
      ],
      "bbox_max": [
        -335.5,
        1125.5,
        60.99046325683594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -63.5,
      "bbox_min": [
        -336.5,
        1122.0,
        60.99046325683594
      ],
      "bbox_max": [
        -335.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -336.5,
        1124.5,
        60.99046325683594
      ],
      "bbox_max": [
        -335.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -559.6878051757812,
      "bbox_min": [
        -336.5,
        1124.5,
        63.0
      ],
      "bbox_max": [
        -335.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9837599992752075,
        -0.17948898673057556,
        0.0
      ],
      "plane_d": 549.634765625,
      "bbox_min": [
        -356.9383850097656,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -352.75,
        1130.4095458984375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -356.9383850097656,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -352.75,
        1130.4095458984375,
        64.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9837608337402344,
        0.17948433756828308,
        0.0
      ],
      "plane_d": -552.6298217773438,
      "bbox_min": [
        -356.9383850097656,
        1122.5928955078125,
        60.0
      ],
      "bbox_max": [
        -352.75,
        1130.4095458984375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9196140766143799,
        0.3928230106830597,
        -0.0
      ],
      "plane_d": -119.03848266601562,
      "bbox_min": [
        -353.422607421875,
        1128.8349609375,
        60.0
      ],
      "bbox_max": [
        -352.75,
        1130.4095458984375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9196160435676575,
        -0.3928183913230896,
        0.0
      ],
      "plane_d": 116.0325927734375,
      "bbox_min": [
        -356.684814453125,
        1128.486083984375,
        60.0
      ],
      "bbox_max": [
        -355.8631896972656,
        1130.4095458984375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -702.5599365234375,
      "bbox_min": [
        -335.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -328.5,
      "bbox_min": [
        -328.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        78.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.5,
      "bbox_min": [
        -328.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        78.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -328.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -328.5,
        1125.5,
        60.0
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        60.99046325683594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -63.5,
      "bbox_min": [
        -328.5,
        1122.0,
        60.99046325683594
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -328.5,
        1124.5,
        60.99046325683594
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -559.6878051757812,
      "bbox_min": [
        -328.5,
        1124.5,
        63.0
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588195204734802,
        0.9659257531166077,
        0.0
      ],
      "plane_d": -980.3338623046875,
      "bbox_min": [
        -370.1299133300781,
        1102.0,
        95.0
      ],
      "bbox_max": [
        -279.8700866699219,
        1130.4095458984375,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588195204734802,
        0.9659257531166077,
        0.0
      ],
      "plane_d": -1148.5665283203125,
      "bbox_min": [
        -370.1299133300781,
        1102.0,
        95.0
      ],
      "bbox_max": [
        -279.8700866699219,
        1130.4095458984375,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        -370.1299133300781,
        1120.0,
        95.0
      ],
      "bbox_max": [
        -279.8700866699219,
        1130.4095458984375,
        110.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.25882211327552795,
        -0.9659249782562256,
        -0.0
      ],
      "plane_d": 997.7188110351562,
      "bbox_min": [
        -370.1299133300781,
        1120.0,
        95.0
      ],
      "bbox_max": [
        -279.8700866699219,
        1130.4095458984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882211327552795,
        -0.9659249782562256,
        0.0
      ],
      "plane_d": 1165.953125,
      "bbox_min": [
        -347.5798645019531,
        1120.0,
        95.0
      ],
      "bbox_max": [
        -279.8700866699219,
        1130.4095458984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071050405502319,
        -0.7071085572242737,
        -0.0
      ],
      "plane_d": 553.5468139648438,
      "bbox_min": [
        -347.5798645019531,
        1124.4547119140625,
        95.0
      ],
      "bbox_max": [
        -302.4201354980469,
        1130.4095458984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071049809455872,
        -0.7071085572242737,
        0.0
      ],
      "plane_d": 1013.1650390625,
      "bbox_min": [
        -308.375,
        1124.4547119140625,
        95.0
      ],
      "bbox_max": [
        -302.4201354980469,
        1130.4095458984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659258723258972,
        0.2588188648223877,
        0.0
      ],
      "plane_d": -562.9050903320312,
      "bbox_min": [
        -280.6162109375,
        1127.625,
        95.0
      ],
      "bbox_max": [
        -279.8700866699219,
        1130.4095458984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659257531166077,
        0.2588195204734802,
        0.0
      ],
      "plane_d": 64.94595336914062,
      "bbox_min": [
        -370.1299133300781,
        1127.625,
        95.0
      ],
      "bbox_max": [
        -369.3837890625,
        1130.4095458984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882261991500854,
        0.9659249782562256,
        0.0
      ],
      "plane_d": -999.6504516601562,
      "bbox_min": [
        -370.1299133300781,
        1122.0,
        100.0
      ],
      "bbox_max": [
        -279.8700866699219,
        1130.4095458984375,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9659257531166077,
        0.2588195204734802,
        0.0
      ],
      "plane_d": 64.94595336914062,
      "bbox_min": [
        -370.1299133300781,
        1127.625,
        100.0
      ],
      "bbox_max": [
        -369.3837890625,
        1130.4095458984375,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659258723258972,
        0.2588188648223877,
        0.0
      ],
      "plane_d": -562.9050903320312,
      "bbox_min": [
        -280.6162109375,
        1127.625,
        100.0
      ],
      "bbox_max": [
        -279.8700866699219,
        1130.4095458984375,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071049213409424,
        0.7071086764335632,
        0.0
      ],
      "plane_d": -1015.0970458984375,
      "bbox_min": [
        -309.375,
        1126.186767578125,
        100.0
      ],
      "bbox_max": [
        -305.1521911621094,
        1130.4095458984375,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25882259011268616,
        0.965924859046936,
        0.0
      ],
      "plane_d": -999.6503295898438,
      "bbox_min": [
        -344.8478088378906,
        1122.0,
        118.0
      ],
      "bbox_max": [
        -305.1521911621094,
        1130.4095458984375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882259011268616,
        0.965924859046936,
        0.0
      ],
      "plane_d": -1167.885009765625,
      "bbox_min": [
        -344.8478088378906,
        1122.0,
        118.0
      ],
      "bbox_max": [
        -305.1521911621094,
        1130.4095458984375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071049213409424,
        0.7071086764335632,
        0.0
      ],
      "plane_d": -1015.0970458984375,
      "bbox_min": [
        -344.8478088378906,
        1126.186767578125,
        118.0
      ],
      "bbox_max": [
        -305.1521911621094,
        1130.4095458984375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071049213409424,
        0.7071086764335632,
        0.0
      ],
      "plane_d": -555.4788208007812,
      "bbox_min": [
        -344.8478088378906,
        1126.186767578125,
        118.0
      ],
      "bbox_max": [
        -340.625,
        1130.4095458984375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1101.0794677734375,
      "bbox_min": [
        -391.0191650390625,
        1101.0794677734375,
        250.0
      ],
      "bbox_max": [
        -257.9808349609375,
        1130.4095458984375,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -391.0191650390625,
        1101.0794677734375,
        400.0
      ],
      "bbox_max": [
        -257.9808349609375,
        1130.4095458984375,
        400.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 320.5,
      "bbox_min": [
        -514.4999389648438,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -239.49996948242188,
        1210.361328125,
        500.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8660242557525635,
        0.5000020861625671,
        0.0
      ],
      "plane_d": -925.1790161132812,
      "bbox_min": [
        -514.4999389648438,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -409.5,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        432.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 432.0,
      "bbox_min": [
        -375.0001220703125,
        1130.4095458984375,
        400.0
      ],
      "bbox_max": [
        -320.5,
        1190.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 375.0,
      "bbox_min": [
        -375.0001220703125,
        1130.4095458984375,
        400.0
      ],
      "bbox_max": [
        -320.5,
        1190.0,
        432.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -402.0,
      "bbox_min": [
        -375.0001220703125,
        1130.4095458984375,
        400.0
      ],
      "bbox_max": [
        -320.5,
        1180.0,
        432.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -329.5,
        1140.0,
        400.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        402.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        -329.5,
        1140.0,
        400.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        402.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 329.5,
      "bbox_min": [
        -329.5,
        1140.0,
        400.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        402.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 338.0,
      "bbox_min": [
        -375.0001220703125,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1180.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1145.0,
      "bbox_min": [
        -375.0001220703125,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -338.0,
        1180.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 372.0001220703125,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        402.0
      ],
      "bbox_max": [
        -372.0,
        1180.0,
        422.20001220703125
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 412.5,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        402.0
      ],
      "bbox_max": [
        -372.0,
        1177.0,
        422.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 416.1000061035156,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        412.5
      ],
      "bbox_max": [
        -372.0,
        1177.0,
        422.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 419.20001220703125,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        416.1000061035156
      ],
      "bbox_max": [
        -372.0001220703125,
        1177.0,
        422.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        419.20001220703125
      ],
      "bbox_max": [
        -372.0001220703125,
        1147.0,
        422.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        416.1000061035156
      ],
      "bbox_max": [
        -372.0001220703125,
        1147.0,
        419.20001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        412.5
      ],
      "bbox_max": [
        -372.0001220703125,
        1147.0,
        416.1000061035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 409.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        402.0
      ],
      "bbox_max": [
        -372.0,
        1177.0,
        412.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        409.0
      ],
      "bbox_max": [
        -372.0001220703125,
        1147.0,
        412.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -375.0001220703125,
        1147.0,
        402.0
      ],
      "bbox_max": [
        -372.0001220703125,
        1147.0,
        409.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -405.5,
      "bbox_min": [
        -375.0,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -362.5,
        1136.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1136.5,
      "bbox_min": [
        -375.0,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -362.5,
        1136.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 362.5,
      "bbox_min": [
        -362.5,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -362.5,
        1136.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1158.0,
      "bbox_min": [
        -338.0,
        1150.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1158.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1150.0,
      "bbox_min": [
        -338.0,
        1150.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1158.0,
        413.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        1150.0,
        402.0
      ],
      "bbox_max": [
        -320.5,
        1158.0,
        413.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -405.5,
      "bbox_min": [
        -325.0,
        1154.0,
        405.0
      ],
      "bbox_max": [
        -320.5,
        1158.0,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1154.0,
      "bbox_min": [
        -325.0,
        1154.0,
        405.0
      ],
      "bbox_max": [
        -320.5,
        1154.0,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648214936256409,
        -0.5020795464515686,
        0.0
      ],
      "plane_d": 926.9849853515625,
      "bbox_min": [
        -409.5,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -409.5,
        1141.04345703125,
        95.0
      ],
      "bbox_max": [
        -369.1944274902344,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.5020793676376343,
        -0.8648215532302856,
        0.0
      ],
      "plane_d": 781.2288818359375,
      "bbox_min": [
        -409.49993896484375,
        1141.04345703125,
        95.0
      ],
      "bbox_max": [
        -409.4375,
        1141.07958984375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -387.80487060546875,
        1178.5682373046875,
        120.0
      ],
      "bbox_max": [
        -374.2751159667969,
        1201.7301025390625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49979308247566223,
        0.8661448359489441,
        -0.0
      ],
      "plane_d": -853.708251953125,
      "bbox_min": [
        -387.80487060546875,
        1178.5682373046875,
        120.0
      ],
      "bbox_max": [
        -374.2751159667969,
        1201.7301025390625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 827.0648193359375,
      "bbox_min": [
        -387.80487060546875,
        1178.5682373046875,
        120.0
      ],
      "bbox_max": [
        -387.6523132324219,
        1178.65625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -409.43756103515625,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.361328125,
      "bbox_min": [
        -388.82049560546875,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.16333900392055511,
        0.9865700006484985
      ],
      "plane_d": 89.17681121826172,
      "bbox_min": [
        -340.0,
        1200.361328125,
        108.34407043457031
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -340.0,
        1200.361328125,
        108.34407043457031
      ],
      "bbox_max": [
        -320.5,
        1210.361328125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -340.0,
        1200.361328125,
        108.34407043457031
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -340.0,
        1200.361328125,
        118.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -388.82049560546875,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1200.361328125,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        -388.82049560546875,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1200.361328125,
        118.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -388.82049560546875,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1187.7750244140625,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        -377.73565673828125,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1187.7750244140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.0,
      "bbox_min": [
        -340.0,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -320.5,
        1181.5,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -340.0,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -320.5,
        1177.5,
        65.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1175.5,
      "bbox_min": [
        -338.0,
        1175.5,
        62.0
      ],
      "bbox_max": [
        -320.5,
        1175.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -344.0,
      "bbox_min": [
        -377.73565673828125,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1187.7750244140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.0,
      "bbox_min": [
        -344.0,
        1147.0,
        61.5
      ],
      "bbox_max": [
        -340.0,
        1181.5,
        62.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -1075.8629150390625,
      "bbox_min": [
        -344.0,
        1177.5,
        61.5
      ],
      "bbox_max": [
        -340.0,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1175.0,
      "bbox_min": [
        -377.73565673828125,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1187.7750244140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -364.75,
      "bbox_min": [
        -377.73565673828125,
        1175.0,
        62.5
      ],
      "bbox_max": [
        -351.8951721191406,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291085600852966,
        -0.34680885076522827,
        0.8730038404464722
      ],
      "plane_d": 214.91290283203125,
      "bbox_min": [
        -364.75,
        1175.0,
        62.5
      ],
      "bbox_max": [
        -351.8951721191406,
        1187.7750244140625,
        89.91812133789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -364.75,
        1175.0,
        62.5
      ],
      "bbox_max": [
        -352.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -364.75,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -356.0,
        1182.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429098427295685,
        -0.3468110263347626,
        0.8730034232139587
      ],
      "plane_d": 209.54443359375,
      "bbox_min": [
        -364.75,
        1175.0,
        83.4843978881836
      ],
      "bbox_max": [
        -354.479248046875,
        1185.219970703125,
        89.91812133789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429112732410431,
        -0.3468084931373596,
        0.8730038404464722
      ],
      "plane_d": 465.1109619140625,
      "bbox_min": [
        -377.73565673828125,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -364.75,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -374.0,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -364.75,
        1182.794189453125,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6092076897621155,
        0.6092076897621155,
        0.5076730847358704
      ],
      "plane_d": -972.54931640625,
      "bbox_min": [
        -367.25,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -364.75,
        1177.5,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291085600852966,
        -0.34680885076522827,
        0.8730038404464722
      ],
      "plane_d": 214.91290283203125,
      "bbox_min": [
        -375.151611328125,
        1175.0,
        77.30587768554688
      ],
      "bbox_max": [
        -364.75,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34291166067123413,
        -0.34680986404418945,
        0.8730031847953796
      ],
      "plane_d": 459.7413635253906,
      "bbox_min": [
        -375.151611328125,
        1175.0,
        83.45869445800781
      ],
      "bbox_max": [
        -364.75,
        1185.219970703125,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429098427295685,
        -0.3468110263347626,
        0.8730034232139587
      ],
      "plane_d": 209.54443359375,
      "bbox_min": [
        -373.08441162109375,
        1175.0,
        83.45869445800781
      ],
      "bbox_max": [
        -364.75,
        1185.219970703125,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3429108262062073,
        -0.3468044102191925,
        0.8730056285858154
      ],
      "plane_d": 455.4119567871094,
      "bbox_min": [
        -373.08441162109375,
        1175.0,
        88.40995788574219
      ],
      "bbox_max": [
        -364.8154296875,
        1183.176025390625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -377.73565673828125,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1175.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -364.75,
      "bbox_min": [
        -377.73565673828125,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429105877876282,
        0.34680861234664917,
        0.8730040788650513
      ],
      "plane_d": -600.0875244140625,
      "bbox_min": [
        -364.75,
        1162.2249755859375,
        60.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1175.0,
        89.91812133789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -364.75,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -352.535888671875,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -364.75,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -352.535888671875,
        1175.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1164.205810546875,
      "bbox_min": [
        -364.75,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -358.7679443359375,
        1167.205810546875,
        62.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1167.205810546875,
      "bbox_min": [
        -364.75,
        1167.205810546875,
        62.5
      ],
      "bbox_max": [
        -360.5,
        1167.205810546875,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429105877876282,
        0.34680861234664917,
        0.8730040788650513
      ],
      "plane_d": -600.0875244140625,
      "bbox_min": [
        -375.151611328125,
        1162.2249755859375,
        77.30587768554688
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291166067123413,
        -0.34680986404418945,
        -0.8730031847953796
      ],
      "plane_d": 355.2618408203125,
      "bbox_min": [
        -375.151611328125,
        1164.780029296875,
        83.45869445800781
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291166067123413,
        0.34680986404418945,
        0.8730031847953796
      ],
      "plane_d": -605.4607543945312,
      "bbox_min": [
        -373.08441162109375,
        1164.780029296875,
        83.45869445800781
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429108262062073,
        -0.3468044102191925,
        -0.8730056285858154
      ],
      "plane_d": 359.5783996582031,
      "bbox_min": [
        -373.08441162109375,
        1166.823974609375,
        88.40995788574219
      ],
      "bbox_max": [
        -364.8154296875,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660244345664978,
        -0.5000016689300537,
        -0.0
      ],
      "plane_d": 260.60882568359375,
      "bbox_min": [
        -377.464111328125,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -377.464111328125,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1164.205810546875,
      "bbox_min": [
        -377.464111328125,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660243153572083,
        -0.5000019073486328,
        0.0
      ],
      "plane_d": 263.6091613769531,
      "bbox_min": [
        -377.464111328125,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1167.205810546875,
      "bbox_min": [
        -369.5,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -364.75,
        1167.205810546875,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -369.5,
        1164.205810546875,
        62.5
      ],
      "bbox_max": [
        -364.75,
        1167.205810546875,
        62.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -377.464111328125,
        1164.205810546875,
        62.5
      ],
      "bbox_max": [
        -367.7679138183594,
        1175.0,
        62.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6092076897621155,
        -0.6092076897621155,
        0.5076730847358704
      ],
      "plane_d": 459.0887756347656,
      "bbox_min": [
        -367.25,
        1172.5,
        65.0
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -375.739990234375,
        1147.0,
        64.0
      ],
      "bbox_max": [
        -372.9237976074219,
        1147.25,
        64.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.4244338870048523,
        0.905458927154541
      ],
      "plane_d": 403.45977783203125,
      "bbox_min": [
        -376.25,
        1147.0,
        95.0
      ],
      "bbox_max": [
        -356.5753173828125,
        1163.9166259765625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -376.25,
        1147.0,
        95.0
      ],
      "bbox_max": [
        -356.5753173828125,
        1163.9166259765625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1153.25,
      "bbox_min": [
        -365.0,
        1147.0,
        95.0
      ],
      "bbox_max": [
        -356.5753173828125,
        1153.25,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659259915351868,
        -0.2588188350200653,
        -0.0
      ],
      "plane_d": -47.5601806640625,
      "bbox_min": [
        -358.25,
        1147.0,
        95.0
      ],
      "bbox_max": [
        -356.5753173828125,
        1153.25,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 376.25,
      "bbox_min": [
        -376.25,
        1147.0,
        95.0
      ],
      "bbox_max": [
        -374.5753173828125,
        1163.9166259765625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659257531166077,
        0.2588195204734802,
        0.0
      ],
      "plane_d": 64.94595336914062,
      "bbox_min": [
        -376.25,
        1147.0,
        95.0
      ],
      "bbox_max": [
        -374.5753173828125,
        1153.25,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -329.5,
      "bbox_min": [
        -388.82049560546875,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -329.5,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1140.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -388.82049560546875,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -70.0,
      "bbox_min": [
        -388.82049560546875,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -344.0,
      "bbox_min": [
        -388.82049560546875,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -344.0,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -329.5,
        1140.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.660825788974762,
        0.7505393624305725,
        -0.0
      ],
      "plane_d": -618.0692138671875,
      "bbox_min": [
        -388.82049560546875,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -353.422607421875,
        1147.0,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -388.82049560546875,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -353.422607421875,
        1147.0,
        66.5999984741211
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.319561243057251,
        -0.9475656151771545,
        0.0
      ],
      "plane_d": 964.6857299804688,
      "bbox_min": [
        -386.0616149902344,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -353.422607421875,
        1144.1903076171875,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11961036920547485,
        -0.9928209185600281,
        0.0
      ],
      "plane_d": 1180.7080078125,
      "bbox_min": [
        -386.0616149902344,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -353.422607421875,
        1144.1903076171875,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9196140766143799,
        0.3928230106830597,
        -0.0
      ],
      "plane_d": -119.03848266601562,
      "bbox_min": [
        -386.0616149902344,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -353.422607421875,
        1143.284912109375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6608288884162903,
        -0.7505365610122681,
        0.0
      ],
      "plane_d": 615.0650024414062,
      "bbox_min": [
        -386.0616149902344,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -356.684814453125,
        1143.284912109375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6473259925842285,
        -0.7622132897377014,
        0.0
      ],
      "plane_d": 1118.37890625,
      "bbox_min": [
        -386.0616149902344,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -356.684814453125,
        1143.284912109375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9196160435676575,
        -0.3928183913230896,
        0.0
      ],
      "plane_d": 116.0325927734375,
      "bbox_min": [
        -358.8366394042969,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -356.684814453125,
        1135.4471435546875,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1312400847673416,
        0.1457478404045105,
        0.9805781841278076
      ],
      "plane_d": -183.85304260253906,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6691088676452637,
        -0.7431643605232239,
        0.0
      ],
      "plane_d": 603.8948974609375,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7431347966194153,
        0.6691417694091797,
        0.0
      ],
      "plane_d": -1034.256591796875,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        66.5999984741211
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7431074380874634,
        -0.6691721081733704,
        0.0
      ],
      "plane_d": 1032.28125,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        66.5999984741211
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6691535115242004,
        0.7431241869926453,
        -0.0
      ],
      "plane_d": -606.432861328125,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -66.5999984741211,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -362.1378479003906,
        1141.8756103515625,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5255210399627686,
        -0.47310927510261536,
        0.707103431224823
      ],
      "plane_d": 684.9085693359375,
      "bbox_min": [
        -363.83251953125,
        1140.180908203125,
        63.999996185302734
      ],
      "bbox_max": [
        -362.1378479003906,
        1141.8756103515625,
        64.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4731048047542572,
        -0.5256600379943848,
        0.707003116607666
      ],
      "plane_d": 382.3905944824219,
      "bbox_min": [
        -363.83251953125,
        1140.180908203125,
        63.999996185302734
      ],
      "bbox_max": [
        -362.9407653808594,
        1141.8756103515625,
        64.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5253788232803345,
        0.4731574058532715,
        0.707176923751831
      ],
      "plane_d": -776.2742309570312,
      "bbox_min": [
        -363.83251953125,
        1140.9840087890625,
        63.999996185302734
      ],
      "bbox_max": [
        -362.9999084472656,
        1141.8756103515625,
        64.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7431954741477966,
        -0.6690743565559387,
        0.0
      ],
      "plane_d": 1033.001708984375,
      "bbox_min": [
        -362.97027587890625,
        1140.7459716796875,
        64.4000015258789
      ],
      "bbox_max": [
        -362.7027893066406,
        1141.0430908203125,
        64.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659257531166077,
        0.2588195204734802,
        0.0
      ],
      "plane_d": 64.94595336914062,
      "bbox_min": [
        -374.5753173828125,
        1130.4095458984375,
        95.0
      ],
      "bbox_max": [
        -347.5798645019531,
        1147.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659259915351868,
        -0.2588188350200653,
        -0.0
      ],
      "plane_d": -47.5601806640625,
      "bbox_min": [
        -356.5753173828125,
        1130.4095458984375,
        95.0
      ],
      "bbox_max": [
        -347.5798645019531,
        1147.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071050405502319,
        -0.7071085572242737,
        -0.0
      ],
      "plane_d": 553.5468139648438,
      "bbox_min": [
        -353.79534912109375,
        1130.4095458984375,
        95.0
      ],
      "bbox_max": [
        -347.5798645019531,
        1136.625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.18892592191696167,
        0.9819913506507874
      ],
      "plane_d": 119.6796875,
      "bbox_min": [
        -376.25,
        1130.4095458984375,
        100.0
      ],
      "bbox_max": [
        -320.5,
        1200.361328125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.16333900392055511,
        0.9865700006484985
      ],
      "plane_d": 89.17681121826172,
      "bbox_min": [
        -376.25,
        1153.25,
        100.0
      ],
      "bbox_max": [
        -320.5,
        1200.361328125,
        109.06378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 376.25,
      "bbox_min": [
        -376.25,
        1153.25,
        100.0
      ],
      "bbox_max": [
        -365.0,
        1171.208984375,
        103.41828155517578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -376.25,
        1153.25,
        100.0
      ],
      "bbox_max": [
        -365.0,
        1171.208984375,
        103.41828155517578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4244338870048523,
        0.905458927154541
      ],
      "plane_d": 403.45977783203125,
      "bbox_min": [
        -376.25,
        1163.9166259765625,
        100.0
      ],
      "bbox_max": [
        -365.0,
        1171.208984375,
        103.41828155517578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6844431757926941,
        -0.7290661931037903,
        0.0
      ],
      "plane_d": 1093.154541015625,
      "bbox_min": [
        -376.25,
        1168.874755859375,
        103.00605773925781
      ],
      "bbox_max": [
        -340.0,
        1180.199951171875,
        105.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 376.25,
      "bbox_min": [
        -376.25,
        1168.874755859375,
        103.00605773925781
      ],
      "bbox_max": [
        -365.0,
        1171.34228515625,
        103.48079681396484
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6844431757926941,
        -0.7290661931037903,
        0.0
      ],
      "plane_d": 1093.154541015625,
      "bbox_min": [
        -347.09954833984375,
        1173.534912109375,
        103.90263366699219
      ],
      "bbox_max": [
        -340.0,
        1180.199951171875,
        105.18492126464844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 376.25,
      "bbox_min": [
        -376.25,
        1130.4095458984375,
        100.0
      ],
      "bbox_max": [
        -340.0,
        1200.361328125,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9659257531166077,
        0.2588195204734802,
        0.0
      ],
      "plane_d": 64.94595336914062,
      "bbox_min": [
        -376.25,
        1130.4095458984375,
        100.0
      ],
      "bbox_max": [
        -340.0,
        1200.361328125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -365.0,
        1130.4095458984375,
        100.0
      ],
      "bbox_max": [
        -340.0,
        1200.361328125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1195.25,
      "bbox_min": [
        -365.0,
        1185.25,
        110.0
      ],
      "bbox_max": [
        -353.0,
        1195.25,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1185.25,
      "bbox_min": [
        -365.0,
        1185.25,
        110.0
      ],
      "bbox_max": [
        -353.0,
        1185.25,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        -365.0,
        1130.4095458984375,
        100.0
      ],
      "bbox_max": [
        -344.8478088378906,
        1168.875,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9659258127212524,
        -0.2588190734386444,
        0.0
      ],
      "plane_d": 642.5941772460938,
      "bbox_min": [
        -356.25,
        1130.4095458984375,
        110.0
      ],
      "bbox_max": [
        -344.8478088378906,
        1168.875,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071049213409424,
        0.7071086764335632,
        -0.0
      ],
      "plane_d": -555.4788208007812,
      "bbox_min": [
        -352.06329345703125,
        1130.4095458984375,
        110.0
      ],
      "bbox_max": [
        -344.8478088378906,
        1137.625,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659258723258972,
        -0.2588190734386444,
        0.0
      ],
      "plane_d": -45.62799072265625,
      "bbox_min": [
        -365.0,
        1130.4095458984375,
        100.0
      ],
      "bbox_max": [
        -344.8478088378906,
        1168.875,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9659258127212524,
        -0.2588190734386444,
        0.0
      ],
      "plane_d": 642.5941772460938,
      "bbox_min": [
        -356.25,
        1130.4095458984375,
        100.0
      ],
      "bbox_max": [
        -344.8478088378906,
        1168.875,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071049213409424,
        -0.7071086764335632,
        0.0
      ],
      "plane_d": 555.4788208007812,
      "bbox_min": [
        -352.06329345703125,
        1130.4095458984375,
        100.0
      ],
      "bbox_max": [
        -344.8478088378906,
        1137.625,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1153.25,
      "bbox_min": [
        -365.0,
        1153.25,
        100.0
      ],
      "bbox_max": [
        -356.25,
        1153.25,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1195.25,
      "bbox_min": [
        -376.25,
        1195.25,
        110.0
      ],
      "bbox_max": [
        -365.0,
        1195.25,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4244338870048523,
        0.905458927154541
      ],
      "plane_d": 403.45977783203125,
      "bbox_min": [
        -376.25,
        1171.34228515625,
        103.48079681396484
      ],
      "bbox_max": [
        -365.0,
        1185.25,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -376.25,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -340.0,
        1200.361328125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -376.25,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -340.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6844431757926941,
        -0.7290661931037903,
        0.0
      ],
      "plane_d": 1093.154541015625,
      "bbox_min": [
        -365.0,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -340.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1195.25,
      "bbox_min": [
        -365.0,
        1185.25,
        118.0
      ],
      "bbox_max": [
        -350.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1185.25,
      "bbox_min": [
        -365.0,
        1185.25,
        118.0
      ],
      "bbox_max": [
        -350.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": -293.9911193847656,
      "bbox_min": [
        -353.0,
        1185.25,
        118.0
      ],
      "bbox_max": [
        -350.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659258723258972,
        -0.2588190734386444,
        0.0
      ],
      "plane_d": 642.5941772460938,
      "bbox_min": [
        -356.25,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -344.8478088378906,
        1168.875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659258723258972,
        0.2588190734386444,
        0.0
      ],
      "plane_d": 45.62799072265625,
      "bbox_min": [
        -356.25,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -344.8478088378906,
        1153.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071049213409424,
        0.7071086764335632,
        0.0
      ],
      "plane_d": -555.4788208007812,
      "bbox_min": [
        -352.06329345703125,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -344.8478088378906,
        1137.625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 376.25,
      "bbox_min": [
        -376.25,
        1166.050048828125,
        118.0
      ],
      "bbox_max": [
        -365.0,
        1195.25,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5299989581108093,
        -0.847998321056366
      ],
      "plane_d": -517.9415283203125,
      "bbox_min": [
        -376.25,
        1166.050048828125,
        118.0
      ],
      "bbox_max": [
        -365.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1195.25,
      "bbox_min": [
        -376.25,
        1195.25,
        118.0
      ],
      "bbox_max": [
        -365.0,
        1195.25,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -387.6523132324219,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661441206932068,
        -0.4997943937778473,
        0.0
      ],
      "plane_d": 914.9912109375,
      "bbox_min": [
        -387.6523132324219,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 827.0648193359375,
      "bbox_min": [
        -387.6523132324219,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -365.83636474609375,
        1201.610107421875,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49979308247566223,
        0.8661448359489441,
        -0.0
      ],
      "plane_d": -853.708251953125,
      "bbox_min": [
        -374.2751159667969,
        1196.7406005859375,
        120.0
      ],
      "bbox_max": [
        -365.83636474609375,
        1201.610107421875,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -355.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.4000244140625,
      "bbox_min": [
        -355.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -355.0,
      "bbox_min": [
        -355.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -340.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -233.222412109375,
      "bbox_min": [
        -514.4999389648438,
        1141.0794677734375,
        60.0
      ],
      "bbox_max": [
        -369.4998779296875,
        1210.361328125,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -514.4999389648438,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -399.4999694824219,
        1210.361328125,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5020797848701477,
        -0.8648213148117065,
        0.0
      ],
      "plane_d": 801.2283935546875,
      "bbox_min": [
        -513.3609008789062,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -399.4999694824219,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24196197092533112,
        -0.4167741537094116,
        -0.8762155771255493
      ],
      "plane_d": 491.27337646484375,
      "bbox_min": [
        -513.3609008789062,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -399.4999694824219,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8595525622367859,
        -0.51104736328125,
        0.0
      ],
      "plane_d": 944.7119140625,
      "bbox_min": [
        -416.9037170410156,
        1142.7501220703125,
        122.82001495361328
      ],
      "bbox_max": [
        -402.3447570800781,
        1158.6741943359375,
        130.13385009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        -0.8320503234863281,
        -0.0
      ],
      "plane_d": 736.5462036132812,
      "bbox_min": [
        -416.9037170410156,
        1142.7501220703125,
        122.82001495361328
      ],
      "bbox_max": [
        -402.3447570800781,
        1158.6741943359375,
        130.13385009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5109641551971436,
        -0.8596020340919495,
        -0.0
      ],
      "plane_d": 785.9436645507812,
      "bbox_min": [
        -402.6838073730469,
        1153.4549560546875,
        123.12716674804688
      ],
      "bbox_max": [
        -402.3447570800781,
        1153.6741943359375,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        -402.6838073730469,
        1153.4549560546875,
        130.0
      ],
      "bbox_max": [
        -402.3447570800781,
        1153.6741943359375,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        -415.13079833984375,
        1145.0887451171875,
        130.0
      ],
      "bbox_max": [
        -402.35498046875,
        1158.6741943359375,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5110283493995667,
        0.8595638275146484,
        -0.0
      ],
      "plane_d": -776.1936645507812,
      "bbox_min": [
        -407.63079833984375,
        1145.0887451171875,
        128.45095825195312
      ],
      "bbox_max": [
        -407.18524169921875,
        1145.3536376953125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0365307480096817,
        -0.016438838094472885,
        -0.9991973042488098
      ],
      "plane_d": 133.83287048339844,
      "bbox_min": [
        -409.6993408203125,
        1142.7501220703125,
        130.0
      ],
      "bbox_max": [
        -407.63079833984375,
        1145.3536376953125,
        130.11337280273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2564944922924042,
        -0.9665457010269165,
        0.0
      ],
      "plane_d": 1292.7418212890625,
      "bbox_min": [
        -513.3609008789062,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -399.4999694824219,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9665453433990479,
        -0.25649577379226685,
        -0.0
      ],
      "plane_d": -124.28031921386719,
      "bbox_min": [
        -513.3609008789062,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -399.4999694824219,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5020793676376343,
        -0.8648215532302856,
        0.0
      ],
      "plane_d": 781.2288818359375,
      "bbox_min": [
        -435.38214111328125,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -399.4999694824219,
        1158.6741943359375,
        130.1929473876953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -417.67535400390625,
        1141.0794677734375,
        120.0
      ],
      "bbox_max": [
        -399.4999694824219,
        1158.6741943359375,
        130.1920928955078
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8595525622367859,
        -0.51104736328125,
        0.0
      ],
      "plane_d": 944.7119140625,
      "bbox_min": [
        -417.67535400390625,
        1141.320068359375,
        120.0
      ],
      "bbox_max": [
        -402.3447570800781,
        1158.6741943359375,
        130.1920928955078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.871756911277771,
        -0.4899386465549469,
        0.0
      ],
      "plane_d": 925.495849609375,
      "bbox_min": [
        -417.67535400390625,
        1141.320068359375,
        120.0
      ],
      "bbox_max": [
        -402.3447570800781,
        1158.6741943359375,
        130.1920928955078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        -0.8320503234863281,
        -0.0
      ],
      "plane_d": 736.5462036132812,
      "bbox_min": [
        -417.67535400390625,
        1141.320068359375,
        120.0
      ],
      "bbox_max": [
        -402.3447570800781,
        1158.6741943359375,
        130.1920928955078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5109641551971436,
        -0.8596020340919495,
        -0.0
      ],
      "plane_d": 785.9436645507812,
      "bbox_min": [
        -402.6838073730469,
        1153.47265625,
        120.0
      ],
      "bbox_max": [
        -402.3447570800781,
        1153.6741943359375,
        123.12943267822266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8700023889541626,
        0.4930475056171417,
        0.0
      ],
      "plane_d": -919.353515625,
      "bbox_min": [
        -417.67535400390625,
        1141.320068359375,
        120.0
      ],
      "bbox_max": [
        -407.18524169921875,
        1147.1990966796875,
        130.1920928955078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5110283493995667,
        0.8595638275146484,
        -0.0
      ],
      "plane_d": -776.1936645507812,
      "bbox_min": [
        -407.63079833984375,
        1145.0887451171875,
        120.0
      ],
      "bbox_max": [
        -407.18524169921875,
        1145.3536376953125,
        128.45394897460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020562084391713142,
        -0.030843129381537437,
        -0.999312698841095
      ],
      "plane_d": 156.85520935058594,
      "bbox_min": [
        -417.67535400390625,
        1141.320068359375,
        130.09677124023438
      ],
      "bbox_max": [
        -409.1062316894531,
        1147.1990966796875,
        130.1920928955078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0365307480096817,
        -0.016438838094472885,
        -0.9991973042488098
      ],
      "plane_d": 133.83287048339844,
      "bbox_min": [
        -410.8052062988281,
        1141.320068359375,
        130.09677124023438
      ],
      "bbox_max": [
        -409.1062316894531,
        1143.0595703125,
        130.17398071289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -435.38214111328125,
        1141.0794677734375,
        120.0
      ],
      "bbox_max": [
        -409.4998474121094,
        1156.1058349609375,
        130.1929473876953
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.871756911277771,
        -0.4899386465549469,
        0.0
      ],
      "plane_d": 925.495849609375,
      "bbox_min": [
        -417.6866149902344,
        1141.8331298828125,
        120.0
      ],
      "bbox_max": [
        -410.8052062988281,
        1145.8260498046875,
        130.1929473876953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020562084391713142,
        -0.030843129381537437,
        -0.999312698841095
      ],
      "plane_d": 156.85520935058594,
      "bbox_min": [
        -417.6866149902344,
        1141.8331298828125,
        130.17398071289062
      ],
      "bbox_max": [
        -410.8052062988281,
        1145.8260498046875,
        130.1929473876953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -513.3609008789062,
        1156.0074462890625,
        95.0
      ],
      "bbox_max": [
        -435.3560485839844,
        1208.5478515625,
        131.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.15747740864753723,
        -0.5934206247329712,
        -0.7893369793891907
      ],
      "plane_d": 888.4124755859375,
      "bbox_min": [
        -513.3609008789062,
        1156.0074462890625,
        95.0
      ],
      "bbox_max": [
        -435.3560485839844,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5934202671051025,
        -0.1574781984090805,
        -0.7893370985984802
      ],
      "plane_d": 18.417329788208008,
      "bbox_min": [
        -513.3609008789062,
        1156.0074462890625,
        95.0
      ],
      "bbox_max": [
        -435.3560485839844,
        1201.2930908203125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648213148117065,
        -0.5020797848701477,
        0.0
      ],
      "plane_d": 1046.985107421875,
      "bbox_min": [
        -513.3609008789062,
        1156.0074462890625,
        95.0
      ],
      "bbox_max": [
        -435.3560485839844,
        1201.2930908203125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4167734682559967,
        0.24196158349514008,
        -0.8762159943580627
      ],
      "plane_d": -356.0429992675781,
      "bbox_min": [
        -513.3609008789062,
        1156.0074462890625,
        120.0
      ],
      "bbox_max": [
        -435.3560485839844,
        1201.2930908203125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -435.4183654785156,
        1156.0074462890625,
        120.0
      ],
      "bbox_max": [
        -435.3560485839844,
        1156.1058349609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41677308082580566,
        -0.24196134507656097,
        -0.8762162327766418
      ],
      "plane_d": 609.7070922851562,
      "bbox_min": [
        -513.3609008789062,
        1191.0435791015625,
        120.0
      ],
      "bbox_max": [
        -495.91961669921875,
        1201.2930908203125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661852478981018,
        0.4997231066226959,
        0.0
      ],
      "plane_d": -924.920166015625,
      "bbox_min": [
        -429.4999084472656,
        1158.39990234375,
        60.0
      ],
      "bbox_max": [
        -369.4998779296875,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355281829833984,
        0.7071074843406677
      ],
      "plane_d": -221.48590087890625,
      "bbox_min": [
        -399.5,
        1158.39990234375,
        60.00611877441406
      ],
      "bbox_max": [
        -387.95294189453125,
        1178.4073486328125,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 827.0648193359375,
      "bbox_min": [
        -387.81402587890625,
        1178.65625,
        120.0
      ],
      "bbox_max": [
        -387.80487060546875,
        1178.6614990234375,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355281829833984,
        0.7071074843406677
      ],
      "plane_d": -221.48590087890625,
      "bbox_min": [
        -429.4999084472656,
        1158.39990234375,
        60.00611877441406
      ],
      "bbox_max": [
        -374.497802734375,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 827.0648193359375,
      "bbox_min": [
        -396.4754638671875,
        1178.6614990234375,
        80.0
      ],
      "bbox_max": [
        -374.497802734375,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49979308247566223,
        0.8661448359489441,
        0.0
      ],
      "plane_d": -853.708251953125,
      "bbox_min": [
        -396.4754638671875,
        1178.6614990234375,
        80.0
      ],
      "bbox_max": [
        -374.497802734375,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -396.4754638671875,
        1178.6614990234375,
        125.006103515625
      ],
      "bbox_max": [
        -374.497802734375,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -239.49996948242188,
        1210.361328125,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 432.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        402.0
      ],
      "bbox_max": [
        -248.16021728515625,
        1190.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.900126576423645,
        -0.43562841415405273,
        0.0
      ],
      "plane_d": 271.16888427734375,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        402.0
      ],
      "bbox_max": [
        -248.16021728515625,
        1190.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660229444503784,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 353.1321105957031,
      "bbox_min": [
        -250.66021728515625,
        1136.0794677734375,
        402.0
      ],
      "bbox_max": [
        -248.16021728515625,
        1140.4095458984375,
        422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1158.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        402.0
      ],
      "bbox_max": [
        -280.0,
        1160.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -402.0,
      "bbox_min": [
        -320.5,
        1158.0,
        402.0
      ],
      "bbox_max": [
        -280.0,
        1160.0,
        402.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -402.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        402.0
      ],
      "bbox_max": [
        -280.0,
        1158.0,
        432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -282.0,
      "bbox_min": [
        -320.5,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -280.0,
        1158.0,
        432.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 410.0,
      "bbox_min": [
        -282.0,
        1140.0,
        406.0
      ],
      "bbox_max": [
        -280.0,
        1150.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -406.0,
      "bbox_min": [
        -282.0,
        1140.0,
        406.0
      ],
      "bbox_max": [
        -280.0,
        1150.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1150.0,
      "bbox_min": [
        -282.0,
        1140.0,
        406.0
      ],
      "bbox_max": [
        -280.0,
        1150.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        -282.0,
        1140.0,
        406.0
      ],
      "bbox_max": [
        -280.0,
        1140.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1152.0,
      "bbox_min": [
        -320.5,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -282.0,
        1158.0,
        412.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -405.5,
      "bbox_min": [
        -320.5,
        1152.0,
        402.0
      ],
      "bbox_max": [
        -282.0,
        1158.0,
        412.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1154.0,
      "bbox_min": [
        -320.5,
        1152.0,
        402.0
      ],
      "bbox_max": [
        -305.0,
        1158.0,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -305.0,
      "bbox_min": [
        -305.0,
        1154.0,
        402.0
      ],
      "bbox_max": [
        -305.0,
        1158.0,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -305.0,
      "bbox_min": [
        -305.0,
        1152.0,
        402.0
      ],
      "bbox_max": [
        -305.0,
        1154.0,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 410.0,
      "bbox_min": [
        -305.0,
        1152.0,
        410.0
      ],
      "bbox_max": [
        -297.5,
        1158.0,
        412.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -305.0,
      "bbox_min": [
        -305.0,
        1152.0,
        410.0
      ],
      "bbox_max": [
        -305.0,
        1158.0,
        412.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1135.0,
      "bbox_min": [
        -305.5,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -282.0,
        1143.5,
        409.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -287.0,
      "bbox_min": [
        -287.0,
        1130.5,
        402.0
      ],
      "bbox_max": [
        -287.0,
        1135.0,
        409.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 405.0,
      "bbox_min": [
        -305.5,
        1137.0,
        402.0
      ],
      "bbox_max": [
        -297.5,
        1143.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -405.5,
      "bbox_min": [
        -305.5,
        1137.0,
        405.0
      ],
      "bbox_max": [
        -297.5,
        1143.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1143.5,
      "bbox_min": [
        -305.5,
        1137.0,
        405.0
      ],
      "bbox_max": [
        -297.5,
        1143.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -305.5,
      "bbox_min": [
        -305.5,
        1137.0,
        405.0
      ],
      "bbox_max": [
        -305.5,
        1143.5,
        405.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8626818060874939,
        0.5057471394538879,
        0.0
      ],
      "plane_d": -837.2601318359375,
      "bbox_min": [
        -302.5,
        1139.5,
        402.0
      ],
      "bbox_max": [
        -301.4817199707031,
        1141.2369384765625,
        405.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380874395370483,
        -0.5455358624458313,
        0.0
      ],
      "plane_d": 420.1756591796875,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -239.49996948242188,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -286.50933837890625,
        1140.2772216796875,
        95.0
      ],
      "bbox_max": [
        -239.49996948242188,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.5444650053977966,
        -0.8387835621833801,
        0.0
      ],
      "plane_d": 1107.505126953125,
      "bbox_min": [
        -251.74757385253906,
        1147.74609375,
        95.0
      ],
      "bbox_max": [
        -244.0028076171875,
        1158.412353515625,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5436074137687683,
        0.8393396139144897,
        0.0
      ],
      "plane_d": -1096.9410400390625,
      "bbox_min": [
        -251.74757385253906,
        1147.74609375,
        95.0
      ],
      "bbox_max": [
        -244.0028076171875,
        1158.412353515625,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        -251.74757385253906,
        1147.74609375,
        95.0
      ],
      "bbox_max": [
        -244.0028076171875,
        1158.412353515625,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -251.74757385253906,
        1147.74609375,
        95.0
      ],
      "bbox_max": [
        -244.0028076171875,
        1158.412353515625,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -240.8894805908203,
        1140.2772216796875,
        95.0
      ],
      "bbox_max": [
        -239.49996948242188,
        1141.15380859375,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -279.1505432128906,
        1176.694580078125,
        120.0
      ],
      "bbox_max": [
        -261.195068359375,
        1201.7301025390625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        0.8661448359489441,
        0.0
      ],
      "plane_d": -1178.073974609375,
      "bbox_min": [
        -279.1505432128906,
        1176.694580078125,
        120.0
      ],
      "bbox_max": [
        -261.195068359375,
        1201.7301025390625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 1151.430419921875,
      "bbox_min": [
        -264.5946350097656,
        1176.694580078125,
        120.0
      ],
      "bbox_max": [
        -261.195068359375,
        1178.65625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -245.75125122070312,
        1210.361328125,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.16333900392055511,
        0.9865700006484985
      ],
      "plane_d": 89.17681121826172,
      "bbox_min": [
        -320.5,
        1200.361328125,
        108.34407043457031
      ],
      "bbox_max": [
        -310.0,
        1210.361328125,
        109.99969482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -245.75125122070312,
        1200.361328125,
        118.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1187.7750244140625,
        88.75
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -312.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660244345664978,
        -0.5000016689300537,
        0.0
      ],
      "plane_d": 329.8907775878906,
      "bbox_min": [
        -312.0,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1164.205810546875,
      "bbox_min": [
        -297.464111328125,
        1139.4071044921875,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660244345664978,
        0.5000016689300537,
        0.0
      ],
      "plane_d": -845.1131591796875,
      "bbox_min": [
        -297.464111328125,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -272.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1167.205810546875,
      "bbox_min": [
        -297.464111328125,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -272.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660243153572083,
        -0.5000019073486328,
        -0.0
      ],
      "plane_d": 332.8910827636719,
      "bbox_min": [
        -297.464111328125,
        1167.205810546875,
        60.0
      ],
      "bbox_max": [
        -272.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660243153572083,
        0.5000019073486328,
        0.0
      ],
      "plane_d": -842.1134033203125,
      "bbox_min": [
        -294.0,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -289.5,
        1182.794189453125,
        62.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660243153572083,
        0.5000019073486328,
        0.0
      ],
      "plane_d": -842.1134033203125,
      "bbox_min": [
        -294.0,
        1175.0,
        62.5
      ],
      "bbox_max": [
        -289.5,
        1182.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -297.464111328125,
        1167.205810546875,
        62.5
      ],
      "bbox_max": [
        -289.5,
        1178.0,
        62.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -292.964111328125,
        1164.205810546875,
        62.5
      ],
      "bbox_max": [
        -277.035888671875,
        1167.205810546875,
        62.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -268.5044250488281,
        1139.4071044921875,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1146.1553955078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6473259925842285,
        -0.7622132897377014,
        -0.0
      ],
      "plane_d": 697.6170654296875,
      "bbox_min": [
        -268.5044250488281,
        1139.4071044921875,
        60.0
      ],
      "bbox_max": [
        -263.9383850097656,
        1143.284912109375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.660825788974762,
        0.7505393624305725,
        0.0
      ],
      "plane_d": -1047.60595703125,
      "bbox_min": [
        -312.0,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -284.47003173828125,
        1181.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -296.577392578125,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -284.47003173828125,
        1143.9903564453125,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9196140766143799,
        0.3928230106830597,
        0.0
      ],
      "plane_d": -716.7876586914062,
      "bbox_min": [
        -296.577392578125,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -284.47003173828125,
        1141.3404541015625,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6608288884162903,
        -0.7505365610122681,
        0.0
      ],
      "plane_d": 1044.603759765625,
      "bbox_min": [
        -293.315185546875,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -284.47003173828125,
        1141.3404541015625,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9196160435676575,
        -0.3928183913230896,
        0.0
      ],
      "plane_d": 713.7830200195312,
      "bbox_min": [
        -293.315185546875,
        1130.4095458984375,
        60.0
      ],
      "bbox_max": [
        -291.1633605957031,
        1135.4471435546875,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7547014355659485,
        -0.6560683846473694,
        0.0
      ],
      "plane_d": 531.3302001953125,
      "bbox_min": [
        -288.42059326171875,
        1139.689453125,
        63.999996185302734
      ],
      "bbox_max": [
        -286.71484375,
        1141.6517333984375,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5336341857910156,
        -0.4638999104499817,
        0.7071290016174316
      ],
      "plane_d": 330.7276306152344,
      "bbox_min": [
        -287.5938720703125,
        1140.40478515625,
        63.999996185302734
      ],
      "bbox_max": [
        -286.7671203613281,
        1141.3104248046875,
        64.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 306.0,
      "bbox_min": [
        -312.0,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -306.0,
        1181.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -312.0,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -306.0,
        1181.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.0,
      "bbox_min": [
        -312.0,
        1177.5,
        62.0
      ],
      "bbox_max": [
        -310.0,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.0,
      "bbox_min": [
        -320.5,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -312.0,
        1181.5,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -320.5,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -312.0,
        1147.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -320.5,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -312.0,
        1147.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -320.5,
        1140.0,
        62.0
      ],
      "bbox_max": [
        -312.0,
        1175.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1175.5,
      "bbox_min": [
        -320.5,
        1175.5,
        62.0
      ],
      "bbox_max": [
        -312.0,
        1175.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -320.5,
        1140.0,
        62.0
      ],
      "bbox_max": [
        -312.0,
        1140.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1175.0,
      "bbox_min": [
        -320.5,
        1139.689453125,
        64.99999237060547
      ],
      "bbox_max": [
        -272.26434326171875,
        1187.7750244140625,
        88.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.25,
      "bbox_min": [
        -287.75,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -272.26434326171875,
        1187.7750244140625,
        88.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291085600852966,
        -0.34680888056755066,
        0.8730039000511169
      ],
      "plane_d": 244.4017333984375,
      "bbox_min": [
        -285.1845703125,
        1175.0,
        74.80587768554688
      ],
      "bbox_max": [
        -272.26434326171875,
        1187.7750244140625,
        82.8801498413086
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6092076897621155,
        0.6092076897621155,
        0.5076730847358704
      ],
      "plane_d": -924.1173095703125,
      "bbox_min": [
        -287.75,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -285.25,
        1177.5,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.25,
      "bbox_min": [
        -320.5,
        1139.689453125,
        64.99999237060547
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        88.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -70.0,
      "bbox_min": [
        -320.5,
        1139.689453125,
        64.99999237060547
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -320.5,
        1139.689453125,
        64.99999237060547
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 306.0,
      "bbox_min": [
        -306.0,
        1140.0,
        64.99999237060547
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6092076897621155,
        -0.6092076897621155,
        0.5076730847358704
      ],
      "plane_d": 507.5207824707031,
      "bbox_min": [
        -288.42059326171875,
        1140.0,
        64.99999237060547
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7547014355659485,
        -0.6560683846473694,
        0.0
      ],
      "plane_d": 531.3302001953125,
      "bbox_min": [
        -288.42059326171875,
        1140.0,
        64.99999237060547
      ],
      "bbox_max": [
        -286.9847412109375,
        1141.6517333984375,
        66.5999984741211
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7547653913497925,
        -0.6559948325157166,
        0.0
      ],
      "plane_d": 531.2279663085938,
      "bbox_min": [
        -286.9847412109375,
        1139.689453125,
        65.0
      ],
      "bbox_max": [
        -286.71484375,
        1140.0,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        95.0
      ],
      "bbox_max": [
        -245.75125122070312,
        1200.361328125,
        118.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9659258127212524,
        0.2588190734386444,
        0.0
      ],
      "plane_d": -582.2238159179688,
      "bbox_min": [
        -313.4222106933594,
        1130.4095458984375,
        110.0
      ],
      "bbox_max": [
        -293.75,
        1200.361328125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659258127212524,
        -0.2588190734386444,
        0.0
      ],
      "plane_d": 14.742388725280762,
      "bbox_min": [
        -313.4222106933594,
        1130.4095458984375,
        110.0
      ],
      "bbox_max": [
        -293.75,
        1200.361328125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -313.4222106933594,
        1130.4095458984375,
        110.0
      ],
      "bbox_max": [
        -297.93670654296875,
        1200.361328125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6844431757926941,
        -0.7290661931037903,
        0.0
      ],
      "plane_d": 648.2664794921875,
      "bbox_min": [
        -310.0,
        1130.4095458984375,
        110.0
      ],
      "bbox_max": [
        -297.93670654296875,
        1180.199951171875,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 115.0,
      "bbox_min": [
        -310.0,
        1130.4095458984375,
        110.0
      ],
      "bbox_max": [
        -297.93670654296875,
        1180.199951171875,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.729071855545044,
        -0.6844371557235718,
        0.0
      ],
      "plane_d": 1017.23876953125,
      "bbox_min": [
        -301.3589172363281,
        1165.2296142578125,
        115.0
      ],
      "bbox_max": [
        -297.93670654296875,
        1168.875,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071049213409424,
        0.7071086764335632,
        0.0
      ],
      "plane_d": -1015.0970458984375,
      "bbox_min": [
        -305.1521911621094,
        1130.4095458984375,
        115.0
      ],
      "bbox_max": [
        -297.93670654296875,
        1137.625,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071049213409424,
        0.7071086764335632,
        0.0
      ],
      "plane_d": -1015.0970458984375,
      "bbox_min": [
        -305.1521911621094,
        1130.4095458984375,
        116.0
      ],
      "bbox_max": [
        -297.93670654296875,
        1137.625,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -116.0,
      "bbox_min": [
        -313.4222106933594,
        1173.341796875,
        115.0
      ],
      "bbox_max": [
        -310.0,
        1180.199951171875,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6844431757926941,
        -0.7290661931037903,
        0.0
      ],
      "plane_d": 643.2664794921875,
      "bbox_min": [
        -313.4222106933594,
        1173.341796875,
        115.0
      ],
      "bbox_max": [
        -310.0,
        1176.5545654296875,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.00402352400124073,
        0.9999918937683105,
        0.0
      ],
      "plane_d": -1145.1021728515625,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        95.0
      ],
      "bbox_max": [
        -245.75125122070312,
        1200.361328125,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        -320.5,
        1130.4095458984375,
        95.0
      ],
      "bbox_max": [
        -276.2285461425781,
        1144.0,
        110.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9659258723258972,
        0.2588188648223877,
        0.0
      ],
      "plane_d": -562.9050903320312,
      "bbox_min": [
        -302.4201354980469,
        1130.4095458984375,
        95.0
      ],
      "bbox_max": [
        -276.2285461425781,
        1144.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659258723258972,
        -0.2588188052177429,
        0.0
      ],
      "plane_d": 580.2916870117188,
      "bbox_min": [
        -296.20465087890625,
        1136.625,
        95.0
      ],
      "bbox_max": [
        -294.2479553222656,
        1143.927490234375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659258723258972,
        0.2588188648223877,
        0.0
      ],
      "plane_d": -562.9050903320312,
      "bbox_min": [
        -305.1521911621094,
        1130.4095458984375,
        100.0
      ],
      "bbox_max": [
        -276.2285461425781,
        1144.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071049213409424,
        0.7071086764335632,
        0.0
      ],
      "plane_d": -1015.0970458984375,
      "bbox_min": [
        -305.1521911621094,
        1130.4095458984375,
        100.0
      ],
      "bbox_max": [
        -296.2500915527344,
        1143.9195556640625,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659258127212524,
        0.2588190734386444,
        0.0
      ],
      "plane_d": -582.2238159179688,
      "bbox_min": [
        -297.93670654296875,
        1137.625,
        100.0
      ],
      "bbox_max": [
        -296.2500915527344,
        1143.9195556640625,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        -320.5,
        1143.8218994140625,
        95.0
      ],
      "bbox_max": [
        -245.75125122070312,
        1200.361328125,
        110.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0030578786972910166,
        -0.9999953508377075,
        0.0
      ],
      "plane_d": 1154.081787109375,
      "bbox_min": [
        -273.75,
        1153.25,
        95.0
      ],
      "bbox_max": [
        -251.74757385253906,
        1156.9580078125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.18892592191696167,
        0.9819913506507874
      ],
      "plane_d": 119.6796875,
      "bbox_min": [
        -320.5,
        1143.9195556640625,
        100.0
      ],
      "bbox_max": [
        -245.75125122070312,
        1200.361328125,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.16333900392055511,
        0.9865700006484985
      ],
      "plane_d": 89.17681121826172,
      "bbox_min": [
        -320.5,
        1153.25,
        100.0
      ],
      "bbox_max": [
        -251.74757385253906,
        1200.361328125,
        109.06378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0030578786972910166,
        -0.9999953508377075,
        0.0
      ],
      "plane_d": 1154.081787109375,
      "bbox_min": [
        -273.75,
        1153.25,
        100.0
      ],
      "bbox_max": [
        -251.74757385253906,
        1156.9580078125,
        100.71338653564453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5444650053977966,
        -0.8387835621833801,
        0.0
      ],
      "plane_d": 1107.505126953125,
      "bbox_min": [
        -257.3829040527344,
        1153.300048828125,
        100.0
      ],
      "bbox_max": [
        -251.74757385253906,
        1156.9580078125,
        100.71338653564453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6844431757926941,
        -0.7290661931037903,
        0.0
      ],
      "plane_d": 648.2664794921875,
      "bbox_min": [
        -310.0,
        1168.875,
        103.006103515625
      ],
      "bbox_max": [
        -297.93670654296875,
        1180.199951171875,
        105.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        1173.534912109375,
        103.90263366699219
      ],
      "bbox_max": [
        -302.90045166015625,
        1200.361328125,
        109.06378173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6844431757926941,
        -0.7290661931037903,
        0.0
      ],
      "plane_d": 648.2664794921875,
      "bbox_min": [
        -310.0,
        1173.534912109375,
        103.90263366699219
      ],
      "bbox_max": [
        -302.90045166015625,
        1180.199951171875,
        105.18492126464844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1153.25,
      "bbox_min": [
        -310.0,
        1143.9195556640625,
        100.0
      ],
      "bbox_max": [
        -245.75125122070312,
        1200.361328125,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        1153.25,
        100.0
      ],
      "bbox_max": [
        -251.74757385253906,
        1200.361328125,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0030578786972910166,
        -0.9999953508377075,
        0.0
      ],
      "plane_d": 1154.081787109375,
      "bbox_min": [
        -310.0,
        1153.25,
        100.0
      ],
      "bbox_max": [
        -251.74757385253906,
        1180.199951171875,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5444650053977966,
        -0.8387835621833801,
        0.0
      ],
      "plane_d": 1107.505126953125,
      "bbox_min": [
        -257.3829040527344,
        1153.300048828125,
        100.00962829589844
      ],
      "bbox_max": [
        -251.74757385253906,
        1156.9580078125,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6844431757926941,
        -0.7290661931037903,
        0.0
      ],
      "plane_d": 648.2664794921875,
      "bbox_min": [
        -310.0,
        1168.875,
        103.006103515625
      ],
      "bbox_max": [
        -297.93670654296875,
        1180.199951171875,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659258127212524,
        0.2588190734386444,
        0.0
      ],
      "plane_d": -582.2238159179688,
      "bbox_min": [
        -296.2500915527344,
        1143.9195556640625,
        100.0
      ],
      "bbox_max": [
        -245.75125122070312,
        1153.25,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5436074137687683,
        0.8393396139144897,
        0.0
      ],
      "plane_d": -1096.9410400390625,
      "bbox_min": [
        -251.3809814453125,
        1144.0999755859375,
        100.0
      ],
      "bbox_max": [
        -245.75125122070312,
        1147.74609375,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659258127212524,
        0.2588190734386444,
        0.0
      ],
      "plane_d": -582.2238159179688,
      "bbox_min": [
        -305.1521911621094,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -293.75,
        1168.875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659258127212524,
        -0.2588190734386444,
        -0.0
      ],
      "plane_d": 14.742388725280762,
      "bbox_min": [
        -305.1521911621094,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -293.75,
        1168.875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071049213409424,
        0.7071086764335632,
        0.0
      ],
      "plane_d": -1015.0970458984375,
      "bbox_min": [
        -305.1521911621094,
        1130.4095458984375,
        118.0
      ],
      "bbox_max": [
        -297.93670654296875,
        1137.625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -310.0,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -264.5946350097656,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866144061088562,
        -0.4997943639755249,
        0.0
      ],
      "plane_d": 352.86370849609375,
      "bbox_min": [
        -310.0,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -264.5946350097656,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 1151.430419921875,
      "bbox_min": [
        -283.16363525390625,
        1173.66357421875,
        120.0
      ],
      "bbox_max": [
        -264.5946350097656,
        1199.0562744140625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        0.8661448359489441,
        0.0
      ],
      "plane_d": -1178.073974609375,
      "bbox_min": [
        -283.16363525390625,
        1196.7406005859375,
        120.0
      ],
      "bbox_max": [
        -279.1505432128906,
        1199.0562744140625,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -310.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -295.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.4000244140625,
      "bbox_min": [
        -310.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -295.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -310.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -295.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -295.0,
        1200.4000244140625,
        120.0
      ],
      "bbox_max": [
        -295.0,
        1210.361328125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661856651306152,
        0.4997224807739258,
        0.0
      ],
      "plane_d": -362.76519775390625,
      "bbox_min": [
        -279.5001220703125,
        1141.0794677734375,
        60.0
      ],
      "bbox_max": [
        -134.50001525878906,
        1210.361328125,
        500.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -279.5001220703125,
        1158.2647705078125,
        60.00611877441406
      ],
      "bbox_max": [
        -249.42201232910156,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 1151.430419921875,
      "bbox_min": [
        -261.195068359375,
        1178.65625,
        120.0
      ],
      "bbox_max": [
        -261.18597412109375,
        1178.6614990234375,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660251498222351,
        0.5000004768371582,
        0.0
      ],
      "plane_d": -795.2738647460938,
      "bbox_min": [
        -274.502197265625,
        1141.0794677734375,
        60.00611877441406
      ],
      "bbox_max": [
        -134.50001525878906,
        1210.361328125,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -249.50003051757812,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -134.50001525878906,
        1210.361328125,
        320.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -209.49990844726562,
        1171.3902587890625,
        270.0
      ],
      "bbox_max": [
        -134.50001525878906,
        1210.361328125,
        270.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.20686259865760803,
        -0.9783700108528137,
        -0.0
      ],
      "plane_d": 1150.6346435546875,
      "bbox_min": [
        -249.50003051757812,
        1141.15380859375,
        95.0
      ],
      "bbox_max": [
        -140.31898498535156,
        1210.361328125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5444650053977966,
        -0.8387835621833801,
        0.0
      ],
      "plane_d": 1107.505126953125,
      "bbox_min": [
        -249.50003051757812,
        1141.15380859375,
        95.0
      ],
      "bbox_max": [
        -140.31898498535156,
        1210.361328125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783695936203003,
        -0.20686452090740204,
        0.0
      ],
      "plane_d": 450.3486022949219,
      "bbox_min": [
        -209.94268798828125,
        1184.0941162109375,
        95.0
      ],
      "bbox_max": [
        -209.80831909179688,
        1184.3157958984375,
        120.08821868896484
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6006800532341003,
        -0.1270068734884262,
        -0.7893369197845459
      ],
      "plane_d": 371.2169189453125,
      "bbox_min": [
        -209.94268798828125,
        1184.0941162109375,
        120.0
      ],
      "bbox_max": [
        -209.80831909179688,
        1184.3157958984375,
        120.08821868896484
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        -249.50003051757812,
        1141.15380859375,
        95.0
      ],
      "bbox_max": [
        -140.31898498535156,
        1210.361328125,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -249.50003051757812,
        1141.15380859375,
        120.0
      ],
      "bbox_max": [
        -239.5428924560547,
        1158.40478515625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12700533866882324,
        -0.600679874420166,
        -0.7893372774124146
      ],
      "plane_d": 801.1639404296875,
      "bbox_min": [
        -215.74685668945312,
        1156.643310546875,
        110.0
      ],
      "bbox_max": [
        -140.31898498535156,
        1210.361328125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783694744110107,
        -0.20686496794223785,
        0.0
      ],
      "plane_d": 450.34912109375,
      "bbox_min": [
        -215.74685668945312,
        1156.643310546875,
        110.0
      ],
      "bbox_max": [
        -209.94268798828125,
        1184.0941162109375,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5436074137687683,
        0.8393396139144897,
        0.0
      ],
      "plane_d": -1096.9410400390625,
      "bbox_min": [
        -244.0028076171875,
        1148.8785400390625,
        95.0
      ],
      "bbox_max": [
        -209.94268798828125,
        1184.0941162109375,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783695936203003,
        -0.20686452090740204,
        0.0
      ],
      "plane_d": 450.3486328125,
      "bbox_min": [
        -219.08721923828125,
        1156.643310546875,
        95.0
      ],
      "bbox_max": [
        -214.19537353515625,
        1165.015380859375,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.20686061680316925,
        0.9783704280853271,
        0.0
      ],
      "plane_d": -1094.49609375,
      "bbox_min": [
        -219.08721923828125,
        1163.9810791015625,
        95.0
      ],
      "bbox_max": [
        -214.19537353515625,
        1165.015380859375,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783695936203003,
        -0.20686452090740204,
        0.0
      ],
      "plane_d": 450.3486022949219,
      "bbox_min": [
        -225.0891571044922,
        1174.2623291015625,
        95.0
      ],
      "bbox_max": [
        -209.94268798828125,
        1184.0941162109375,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.20686061680316925,
        -0.9783704280853271,
        0.0
      ],
      "plane_d": 1107.7803955078125,
      "bbox_min": [
        -216.3391571044922,
        1176.97802734375,
        95.0
      ],
      "bbox_max": [
        -211.4473114013672,
        1178.0123291015625,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -239.54290771484375,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -136.8179473876953,
        1205.7415771484375,
        131.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -239.54290771484375,
        1141.0794677734375,
        95.0
      ],
      "bbox_max": [
        -136.8179473876953,
        1205.7415771484375,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4038896858692169,
        0.26290363073349,
        -0.8762161731719971
      ],
      "plane_d": -111.8018569946289,
      "bbox_min": [
        -215.74685668945312,
        1155.2987060546875,
        120.0
      ],
      "bbox_max": [
        -197.52635192871094,
        1167.5540771484375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380875587463379,
        -0.5455357432365417,
        0.0
      ],
      "plane_d": 540.175537109375,
      "bbox_min": [
        -140.31898498535156,
        1200.363037109375,
        95.0
      ],
      "bbox_max": [
        -136.8179473876953,
        1205.7415771484375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122786998748779,
        0.3534991443157196,
        0.7072150707244873
      ],
      "plane_d": -618.8341674804688,
      "bbox_min": [
        -274.502197265625,
        1158.4000244140625,
        60.00611877441406
      ],
      "bbox_max": [
        -219.50009155273438,
        1210.361328125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        0.8661448359489441,
        0.0
      ],
      "plane_d": -1178.073974609375,
      "bbox_min": [
        -274.502197265625,
        1158.4000244140625,
        80.0
      ],
      "bbox_max": [
        -249.484375,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 1151.430419921875,
      "bbox_min": [
        -274.502197265625,
        1158.4000244140625,
        80.0
      ],
      "bbox_max": [
        -249.484375,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.006103515625,
      "bbox_min": [
        -274.502197265625,
        1178.6611328125,
        120.0
      ],
      "bbox_max": [
        -252.5245361328125,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -262.07373046875,
        1178.6611328125,
        120.0
      ],
      "bbox_max": [
        -261.1859130859375,
        1180.199951171875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -261.18621826171875,
        1158.4000244140625,
        95.0
      ],
      "bbox_max": [
        -249.484375,
        1178.661376953125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5444650053977966,
        -0.8387835621833801,
        0.0
      ],
      "plane_d": 1107.505126953125,
      "bbox_min": [
        -249.50714111328125,
        1158.4000244140625,
        95.0
      ],
      "bbox_max": [
        -249.484375,
        1158.4271240234375,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        -249.50714111328125,
        1158.4000244140625,
        95.0
      ],
      "bbox_max": [
        -249.484375,
        1158.4271240234375,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -249.50714111328125,
        1158.4000244140625,
        95.0
      ],
      "bbox_max": [
        -249.484375,
        1158.4271240234375,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661856651306152,
        0.4997224807739258,
        0.0
      ],
      "plane_d": -362.76519775390625,
      "bbox_min": [
        -640.0554809570312,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        500.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9700985550880432,
        -0.2427113950252533,
        0.0
      ],
      "plane_d": 924.297119140625,
      "bbox_min": [
        -640.0554809570312,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -299.5,
        1430.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -214.0,
      "bbox_min": [
        -640.0554809570312,
        1309.916748046875,
        214.0
      ],
      "bbox_max": [
        -595.0115356445312,
        1430.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9863939881324768,
        -0.0,
        0.16439899802207947
      ],
      "plane_d": 512.9248657226562,
      "bbox_min": [
        -625.0554809570312,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -299.5,
        1430.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        -625.0554809570312,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -530.0,
        1430.0,
        214.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9952487945556641,
        0.09736471623182297,
        -0.0
      ],
      "plane_d": 494.5460205078125,
      "bbox_min": [
        -625.0554809570312,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -530.0,
        1309.916748046875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -550.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -530.0,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9952487945556641,
        0.09736471623182297,
        -0.0
      ],
      "plane_d": 494.5460205078125,
      "bbox_min": [
        -625.0554809570312,
        1239.0,
        119.99999237060547
      ],
      "bbox_max": [
        -618.1177368164062,
        1309.916748046875,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067094802856,
        0.7071067094802856
      ],
      "plane_d": -918.5513305664062,
      "bbox_min": [
        -516.0469970703125,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -299.5,
        1370.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.44721361994743347,
        -0.0
      ],
      "plane_d": -286.2166748046875,
      "bbox_min": [
        -310.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -299.5,
        1239.02783203125,
        60.02788162231445
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -310.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1239.02783203125,
        60.02788162231445
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -867.5943603515625,
      "bbox_min": [
        -422.9655456542969,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -350.4860534667969,
        1239.02783203125,
        60.02788162231445
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355281829833984,
        0.7071074843406677
      ],
      "plane_d": -221.48590087890625,
      "bbox_min": [
        -422.9655456542969,
        1239.0,
        60.00611877441406
      ],
      "bbox_max": [
        -422.9404602050781,
        1239.021728515625,
        60.02784729003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -475.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -299.5,
        1370.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -867.5944213867188,
      "bbox_min": [
        -350.5,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1240.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -350.5,
        1239.0,
        125.0
      ],
      "bbox_max": [
        -340.0,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268595933914185,
        -0.9238786101341248,
        -0.0
      ],
      "plane_d": 1047.3111572265625,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1391.728515625,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        0.3826843202114105,
        0.0
      ],
      "plane_d": -122.06173706054688,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 907.3590087890625,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1435.9219970703125,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -427.164794921875,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        -0.9238780736923218,
        -0.0
      ],
      "plane_d": 1091.50390625,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -427.164794921875,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        -0.3826843500137329,
        -0.0
      ],
      "plane_d": 120.061767578125,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -427.164794921875,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        0.3826843500137329,
        0.0
      ],
      "plane_d": -77.86785888671875,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -466.1469421386719,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 951.5531005859375,
      "bbox_min": [
        -472.835205078125,
        1345.0,
        60.0
      ],
      "bbox_max": [
        -466.1469421386719,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -340.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -299.5,
        1270.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -286.2167053222656,
      "bbox_min": [
        -310.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -299.5,
        1240.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -310.0,
        1239.0,
        125.0
      ],
      "bbox_max": [
        -299.5,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -340.0,
        1239.0,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        85.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -84.99999237060547,
      "bbox_min": [
        -340.0,
        1239.0,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1240.0,
        85.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        -335.0,
        1240.0,
        65.0
      ],
      "bbox_max": [
        -315.0,
        1240.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -233.222412109375,
      "bbox_min": [
        -618.1177368164062,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1239.0,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9952487945556641,
        0.09736471623182297,
        -0.0
      ],
      "plane_d": 494.5460205078125,
      "bbox_min": [
        -618.1177368164062,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -434.5,
        1239.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067094802856,
        0.7071067094802856
      ],
      "plane_d": -918.5513305664062,
      "bbox_min": [
        -516.034423828125,
        1210.361328125,
        60.02784729003906
      ],
      "bbox_max": [
        -434.5,
        1239.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -509.5000915527344,
        1210.361328125,
        320.0
      ],
      "bbox_max": [
        -434.5,
        1219.021728515625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -446.0344543457031,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1239.0,
        125.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -355.0,
      "bbox_min": [
        -446.0344543457031,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1239.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -867.5944213867188,
      "bbox_min": [
        -355.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1239.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -355.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1239.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1230.0,
      "bbox_min": [
        -355.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1230.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -355.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1210.4000244140625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -355.0,
        1210.361328125,
        120.0
      ],
      "bbox_max": [
        -340.0,
        1210.4000244140625,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -446.0344543457031,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -355.0,
        1239.0,
        120.00000762939453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8661852478981018,
        0.4997231066226959,
        0.0
      ],
      "plane_d": -924.920166015625,
      "bbox_min": [
        -429.5222473144531,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -355.0,
        1210.4000244140625,
        120.00000762939453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -369.522216796875,
        1210.361328125,
        120.0
      ],
      "bbox_max": [
        -355.0,
        1210.4000244140625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071067094802856,
        0.7071067094802856
      ],
      "plane_d": -918.5513305664062,
      "bbox_min": [
        -446.0344543457031,
        1219.021728515625,
        60.02784729003906
      ],
      "bbox_max": [
        -422.9655456542969,
        1239.0,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -340.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1239.0,
        125.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -310.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1239.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -286.2167053222656,
      "bbox_min": [
        -310.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1239.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -310.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1239.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1230.0,
      "bbox_min": [
        -310.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1230.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -310.0,
        1210.361328125,
        120.0
      ],
      "bbox_max": [
        -295.0,
        1210.4000244140625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9060451984405518,
        0.4231809079647064,
        0.0
      ],
      "plane_d": -240.40463256835938,
      "bbox_min": [
        -301.4644775390625,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1213.5355224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -295.0,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1210.4000244140625,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -295.0,
        1210.361328125,
        120.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1210.4000244140625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -85.0,
      "bbox_min": [
        -340.0,
        1210.361328125,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1239.0,
        118.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -64.99999237060547,
      "bbox_min": [
        -340.0,
        1235.0,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1239.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -340.0,
        1210.361328125,
        100.0
      ],
      "bbox_max": [
        -310.0,
        1230.0,
        118.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -340.0,
        1210.361328125,
        109.99969482421875
      ],
      "bbox_max": [
        -310.0,
        1210.4000244140625,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.16333900392055511,
        0.9865700006484985
      ],
      "plane_d": 89.17681121826172,
      "bbox_min": [
        -340.0,
        1210.361328125,
        109.99969482421875
      ],
      "bbox_max": [
        -310.0,
        1210.4000244140625,
        110.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        -340.0,
        1210.4000244140625,
        100.0
      ],
      "bbox_max": [
        -310.0,
        1230.0,
        100.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        -406.1922912597656,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        0.16439898312091827
      ],
      "plane_d": 1380.9515380859375,
      "bbox_min": [
        -400.42303466796875,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -50.843994140625,
        1430.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -350.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -350.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -350.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9863938689231873,
        0.0,
        0.16439898312091827
      ],
      "plane_d": -78.91150665283203,
      "bbox_min": [
        -313.88458251953125,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -50.843994140625,
        1420.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -70.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -50.843994140625,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7069986462593079,
        0.7072150111198425
      ],
      "plane_d": -918.4239501953125,
      "bbox_min": [
        -313.88458251953125,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -132.95298767089844,
        1370.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122786998748779,
        0.3534991443157196,
        0.7072150707244873
      ],
      "plane_d": -618.8341674804688,
      "bbox_min": [
        -226.05955505371094,
        1239.0,
        60.00611877441406
      ],
      "bbox_max": [
        -226.0344696044922,
        1239.021728515625,
        60.02783966064453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -61.999996185302734,
      "bbox_min": [
        -313.88458251953125,
        1263.2667236328125,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1142.9825439453125,
      "bbox_min": [
        -310.0,
        1263.2667236328125,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1296.0570068359375,
      "bbox_min": [
        -225.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238791465759277,
        0.3826843202114105,
        0.0
      ],
      "plane_d": -722.5831909179688,
      "bbox_min": [
        -225.0,
        1327.3223876953125,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 306.83758544921875,
      "bbox_min": [
        -225.0,
        1327.3223876953125,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 676.3892211914062,
      "bbox_min": [
        -222.835205078125,
        1327.3223876953125,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1340.2503662109375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1187.175537109375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1367.835205078125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 720.583251953125,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1361.1468505859375,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 351.0315856933594,
      "bbox_min": [
        -183.85305786132812,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1361.1468505859375,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        0.3826843500137329,
        0.0
      ],
      "plane_d": -678.3893432617188,
      "bbox_min": [
        -183.85305786132812,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1345.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -310.0,
        1263.2667236328125,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1296.0570068359375,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238791465759277,
        0.3826843202114105,
        0.0
      ],
      "plane_d": -722.5831909179688,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 306.83758544921875,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 676.3892211914062,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -63.999996185302734,
      "bbox_min": [
        -225.0,
        1320.0,
        62.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1340.2503662109375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -177.164794921875,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1187.175537109375,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -177.164794921875,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 720.583251953125,
      "bbox_min": [
        -222.835205078125,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -177.164794921875,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 351.0315856933594,
      "bbox_min": [
        -183.85305786132812,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -177.164794921875,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        0.3826843500137329,
        0.0
      ],
      "plane_d": -678.3893432617188,
      "bbox_min": [
        -183.85305786132812,
        1328.8531494140625,
        62.0
      ],
      "bbox_max": [
        -177.164794921875,
        1345.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -313.88458251953125,
        1263.2667236328125,
        62.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -64.99999237060547,
      "bbox_min": [
        -313.88458251953125,
        1263.2667236328125,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660251498222351,
        0.5000004768371582,
        0.0
      ],
      "plane_d": -795.2738647460938,
      "bbox_min": [
        -242.59410095214844,
        1210.361328125,
        60.00611877441406
      ],
      "bbox_max": [
        -132.9655303955078,
        1239.0,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.7069986462593079,
        0.7072150111198425
      ],
      "plane_d": -918.4239501953125,
      "bbox_min": [
        -214.5,
        1210.361328125,
        60.02783966064453
      ],
      "bbox_max": [
        -132.9655303955078,
        1239.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -214.5,
        1210.361328125,
        95.0
      ],
      "bbox_max": [
        -139.49990844726562,
        1219.021728515625,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20686259865760803,
        -0.9783700108528137,
        -0.0
      ],
      "plane_d": 1150.6346435546875,
      "bbox_min": [
        -214.5,
        1210.361328125,
        95.0
      ],
      "bbox_max": [
        -139.49993896484375,
        1219.021728515625,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -149.0497283935547,
        1210.361328125,
        270.0
      ],
      "bbox_max": [
        -139.49993896484375,
        1219.021728515625,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5455349087715149,
        -0.8380880951881409,
        0.0
      ],
      "plane_d": 1107.0665283203125,
      "bbox_min": [
        -214.5,
        1210.361328125,
        95.0
      ],
      "bbox_max": [
        -162.16839599609375,
        1219.021728515625,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        -214.5,
        1210.361328125,
        270.0
      ],
      "bbox_max": [
        -205.74085998535156,
        1219.021728515625,
        270.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -169.88290405273438,
        1210.361328125,
        95.0
      ],
      "bbox_max": [
        -162.16839599609375,
        1211.592529296875,
        120.8079833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12700533866882324,
        -0.600679874420166,
        -0.7893372774124146
      ],
      "plane_d": 801.1639404296875,
      "bbox_min": [
        -169.88290405273438,
        1210.361328125,
        120.0
      ],
      "bbox_max": [
        -162.16839599609375,
        1211.592529296875,
        120.8079833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26290374994277954,
        -0.4038907289505005,
        -0.8762156367301941
      ],
      "plane_d": 638.6624755859375,
      "bbox_min": [
        -169.88290405273438,
        1210.361328125,
        120.0
      ],
      "bbox_max": [
        -167.1900177001953,
        1211.592529296875,
        120.8079833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122786998748779,
        0.3534991443157196,
        0.7072150707244873
      ],
      "plane_d": -618.8341674804688,
      "bbox_min": [
        -242.59410095214844,
        1210.361328125,
        60.00611877441406
      ],
      "bbox_max": [
        -202.96554565429688,
        1239.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7069986462593079,
        0.7072150111198425
      ],
      "plane_d": -918.4239501953125,
      "bbox_min": [
        -226.0344696044922,
        1219.021728515625,
        60.02783966064453
      ],
      "bbox_max": [
        -202.96554565429688,
        1239.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        60.0
      ],
      "bbox_max": [
        450.0,
        2540.0,
        640.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        0.3398486375808716,
        0.9404801726341248
      ],
      "plane_d": -465.9464111328125,
      "bbox_min": [
        120.0,
        1038.958984375,
        60.0
      ],
      "bbox_max": [
        190.0,
        1693.45361328125,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 180.0,
      "bbox_min": [
        120.0,
        1038.958984375,
        60.0
      ],
      "bbox_max": [
        190.0,
        1693.45361328125,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        180.0,
        1678.487548828125,
        60.0
      ],
      "bbox_max": [
        190.0,
        1693.45361328125,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        120.0,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        180.0,
        1678.487548828125,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.19509030878543854,
        0.0
      ],
      "plane_d": -174.94122314453125,
      "bbox_min": [
        120.0,
        1490.0,
        60.0
      ],
      "bbox_max": [
        180.0,
        1678.487548828125,
        214.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        120.0,
        1490.0,
        60.0
      ],
      "bbox_max": [
        180.0,
        1678.487548828125,
        214.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -213.99998474121094,
      "bbox_min": [
        120.0,
        1490.0,
        214.0
      ],
      "bbox_max": [
        120.01652526855469,
        1500.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324584484100342,
        -0.6324530243873596,
        0.4472128450870514
      ],
      "plane_d": 861.5960083007812,
      "bbox_min": [
        120.0,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        170.529052734375,
        1313.20751953125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8639490604400635,
        0.23149654269218445,
        -0.4472150504589081
      ],
      "plane_d": -133.34642028808594,
      "bbox_min": [
        120.0,
        1275.0,
        60.0
      ],
      "bbox_max": [
        170.529052734375,
        1313.20751953125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324588060379028,
        0.632449209690094,
        -0.4472179114818573
      ],
      "plane_d": -688.5440063476562,
      "bbox_min": [
        151.7926025390625,
        1294.470947265625,
        60.0
      ],
      "bbox_max": [
        170.529052734375,
        1313.20751953125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324587464332581,
        0.6324533224105835,
        0.44721198081970215
      ],
      "plane_d": -751.1594848632812,
      "bbox_min": [
        156.2755126953125,
        1294.470947265625,
        60.0
      ],
      "bbox_max": [
        170.529052734375,
        1313.20751953125,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        120.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        126.69873046875,
        1300.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324604153633118,
        -0.6324508786201477,
        -0.44721314311027527
      ],
      "plane_d": 924.2034301757812,
      "bbox_min": [
        151.7926025390625,
        1236.79248046875,
        70.0
      ],
      "bbox_max": [
        170.529052734375,
        1255.529052734375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        190.0,
        980.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1830.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        190.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1830.0,
        340.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8314701318740845,
        0.5555695295333862,
        0.0
      ],
      "plane_d": -674.9655151367188,
      "bbox_min": [
        190.0,
        1460.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1830.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9797557592391968,
        0.2001969814300537,
        0.0
      ],
      "plane_d": -75.3988037109375,
      "bbox_min": [
        230.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        450.0,
        1830.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999943971633911,
        0.003364049829542637,
        0.0
      ],
      "plane_d": 225.0872039794922,
      "bbox_min": [
        230.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        450.0,
        1830.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        230.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        450.0,
        1830.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1835126131772995,
        -0.9830173850059509,
        0.0
      ],
      "plane_d": 1637.69970703125,
      "bbox_min": [
        230.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        450.0,
        1830.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        344.3594055175781,
        1730.2786865234375,
        120.0
      ],
      "bbox_max": [
        450.0,
        1830.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.19659994542598724,
        -0.980483889579773,
        0.0
      ],
      "plane_d": 1696.0107421875,
      "bbox_min": [
        397.2405700683594,
        1809.4210205078125,
        120.0
      ],
      "bbox_max": [
        450.0,
        1820.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        397.2405700683594,
        1809.4210205078125,
        140.0
      ],
      "bbox_max": [
        450.0,
        1830.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698934555054,
        0.5555699467658997,
        0.0
      ],
      "plane_d": -645.5426635742188,
      "bbox_min": [
        230.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        377.2901611328125,
        1732.055908203125,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.1950903832912445,
        0.0
      ],
      "plane_d": -37.63140869140625,
      "bbox_min": [
        230.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        377.2901611328125,
        1684.9569091796875,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        252.0435028076172,
        1460.0,
        140.0
      ],
      "bbox_max": [
        377.2901611328125,
        1684.9569091796875,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        252.0435028076172,
        1460.0,
        140.0
      ],
      "bbox_max": [
        260.0,
        1500.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        252.0435028076172,
        1460.0,
        240.0
      ],
      "bbox_max": [
        260.0,
        1500.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        230.0,
        1460.0,
        240.0
      ],
      "bbox_max": [
        260.0,
        1502.9405517578125,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        338.8262939453125,
        1721.997802734375,
        130.0
      ],
      "bbox_max": [
        353.87933349609375,
        1732.055908203125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        190.0,
        1655.5635986328125,
        60.0
      ],
      "bbox_max": [
        405.0116271972656,
        1821.05126953125,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        190.0,
        1655.5635986328125,
        60.0
      ],
      "bbox_max": [
        397.2405700683594,
        1809.4210205078125,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        190.0,
        1693.45361328125,
        60.0
      ],
      "bbox_max": [
        216.65475463867188,
        1733.34521484375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555703639984131,
        -0.8314696550369263,
        0.0
      ],
      "plane_d": 1310.85693359375,
      "bbox_min": [
        190.0,
        1677.60791015625,
        120.0
      ],
      "bbox_max": [
        397.2405700683594,
        1809.4210205078125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        202.13682556152344,
        1711.61767578125,
        120.0
      ],
      "bbox_max": [
        216.65475463867188,
        1733.34521484375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        190.0,
        1677.60791015625,
        120.0
      ],
      "bbox_max": [
        397.2405700683594,
        1809.4210205078125,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5555702447891235,
        -0.8314695954322815,
        0.0
      ],
      "plane_d": 1243.5469970703125,
      "bbox_min": [
        190.0,
        1677.60791015625,
        120.0
      ],
      "bbox_max": [
        397.2405700683594,
        1809.4210205078125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19659994542598724,
        -0.980483889579773,
        0.0
      ],
      "plane_d": 1696.0107421875,
      "bbox_min": [
        190.0,
        1693.45361328125,
        120.0
      ],
      "bbox_max": [
        397.2405700683594,
        1809.4210205078125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        190.0,
        1693.45361328125,
        120.0
      ],
      "bbox_max": [
        202.13682556152344,
        1711.61767578125,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19659994542598724,
        -0.980483889579773,
        0.0
      ],
      "plane_d": 1696.0107421875,
      "bbox_min": [
        190.0,
        1693.45361328125,
        130.0
      ],
      "bbox_max": [
        397.2405700683594,
        1809.4210205078125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314695954322815,
        0.5555702447891235,
        0.0
      ],
      "plane_d": -782.8532104492188,
      "bbox_min": [
        190.0,
        1693.45361328125,
        130.0
      ],
      "bbox_max": [
        202.13682556152344,
        1711.61767578125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        270.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        360.0,
        1460.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        300.0,
        1415.0,
        190.0
      ],
      "bbox_max": [
        360.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        300.0,
        1415.0,
        190.0
      ],
      "bbox_max": [
        300.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        210.0,
        980.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1240.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        -0.0,
        -0.9284767508506775
      ],
      "plane_d": 272.97216796875,
      "bbox_min": [
        210.0,
        1000.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1240.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 225.0,
      "bbox_min": [
        225.0,
        1038.958984375,
        60.0
      ],
      "bbox_max": [
        225.0,
        1205.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        60.0
      ],
      "bbox_max": [
        120.0,
        1513.9443359375,
        230.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        0.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1513.9443359375,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -213.99998474121094,
      "bbox_min": [
        0.0,
        1490.0,
        211.52786254882812
      ],
      "bbox_max": [
        120.0,
        1513.9443359375,
        218.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5218772888183594,
        -0.8530205488204956
      ],
      "plane_d": 970.2698364257812,
      "bbox_min": [
        35.0,
        1509.403564453125,
        211.52786254882812
      ],
      "bbox_max": [
        37.0,
        1513.9443359375,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 35.0,
      "bbox_min": [
        35.0,
        1509.403564453125,
        211.52786254882812
      ],
      "bbox_max": [
        35.0,
        1513.9443359375,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 35.0,
      "bbox_min": [
        35.0,
        1504.5,
        214.0
      ],
      "bbox_max": [
        37.0,
        1511.5380859375,
        218.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5218772888183594,
        -0.8530205488204956
      ],
      "plane_d": 970.2698364257812,
      "bbox_min": [
        35.0,
        1504.5,
        214.0
      ],
      "bbox_max": [
        37.0,
        1509.403564453125,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        10.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        230.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": 796.7407836914062,
      "bbox_min": [
        10.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        10.0,
        1430.0,
        230.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        60.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -693.3753051757812,
      "bbox_min": [
        0.0,
        1250.0,
        80.0
      ],
      "bbox_max": [
        22.5,
        1270.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1170.8092041015625,
      "bbox_min": [
        10.0,
        1265.0,
        80.0
      ],
      "bbox_max": [
        22.5,
        1270.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 144.0,
      "bbox_min": [
        0.0,
        839.9456176757812,
        60.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        110.0,
        1050.0,
        155.0
      ],
      "bbox_max": [
        110.0,
        1240.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        0.0,
        1000.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        144.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1050.0,
        60.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        0.0,
        1050.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3205961585044861,
        0.0,
        0.9472159743309021
      ],
      "plane_d": -69.65679931640625,
      "bbox_min": [
        0.0,
        1050.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -104.0,
      "bbox_min": [
        90.0,
        1210.0,
        104.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1050.0,
        82.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        0.0,
        1050.0,
        126.0
      ],
      "bbox_max": [
        10.0,
        1050.0,
        144.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}